import { AlveolePackages } from '@/__generated__/graphql.js';
import { ContactRole } from '@/__generated__/graphql.js';
import { config } from '@/config/loader.js';

import type { Language } from '../utils/localization.js';

type LocalizedDictionary = {
  [key in MyHiveLocalizationKey | ContactRole | AlveolePackages]: string;
};
type LocalizedStrings = Record<Language, LocalizedDictionary>;

const getMarketingSiteUrl = (language: Language): string => {
  switch (config.envName) {
    case 'prod':
      return `https://www.alveole.buzz/${language === 'fr' ? 'fr/' : ''}`;
    case 'dev':
      return 'https://myhive-dev.alveole.buzz/login';
    case 'local':
      return 'http://localhost:5173/login';
    default:
      return `https://www.alveole.buzz/${language === 'fr' ? 'fr/' : ''}`;
  }
};
export enum MyHiveLocalizationKey {
  Unset = 'unset',
  AMessageFrom = 'aMessageFrom',
  PreHeader = 'preHeader',
  MessageYourAttendees = 'messageYourAttendees',
  MessageAttendees = 'messageAttendees',
  NatureAgentToolTipTitle = 'natureAgentToolTipTitle',
  NatureAgentToolTipDesc = 'natureAgentToolTipDesc',
  WelcomeToMyhive = 'welcomeToMyhive',
  AppTitle = 'appTitle',
  MenuHeading = 'menuHeading',
  FindAHive = 'findAHive',
  HowCanWeHelp = 'howCanWeHelp',
  Website = 'website',
  Blog = 'blog',
  English = 'english',
  French = 'french',
  SignIn = 'signIn',
  SignOut = 'signOut',
  Change = 'change',
  Profile = 'profile',
  HeroTitle = 'heroTitle',
  HeroDescription = 'heroDescription',
  HeroSearch = 'heroSearch',
  HeroHives = 'heroHives',
  HeroBees = 'heroBees',
  HeroCities = 'heroCities',
  HeroPeople = 'heroPeople',
  NoHivesFound = 'noHivesFound',

  NearbyBuzzTitle = 'nearbyBuzzTitle',
  NearbyBuzzDescription = 'nearbyBuzzDescription',
  NearbyBuzzVisit = 'nearbyBuzzVisit',

  WhereWeBuzzTitle = 'whereWeBuzzTitle',
  WhereWeBuzzDescription = 'whereWeBuzzDescription',
  WhereWeBuzzUnitedStates = 'whereWeBuzzUnitedStates',
  WhereWeBuzzVisit = 'whereWeBuzzVisit',

  JoinMovementTitle = 'joinMovementTitle',
  JoinMovementDescription = 'joinMovementDescription',
  JoinMovementButton = 'joinMovementButton',

  FooterCopyright = 'footerCopyright',
  FooterTerms = 'footerTerms',
  FooterPrivacy = 'footerPrivacy',

  Edit = 'edit',
  Save = 'save',
  Cancel = 'cancel',
  Remove = 'remove',

  RemoveBuzzTitle = 'removeBuzzTitle',
  RemoveBuzzDescription = 'removeBuzzDescription',
  CreateABuzz = 'createABuzz',
  CreateABuzzPlaceholder = 'createABuzzPlaceholder',
  CreateABuzzPost = 'createABuzzPost',
  CreateABuzzUploadText = 'createABuzzUploadText',
  CreateABuzzPostToText = 'createABuzzPostToText',
  CreateABuzzPagesText = 'createABuzzPagesText',
  Order = 'order',

  BuzzTimeLine = 'buzzTimeLine',
  Community = 'Community',
  BuzzCharacters = 'characters',

  JoinWaitingList = 'joinWaitingList',

  FollowTheBuzz = 'followTheBuzz',
  FollowTheBuzzDescription = 'followTheBuzzDescription',
  FollowTheBuzzYourEmail = 'followTheBuzzYourEmail',
  FollowTheBuzzSignUp = 'followTheBuzzSignUp',
  FollowTheBuzzThankyou = 'followTheBuzzThankYou',
  ProgramOverview = 'programOverview',
  ProgramOverviewDescription = 'programOverviewDescription',
  ProgramOverviewButton = 'programOverviewButton',
  GetInvolved = 'getInvolved',
  KeepLearning = 'keepLearning',
  KeepLearningDescription = 'keepLearningDescription',
  KeepLearningButton = 'keepLearningButton',
  HaveAquestion = 'haveAQuestion',
  HaveAquestionDescription = 'haveAquestionDescription',
  HaveAquestionButton = 'haveAquestionButton',
  UpcomingEvents = 'upcomingEvents',
  ScheduledVisits = 'scheduledVisits',
  Beekeeper = 'beekeeper',
  AddToCalendar = 'addToCalendar',
  ShowAll = 'showAll',
  ShowLess = 'showLess',
  NoUpcomingVisits = 'noUpcomingVisits',
  NoUpcomingEvents = 'noUpcomingEvents',
  BuzzWeatherCold = 'cold',
  BuzzWeatherHot = 'hot',
  BuzzWeatherRainy = 'rainy',
  BuzzWeatherCloudy = 'cloudy',
  BuzzWeatherSunny = 'sunny',

  GalleryTitle = 'galleryTitle',
  GalleryDescription = 'galleryDescription',
  HoneyLabelTitle = 'honeyLabelTitle',
  HoneyLabelDescription = 'honeyDescription',
  HoneyLabelTabYourLabel = 'honeyLabelTabYourLabel',
  HoneyLabelTabDesignOwn = 'honeyLabelTabDesignOwn',
  HoneyLabelApprove = 'honeyLabelApprove',
  HoneyLabelOr = 'or',
  HoneyLabelCreate = 'honeyLabelCreate',
  HoneyLabelTabFaq = 'honeyLabelTabFaq',
  HoneyLabelNoLabel = 'honeyLabelNoLabel',
  HoneyLabelDesignSubmitted = 'honeyLabelDesignSubmitted',
  HoneyLabelFaqDesignGuideTitle = 'honeyLabelFaqDesignGuideTitle',
  HoneyLabelFaqDesignGuideContent = 'honeyLabelFaqDesignGuideContent',
  HoneyLabelFaqDesignGuideContentTwo = 'honeyLabelFaqDesignGuideContentTwo',
  HoneyLabelFaqDesignLink = 'honeyLabelFaqDesignLink',

  HoneyLabelFaqDimensionsTitle = 'honeyLabelFaqDimensionsTitle',
  HoneyLabelFaqDimensionsList = 'honeyLabelFaqDimensionsList',
  HoneyLabelFaqRequiredInfoTitle = 'honeyLabelFaqRequiredInfoTitle',
  HoneyLabelFaqRequiredInfoList = 'honeyLabelFaqRequiredInfoList',
  HoneyLabelFaqExportingTitle = 'honeyLabelFaqExportingTitle',
  HoneyLabelFaqExportingList = 'honeyLabelFaqExportingList',
  HoneyLabelFaqUploadingTitle = 'honeyLabelFaqUploadingTitle',
  HoneyLabelFaqUploadingList = 'honeyLabelFaqUploadingList',
  HoneyLabelFaqWhyFromScratchTitle = 'honeyLabelFaqWhyFromScratchTitle',
  HoneyLabelFaqWhyFromScratchIntro = 'honeyLabelFaqWhyFromScratchIntro',
  HoneyLabelFaqWhyChangeTitle = 'honeyLabelFaqWhyChangeTitle',
  HoneyLabelFaqWhyChangeContent = 'honeyLabelFaqWhyChangeContent',
  HoneyLabelFaqWhyNotModifyTitle = 'honeyLabelFaqWhyNotModifyTitle',
  HoneyLabelFaqWhyNotModifyContent = 'honeyLabelFaqWhyNotModifyContent',
  HoneyLabelFaqByeByeWaitingTitle = 'honeyLabelFaqByeByeWaitingTitle',
  HoneyLabelFaqByeByeWaitingContent = 'honeyLabelFaqByeByeWaitingContent',
  HoneyLabelFaqMoreOptionsTitle = 'honeyLabelFaqMoreOptionsTitle',
  HoneyLabelFaqMoreOptionsContent = 'honeyLabelFaqMoreOptionsContent',
  HoneyLabelFaqFreshLabelTitle = 'honeyLabelFaqFreshLabelTitle',
  HoneyLabelFaqFreshLabelContent = 'honeyLabelFaqFreshLabelContent',
  HoneyLabelFaqContentChangesTitle = 'honeyLabelFaqContentChangesTitle',
  HoneyLabelFaqContentChangesContent = 'honeyLabelFaqContentChangesContent',
  HoneyLabelGuideTitle = 'honeyLabelGuideTitle',
  HoneyLabelChooseYourDesign = 'honeyLabelChooseYourDesign',
  HoneyLabelGuideRequiredCustomizationTitle = 'honeyLabelGuideRequiredCustomizationTitle',
  HoneyLabelGuideChooseTemplate = 'honeyLabelGuideChooseTemplate',
  HoneyLabelGuideUploadLogo = 'honeyLabelGuideUploadLogo',
  HoneyLabelGuideEnterCity = 'honeyLabelGuideEnterCity',
  HoneyLabelGuideOptionalCustomizationTitle = 'honeyLabelGuideOptionalCustomizationTitle',
  HoneyLabelGuideAddQRCode = 'honeyLabelGuideAddQRCode',
  HoneyLabelGuideCustomizeColors = 'honeyLabelGuideCustomizeColors',
  HoneyLabelGuideAddArtwork = 'honeyLabelGuideAddArtwork',
  HoneyLabelGuideSaveSubmitTitle = 'honeyLabelGuideSaveSubmitTitle',
  HoneyLabelGuideSaveDraft = 'honeyLabelGuideSaveDraft',
  HoneyLabelGuideSubmitDesign = 'honeyLabelGuideSubmitDesign',
  HoneyLabelGuideUploadOwnLabel = 'honeyLabelGuideUploadOwnLabel',
  HoneyLabelWatchATutorial = 'honeyLabelWatchATutorial',
  HoneyLabelDesignToolDown = 'honeyLabelDesignToolDown',
  QueenFormTitle = 'queenFormTitle',
  QueenFormSubtitle = 'queenFormSubtitle',
  QueenFormPlaceholder = 'queenFormPlaceholder',
  QueenFormProfilePrompt = 'queenFormProfilePrompt',
  QueenFormFirstNameLabel = 'queenFormFirstNameLabel',
  QueenFormLastNameLabel = 'queenFormLastNameLabel',
  QueenFormCompanyLabel = 'queenFormCompanyLabel',
  QueenFormFirstNameRequired = 'queenFormFirstNameRequired',
  QueenFormLastNameRequired = 'queenFormLastNameRequired',
  QueenFormCompanyRequired = 'queenFormCompanyRequired',
  QueenFormSubmitting = 'queenFormSubmitting',
  QueenFormSubmit = 'queenFormSubmit',
  QueenFormViewSubmissions = 'queenFormViewSubmissions',
  QueenFormSubmitError = 'queenFormSubmitError',
  QueenFormProfileError = 'queenFormProfileError',
  QueenSignInTitle = 'queenSignInTitle',
  QueenSignInTitleViewSubmissions = 'queenSignInTitleViewSubmissions',
  QueenSignInMessage = 'queenSignInMessage',
  QueenSignInMessageViewSubmissions = 'queenSignInMessageViewSubmissions',
  QueenSubmittedTitle = 'queenSubmittedTitle',
  QueenSubmittedMessage = 'queenSubmittedMessage',
  QueenSubmittedYourSuggestion = 'queenSubmittedYourSuggestion',
  QueenSubmittedViewBoard = 'queenSubmittedViewBoard',
  QueenInviteColleagueButton = 'queenInviteColleagueButton',
  QueenInviteColleagueDescription = 'queenInviteColleagueDescription',
  QueenInviteSending = 'queenInviteSending',
  QueenInviteSent = 'queenInviteSent',
  QueenInviteSendButton = 'queenInviteSendButton',
  QueenInviteError = 'queenInviteError',
  QueenSubmittedStaticMessage = 'queenSubmittedStaticMessage',
  QueenVotingTitle = 'queenVotingTitle',
  QueenVotingSubtitle = 'queenVotingSubtitle',
  QueenNoSubmissionsYet = 'queenNoSubmissionsYet',
  QueenBeFirstToSubmit = 'queenBeFirstToSubmit',
  QueenAdminVotingTitle = 'queenAdminVotingTitle',
  QueenAdminVotingSubtitleVoting = 'queenAdminVotingSubtitleVoting',
  QueenAdminVotingSubtitleNoVoting = 'queenAdminVotingSubtitleNoVoting',
  QueenAdminCrownButton = 'queenAdminCrownButton',
  QueenAdminCrownAriaLabel = 'queenAdminCrownAriaLabel',
  QueenAdminBackToSettings = 'queenAdminBackToSettings',
  QueenConfirmTitle = 'queenConfirmTitle',
  QueenConfirmMessage = 'queenConfirmMessage',
  QueenConfirmSelectedName = 'queenConfirmSelectedName',
  QueenConfirmNominatedBy = 'queenConfirmNominatedBy',
  QueenConfirmVotesSingular = 'queenConfirmVotesSingular',
  QueenConfirmVotesPlural = 'queenConfirmVotesPlural',
  QueenConfirmSubmit = 'queenConfirmSubmit',
  QueenConfirmSubmitting = 'queenConfirmSubmitting',
  QueenConfirmError = 'queenConfirmError',
  QueenConfirmFinalTitle = 'queenConfirmFinalTitle',
  QueenConfirmFinalMessage = 'queenConfirmFinalMessage',
  QueenConfirmFinalSubmit = 'queenConfirmFinalSubmit',
  QueenWinnerTitle = 'queenWinnerTitle',
  QueenWinnerSubtitle = 'queenWinnerSubtitle',
  QueenWinnerNamePrefix = 'queenWinnerNamePrefix',
  QueenWinnerCrownedWithVotesSingular = 'queenWinnerCrownedWithVotesSingular',
  QueenWinnerCrownedWithVotesPlural = 'queenWinnerCrownedWithVotesPlural',
  QueenWinnerCrownedByCommunity = 'queenWinnerCrownedByCommunity',
  QueenAdminHomeTitle = 'queenAdminHomeTitle',
  QueenAdminWinnerChosen = 'queenAdminWinnerChosen',
  QueenAdminWinnerNominatedBy = 'queenAdminWinnerNominatedBy',
  QueenAdminDeadlineMessage = 'queenAdminDeadlineMessage',
  QueenAdminNoDeadlineMessage = 'queenAdminNoDeadlineMessage',
  QueenAdminDeadlineLabel = 'queenAdminDeadlineLabel',
  QueenAdminDeadlineTooltip = 'queenAdminDeadlineTooltip',
  QueenAdminDeadlineSetButton = 'queenAdminDeadlineSetButton',
  QueenAdminDeadlineUpdateButton = 'queenAdminDeadlineUpdateButton',
  QueenAdminDeadlineSaving = 'queenAdminDeadlineSaving',
  QueenAdminDeadlineError = 'queenAdminDeadlineError',
  QueenAdminShareWithTenants = 'queenAdminShareWithTenants',
  QueenAdminShareDeadlineRequired = 'queenAdminShareDeadlineRequired',
  QueenAdminUpdateDeadlineConfirmTitle = 'queenAdminUpdateDeadlineConfirmTitle',
  QueenAdminUpdateDeadlineConfirmMessage = 'queenAdminUpdateDeadlineConfirmMessage',
  QueenAdminSuggestNameLabel = 'queenAdminSuggestNameLabel',
  QueenCountdownClosed = 'queenCountdownClosed',
  QueenCountdownDaysSingular = 'queenCountdownDaysSingular',
  QueenCountdownDaysPlural = 'queenCountdownDaysPlural',
  QueenShareTenantsHeading = 'queenShareTenantsHeading',
  QueenShareTenantsSubheading = 'queenShareTenantsSubheading',
  QueenShareTenantsFallbackSomeone = 'queenShareTenantsFallbackSomeone',
  QueenShareTenantsFallbackHive = 'queenShareTenantsFallbackHive',
  QueenShareTenantsDefaultMessage = 'queenShareTenantsDefaultMessage',
  WorkshopsTitle = 'workshopsTitle',
  WorkshopsButton = 'workshopsButton',
  WorkShopsInfo1Title = 'workShopsInfo1Title',
  WorkShopsInfo1Description = 'workShopsInfo1Description',
  WorkShopsInfo2Title = 'workShopsInfo2Title',
  WorkShopsInfo2Description = 'workShopsInfo2Description',
  RequestWorkshopTitle = 'requestWorkshopTitle',
  RequestWorkshopDescription = 'requestWorkshopDescription',
  RequestWorkshopDescriptionPre = 'requestWorkshopDescriptionPre',
  RequestWorkshopDescriptionLink = 'requestWorkshopDescriptionLink',
  RequestWorkshopDescriptionPost = 'requestWorkshopDescriptionPost',
  RequestWorkshopTypePlaceholder = 'requestWorkshopTypePlaceholder',
  RequestWorkshopDateLabel = 'requestWorkshopDateLabel',
  RequestWorkshopSubmit = 'requestWorkshopSubmit',
  RequestWorkshopSuccess = 'requestWorkshopSuccess',
  DownloadsTitle = 'downloadsTitle',
  DownloadsDescription = 'downloadsDescription',
  DownloadsPartnersTitle = 'downloadsPartnersTitle',
  DownloadsPartnersDescription = 'downloadsPartnersDescription',
  DownloadsWorkshopPromotionTitle = 'downloadsWorkshopPromotionTitle',
  DownloadsWorkshopPromotionDescription = 'downloadsWorkshopPromotionDescription',
  DownloadsSpecialHolidayTitle = 'downloadsSpecialHolidayTitle',
  DownloadsSpecialHolidayDescription = 'downloadsSpecialHolidayDescription',
  DownloadsAveoleMediaKitTitle = 'downloadsAveoleMediaKitTitle',
  DownloadsAveoleMediaKitDescription = 'downloadsAveoleMediaKitDescription',
  DownloadsButton = 'downloadsButton',

  PreferencesTitle = 'preferencesTitle',
  PreferencesTabTeam = 'preferencesTabPreferences',
  PreferencesTabManagement = 'preferencesTabManagement',
  PreferencesHiveName = 'preferencesHiveName',
  PreferencesHiveNameDescription = 'preferencesHiveNameDescription',
  PreferencesHiveDescription = 'preferencesHiveDescription',
  PreferencesHiveDescriptionDescription = 'preferencesHiveDescriptionDescription',
  PreferencesHivePermalink = 'preferencesHivePermalink',
  PreferencesHivePermalinkDescription = 'preferencesHivePermalinkDescription',
  PreferencesHivePermalinkFormatErrorMessage = 'preferencesHivePermalinkFormatErrorMessage',
  PerferencesLanguage = 'preferencesLanguage',
  PreferencesVisibility = 'preferencesVisibility',
  PreferencesQRCode = 'preferencesQRCode',
  PreferencesQRCodeDescription = 'preferencesQRCodeDescription',
  PreferencesLogoUploadTitle = 'preferencesLogoUploadTitle',
  PreferencesLogoUploadDescription = 'preferencesLogoUploadDescription',
  PreferencesLogoUploadChooseFile = 'preferencesLogoUploadChooseFile',
  PreferencesLogoUploadError = 'preferencesLogoUploadError',
  PreferencesManagementDescription = 'preferencesManagementDescription',
  PreferencesResendInvitation = 'preferencesResendInvitation',
  PreferencesRemoveUser = 'preferencesRemoveUser',
  PreferencesVisitReminder = 'preferencesVisitReminder',
  PreferencesBuzzReminder = 'preferencesBuzzReminder',
  PreferencesSubscriberAlerts = 'preferencesSubscriberAlerts',
  PreferencesVisible = 'preferencesVisible',
  PreferencesUnlisted = 'preferencesUnlisted',
  PreferencesMainContact = 'preferencesMainContact',
  PreferencesHiveContact = 'preferencesHiveContact',
  PreferencesAdditionalContacts = 'preferencesAdditionalContacts',
  PreferencesMainContactDescription = 'preferencesMainContactDescription',
  PreferencesHiveContactDescription = 'preferencesHiveContactDescription',
  SMSDeliveredHere = 'smsDeliveredHere',
  PreferencesEditMainContactHint = 'preferencesEditMainContactHint',
  PreferencesAdditionalContactsDescription = 'preferencesAdditionalContactsDescription',
  PreferencesEnableEventInterestList = 'preferencesEnableEventInterestList',
  PreferencesEnableHoneyInterestList = 'preferencesEnableHoneyInterestList',
  PreferencesEnableAiSupportAgent = 'preferencesEnableAiSupportAgent',
  PreferencesShowUpcomingEvents = 'preferencesShowUpcomingEvents',
  PreferencesShowUpcomingVisits = 'preferencesShowUpcomingVisits',
  PreferencesEnableQueenFeature = 'preferencesEnableQueenFeature',
  PreferencesEnableQueenCommunityVoting = 'preferencesEnableQueenCommunityVoting',
  PreferencesSavedSucessHeader = 'preferencesSavedSuccessHeader',

  EmailAddress = 'emailAddress',
  FirstName = 'firstName',
  LastName = 'lastName',
  Phone = 'phone',
  MobilePhone = 'mobilePhone',
  Role = 'role',

  AddUser = 'addUser',
  PleaseEnterAValidEmail = 'pleaseEnterAValidEmail',

  ThisFieldIsRequired = 'thisFieldIsRequired',
  ApiError = 'apiError',
  SlugUnavailable = 'slugUnavailable',
  Subscribe = 'subscribe',
  Subscriber = 'subscriber',
  Subscribers = 'subscribers',
  FaqLink = 'faqLink',
  FullName = 'FullName',
  OrgName = 'OrgName',
  JoinList = 'JoinList',
  JoinWaitingListTitle = 'JoinWaitingListTitle',
  JoinWaitingListDescription = 'JoinWaitingListDescription',
  GuestsInterested = 'GuestsInterested',
  InterestedInEvents = 'InterestedInEvents',
  EveryAlveoleProgram = 'EveryAlveoleProgram',
  ConnectWithUrbanBio = 'ConnectWithUrbanBio',
  BookAnEvent = 'BookAnEvent',
  Export = 'Export',
  ExportFilteredList = 'ExportFilteredList',
  PeopleFollowingThisPage = 'PeopleFollowingThisPage',
  FilterAll = 'FilterAll',
  FollowNewPosts = 'FollowNewPosts',
  FollowEvents = 'FollowEvents',
  InterestedInHoneyTab = 'InterestedInHoneyTab',
  InviteMoreTenants = 'InviteMoreTenants',
  NoSubscribersYet = 'NoSubscribersYet',
  NoSubscribersMatchFilter = 'NoSubscribersMatchFilter',
  InterestedUsers = 'InterestedUsers',
  PeopleMarkedAsInterested = 'PeopleMarkedAsInterested',
  ViewList = 'ViewList',
  StayUpdated = 'StayUpdated',
  MoreUpcomingEvents = 'MoreUpcomingEvents',
  GetHandsOn = 'GetHandsOn',
  InterstedInEvents = 'InterstedInEvents',
  InterestedInHoney = 'InterestedInHoney',
  GetOnTheHoneyList = 'GetOnTheHoneyList',
  HoneyFromHive = 'HoneyFromHive',
  AddMeToTheList = 'AddMeToTheList',
  HarvestBegins = 'HarvestBegins',
  DeliveredBy = 'DeliveredBy',
  Delivery = 'delivery',
  ComingSoon = 'comingSoon',
  HoneyInterestJoined = 'HoneyInterestJoined',
  ThanksWellNotify = 'ThanksWellNotify',
  WaitingListJoined = 'WaitingListJoined',
  ReferWorkBestie = 'ReferWorkBestie',
  WorkBestieHoney = 'WorkBestieHoney',
  ShareThisLink = 'ShareThisLink',
  CopyLink = 'CopyLink',
  CopyEmail = 'CopyEmail',
  ThanksWaitingList = 'ThanksWaitingList',
  WorkBestieEvents = 'WorkBestieEvents',
  Copied = 'Copied',
  PersonMarkedAsInterested = 'PersonMarkedAsInterested',

  MissingFieldsAlertHeader = 'missingFieldsAlertHeader',
  MissingFieldsAlertDescription = 'missingFieldsAlertDescription',
  NeedSupport = 'needSupport',
  HighlightedEventLabel = 'highlightedEventLabel',
  ReadMore = 'readMore',
  EnjoyWorkshops = 'EnjoyWorkshops',
  WatchForNextEvent = 'WatchForNextEvent',

  EventListSubscriberCountLabel = 'eventListSubscriberCountLabel',
  HoneyListSubscriberCountLabel = 'honeyListSubscriberCountLabel',

  PageSubscribeModalHeader = 'pageSubscribeModalHeader',
  PageSubscribeModalText = 'pageSubscribeModalText',

  SubscribeSucess = 'subscribeSuccess',
  ThanksSubscribe = 'thanksSubscribe',
  WorkBestieSubscribe = 'workBestieSubscribe',

  MarketingSiteUrl = 'marketingSiteUrl',
  Share = 'share',
  Send = 'send',
  WithTenants = 'withTenants',
  BoostEngagementShare = 'boostEngagementShare',
  InviteYourTenantsToRegister = 'inviteYourTenantsToRegister',
  EmailAddresses = 'emailAddresses',
  EmailAddressesHint = 'emailAddressesHint',
  CustomMessage = 'customMessage',
  CustomMessageRequired = 'customMessageRequired',
  CustomMessageText = 'customMessageText',
  PreviewSend = 'previewSend',
  PreviewFrom = 'previewFrom',
  PreviewTo = 'previewTo',
  PreviewSubject = 'previewSubject',
  PreviewClickToExplore = 'previewClickToExplore',
  PreviewSubjectText = 'previewSubjectText',
  PreviewSubjectTextEvent = 'previewSubjectTextEvent',
  BackToEdit = 'backToEdit',
  EmailAddressesPlaceholder = 'emailAddressesPlaceholder',
  CustomMessageHint = 'customMessageHint',
  CustomMessageAttendeesHint = 'customMessageAttendeesHint',
  More = 'more',
  Close = 'close',
  BodyEmail = 'bodyEmail',
  AddFromCsv = 'addFromCsv',
  ShareSuccess1 = 'shareSuccess1',
  ShareSuccess2 = 'shareSuccess2',
  EmailPreview = 'emailPreview',

  Register = 'register',
  RegisterAlmostThere = 'registerAlmostThere',
  RegisterSuccess = 'registerSuccess',
  Registered = 'registered',
  Attended = 'attended',
  RegisteredCountLabel = 'registeredCountLabel',

  InviteColleague = 'inviteColleague',
  SendInvite = 'sendInvite',
  Sending = 'sending',

  Warning = 'warning',
  CancelRegistration = 'cancelRegistration',
  WarningRegistrationCancel = 'warningRegistrationCancel',
  Cancelling = 'cancelling',

  SeatsLeft = 'seatsLeft',
  AtCapacity = 'atCapacity',

  EventRegistration = 'eventRegistration',

  //---------ERROR MESSAGES START--------//

  FirstNameRequired = 'firstNameRequired',
  LastNameRequired = 'lastNameRequired',
  OrgNameRequired = 'orgNameRequired',

  SomethingWentWrong = 'somethingWentWrong',

  //profile error msgs
  FailedToUpdateProfile = 'failedToUpdateProfile',

  //events error msgs
  FailedToRegisterForEvent = 'failedToRegisterForEvent',
  FailedToUnregisterEvent = 'failedToUnregisterForEvent',

  //-----------ERROR MESSAGES END-----------//

  //Event Registration info
  EffortlessRegistration = 'effortlessRegistration',
  HowItWorks = 'howItWorks',
  EasyRegistrationSectionHeader = 'easyRegistrationSectionHeader',
  EasyRegistrationSectionText = 'easyRegistrationSectionText',
  InviteSubscribersSectionHeader = 'inviteSubscribersSectionHeader',
  InviteSubscribersSectionText = 'inviteSubscribersSectionText',
  AutomaticRemindersSectionHeader = 'automaticRemindersSectionHeader',
  AutomaticRemindersSectionText = 'automaticRemindersSectionText',
  RealTimeTrackingSectionHeader = 'realTimeTrackingSectionHeader',
  RealTimeTrackingSectionText = 'realTimeTrackingSectionText',
  PromoteWorkshopCta = 'promoteWorkshopCta',
  ShareMyHivePageHeader = 'shareMyHivePageHeader',
  ShareMyHivePageText = 'shareMyHivePageText',
  PromoKitTemplatesHeader = 'promoKitTemplatesHeader',
  PromoKitTemplatesText = 'promoKitTemplatesText',
  QrCodeHeader = 'qrCodeHeader',
  QrCodeText = 'qrCodeText',
  RegistrationDefaultNote = 'registrationDefaultNote',

  Settings = 'settings',
  NatureAgent = 'natureAgent',

  Integrations = 'integrations',
  TenantApps = 'tenantApps',
  DigitalScreensAndSignage = 'digitalScreensAndSignage',

  TenantAppsHeader = 'tenantAppsHeader',
  TenantAppsDropdownHeader = 'tenantAppsDropdownHeader',
  TenantAppsYoullNeedHeader = 'tenantAppsYoullNeedHeader',
  TenantAppsRequirementUrl = 'tenantAppsRequirementUrl',
  TenantAppsRequirementImage = 'tenantAppsRequirementImage',
  TenantAppsRequirementNameDesc = 'tenantAppsRequirementNameDesc',
  TenantAppsWebviewHowToHeader = 'tenantAppsWebviewHowToHeader',
  TenantAppsWebviewWhatIs = 'tenantAppsWebviewWhatIs',
  TenantAppsStepLogin = 'tenantAppsStepLogin',
  TenantAppsStepUploadImage = 'tenantAppsStepUploadImage',
  TenantAppsStepPasteUrl = 'tenantAppsStepPasteUrl',
  TenantAppsStepAddNameDesc = 'tenantAppsStepAddNameDesc',
  TenantAppsStepSavePublish = 'tenantAppsStepSavePublish',
  TenantAppsNote = 'tenantAppsNote',
  IntegrationKit = 'integrationKit',
  TenantAppsUrlLabel = 'tenantAppsUrlLabel',
  TenantAppsUrlHelp = 'tenantAppsUrlHelp',
  TenantAppsSuggestedDescHeader = 'tenantAppsSuggestedDescHeader',
  TenantAppsSuggestedDescHelp = 'tenantAppsSuggestedDescHelp',
  TenantAppsSuggestedDescExample = 'tenantAppsSuggestedDescExample',

  TenantAppsWidgetsHeader = 'tenantAppsWidgetsHeader',
  TenantAppsWidgetsDesc = 'tenantAppsWidgetsDesc',

  Hey = 'hey',
  Imyour = 'imyour',
  HereToHelp = 'hereToHelp',
  Heresafew = 'heresAFew',
  Curious = 'curious',
  JustAsk = 'justAsk',
  ChatWithMe = 'chatWithMe',
  BuiltToGuide = 'builtToGuide',
  ITurnComplexFrameworks = 'iTurnComplexFrameworks',
  WeGrowBetterTogether = 'weGrowBetterTogether',
  EveryConversationHelpsMeLearn = 'everyConversationHelpsMeLearn',
  Whatsyourrole = 'whatsyourrole',
  Egassetmanager = 'egassetmanager',
  Howareyouplanning = 'howareyouplanning',
  Sustainabilityreporting = 'sustainabilityreporting',
  Hivehealthandbiodiversity = 'hivehealthandbiodiversity',
  Tenantandcommunityengagement = 'tenantandcommunityengagement',
  Frameworksandcertifications = 'frameworksandcertifications',
  Sitelevelinsights = 'sitelevelinsights',
  Portfoliooverview = 'portfoliooverview',
  Natureagentschoice = 'natureagentschoice',
  Continue = 'continue',
  Whichareyouinterestedin = 'whichareyouinterestedin',
  Frameworks = 'frameworks',
  Greencertifications = 'greencertifications',
  Leedleadershipinenergy = 'leedleadershipinenergy',
  Wellbuildingstandard = 'wellbuildingstandard',
  Fitwelhealth = 'fitwelhealth',
  Gresbbenchmarkinges = 'gresbbenchmarkinges',
  Tnfdtaskforceon = 'tnfdtaskforceon',
  Csrdcorporatesustainability = 'csrdcorporatesustainability',
  Breeaminuse = 'breeaminuse',
  BNG = 'bng',
  Doyouprefer = 'doyouprefer',
  Sitelevel = 'sitelevel',
  Portfoliolevel = 'portfoliolevel',
  Completeonboarding = 'completeonboarding',
  Iunderstand = 'iunderstand',
  Back = 'back',
  Skip = 'skip',
  ExploreUnderstand = 'exploreUnderstand',
  ActConfidently = 'actConfidently',

  ChangePassoword = 'changePassword',

  WeWillSendToEmail = 'weWillSendToEmail',
  SendToEmail = 'sendToEmail',

  TaglineDescription = 'taglineDescription',
  Tagline = 'tagline',

  BeekeeperBio = 'beekeeperBio',
  BeekeeperBioDescription = 'beekeeperBioDescription',

  ProfileIntro = 'profileIntro',
  ProfilePhoto = 'profilePhoto',

  Saving = 'saving',

  Discover = 'discover',
  Reports = 'reports',
  Property = 'property',
  Dashboard = 'dashboard',
  AllAssets = 'allAssets',
  AssetAnalytics = 'assetAnalytics',
  NatureData = 'natureData',
  ReportsAtYourFingertips = 'reportsAtYourFingertips',
  ExploreYourData = 'exploreYourData',
  PortfolioInsights = 'portfolioInsights',
  Properties = 'properties',
  AssetLevelResults = 'assetLevelResults',
  SearchForAnAsset = 'searchForAnAsset',
  AvailableReports = 'availableReports',

  AskNature = 'askNature',
  SearchYourAssets = 'searchYourAssets',
  Certifications = 'certifications',
  NoResultsMatching = 'noResultsMatching',
  SearchYourReportTypes = 'searchYourReportTypes',

  ShareOnLinkedin = 'shareOnLinkedin',
  YearEndHeader = 'yearEndHeader',

  Caption = 'caption',
  CaptionHint = 'captionHint',

  RequestedReport = 'requestedReport',
  YouWillReceiveEmail = 'youWillReceiveEmail',

  Loading = 'loading',

  ChatBotWelcomeMessage = 'chatBotWelcomeMessage',
  ChatBotDisclaimerMessage = 'chatBotDisclaimerMessage',
  ChatBotInputPlaceholder = 'chatBotInputPlaceholder',

  NoMatchesFor = 'noMatchesFor',
  OnRequest = 'onRequest',
  StartTypingToSearch = 'startTypingToSearch',

  Conversations = 'conversations',
  NewConversation = 'newConversation',

  ReportsSmartReportsTitle = 'reportsSmartReportsTitle',
  ReportsRequestButton = 'reportsRequestButton',
  ReportsLoadingTitle = 'reportsLoadingTitle',
  ReportsLoadingSubtitle = 'reportsLoadingSubtitle',

  ReportsPortfolioPlaceholder = 'reportsPortfolioPlaceholder',

  ReportsPreviouslyGeneratedReportsTitle = 'reportsPreviouslyGeneratedReportsTitle',

  ReportsPortfolioOptionTitle = 'reportsPortfolioOptionTitle',
  ReportsPortfolioOptionDesc = 'reportsPortfolioOptionDesc',

  PaginationShowing = 'reportsPaginationShowing',
  PaginationTo = 'reportsPaginationTo',
  PaginationOf = 'reportsPaginationOf',
  PaginationResults = 'reportsPaginationResults',

  PaginationFirstPage = 'reportsPaginationFirstPage',
  PaginationPreviousPage = 'reportsPaginationPreviousPage',
  PaginationNextPage = 'reportsPaginationNextPage',
  PaginationLastPage = 'reportsPaginationLastPage',

  Request = 'request',

  ReportsTableNoReports = 'ReportsTableNoReports',

  Report = 'report',
  Asset = 'asset',

  Date = 'date',

  PortfolioAllSites = 'portfolioAllSites',
  PortfolioAllSitesDescription = 'portfolioAllSitesDescription',

  Download = 'download',
  DownloadList = 'downloadList',
  RequestReportErrorGenerating = 'requestReportErrorGenerating',
  Generating = 'generating',
  RequestReportGenerating = 'requestReportGenerating',
  RequestReportGenerated = 'requestReportGenerated',
  RequestReportDownloadAria = 'requestReportDownloadAria',

  SubmitRequest = 'submitRequest',
  Submit = 'submit',

  Format = 'format',

  Language = 'language',

  GeneratingReportLine = 'generatingReportLine',

  UpdateContactSettings = 'updateContactSettings',
  UnreachableEmailsDescription = 'unreachableEmailsDescription',
  UnreachableEmailsCountPlural = 'unreachableEmailsCountPlural',
  UnreachableEmailsCountSingular = 'unreachableEmailsCountSingular',
  EmailIsUnreachable = 'emailIsUnreachable',

  TakeMeToSettings = 'takeMeToSettings',

  InvalidPhoneNumber = 'invalidPhoneNumber',
  InvalidEmail = 'invalidEmail',
  UnknownPhoneNumberStatus = 'unknownPhoneNumberStatus',

  //portfolio dashboard
  InstallationComingUpText = 'installationCominUpText',
  BeekeepingComingUpText = 'beekeepingComingUpText',
  HoneyJarsComingUpText = 'honeyJarsComingUpText',
  HoneyHarvestComingUpText = 'honeyHarvestComingUpText',

  HTHJEventComingUp = 'hthjEventComingUp',
  MeetYourBeesEventComingUp = 'meetYourBeesEventComingUp',
  MeetYourBeekeeperEventComingUp = 'meetYourBeekeeperEventComingUp',
  WondersOfWaxEventComingUp = 'wondersOfWaxEventComingUp',
  HoneyTastingEventComingUp = 'honeyTastingEventComingUp',
  ExploreBeesEventComingUp = 'exploreBeesEventComingUp',
  ExploreWildEventComingUp = 'exploreWildEventComingUp',
  KioskEventComingUp = 'kioskEventComingUp',
  EventComingUp = 'eventComingUp',

  BeekeepingNewsText = 'beekeepingNewsText',
  InstallationNewsText = 'installationNewsText',
  HoneyHarvestNewsText = 'honeyHarvestNewsText',
  HoneyJarsNewsText = 'honeyJarsNewsText',
  EventNewsText = 'eventNewsText',

  BeekeepingNewsBadgeText = 'beekeepingNewsBadgeText',
  InstallationNewsBadgeText = 'installationNewsBadgeText',
  HoneyHarvestNewsBadgeText = 'honeyHarvestNewsBadgeText',
  HoneyJarsNewsBadgeText = 'honeyJarsNewsBadgeText',
  EventNewsBadgeText = 'eventNewsBadgeText',

  DesignRequiredLabelStatus = 'designRequiredLabelStatus',
  NeedsApprovalLabelStatus = 'needsApprovalLabelStatus',
  InProgressLabelStatus = 'inProgressLabelStatus',
  SubmittedLabelStatus = 'submittedLabelStatus',

  DesignRequiredTooltipText = 'designRequiredTooltipText',
  NeedsApprovalTooltipText = 'needsApprovalTooltipText',
  InProgressTooltipText = 'inProgressTooltipText',
  SubmittedTooltipText = 'submittedTooltipText',

  PhotoGallery = 'photoGallery',
  PhotoGallerySubtitle = 'photoGallerySubtitle',

  PortfolioNewsfeed = 'portfolioNewsfeed',
  PortfolioNewsfeedSubtitle = 'portfolioNewsfeedSubtitle',
  ComingUp = 'comingUp',
  Region = 'region',
  MainContact = 'mainContact',
  Package = 'package',
  Events = 'events',
  EventCredits = 'eventCredits',
  Label = 'label',
  NextVisit = 'nextVisit',
  HoneyLabel = 'honeyLabel',

  TenantSubscribers = 'tenantSubscribers',

  PropertiesInPortfolio = 'propertiesInPortfolio',

  CustomizeColumns = 'customizeColumns',

  InviteTenants = 'inviteTenants',
  CreditsLeft = 'creditsLeft',

  UpcomingVisits = 'upcomingVisits',

  YearInReview = 'yearInReview',
  BiodiversityReport = 'biodiversityReport',
  NoReports = 'noReports',

  Updated = 'updated',
  TotalAssets = 'totalAssets',
  PesticidesReport = 'pesticidesReport',
  Growth = 'growth',

  AreaPollinated = 'areaPollinated',

  YourNextEventIsWaiting = 'yourNextEventIsWaiting',
  AllWorkshopCreditsUsed = 'AllWorkshopCreditsUsed',

  EventsBooked = 'eventsBooked',

  Invite = 'invite',

  PostPhotos = 'postPhotos',
  PostVideos = 'postVideos',

  LinkedInChooseHeader = 'linkedInChooseHeader',
  LinkedInChooseDescription = 'linkedInChooseDescription',

  //onboarding modal:
  LivingBusiness = 'livingBusniess',
  ConnectNatureTenants = 'connectNatureTenants',

  ControlCenter = 'controlCenter',
  AllInOnePlace = 'allInOnePlace',

  TenantsToPage = 'tenantsToPage',
  ToDoTenantStuff = 'ToDoTenantStuff',

  HostEvents = 'hostEvents',
  EasilyBook = 'easilyBook',

  //onboarding flows
  GetFamiliar = 'getFamiliar',
  GetFamiliarTitleOne = 'getFamiliarTitleOne',
  GetFamiliarTextOne = 'getFamiliarTextOne',

  GetFamiliarTitleTwo = 'getFamiliarTitleTwo',
  GetFamiliarTextTwo = 'getFamiliarTextTwo',

  GetFamiliarTitleThree = 'getFamiliarTitleThree',
  GetFamiliarTextThree = 'getFamiliarTextThree',

  LetsGrow = 'letsGrow',
  LetsGrowTitleOne = 'letsGrowTitleOne',
  LetsGrowTextOne = 'letsGrowTextOne',

  LetsGrowTitleTwo = 'letsGrowTitleTwo',
  LetsGrowTextTwo = 'letsGrowTextTwo',

  LetsGrowTitleThree = 'letsGrowTitleThree',
  LetsGrowextThree = 'letsGrowextThree',

  LetsGrowTitleFour = 'letsGrowTitleFour',
  LetsGrowextFour = 'letsGrowextFour',

  InviteTenantsNow = 'inviteTenantsNow',
  BookEventNow = 'bookEventNow',

  Next = 'next',
  Finish = 'finish',
  MakeItYourOwn = 'makeItYourOwn',
  MaximizeImpact = 'maximizeImpact',
  StartHere = 'startHere',
  LearnHowToGrow = 'learnHowToGrow',

  InviteYourTenants = 'inviteYourTenants',
  ShareYourPage = 'shareYourPage',

  InviteYourTenantsToRegisterEvent = 'inviteYourTenantsToRegisterEvent',
  ShareYourEventWithYourTenantNetwork = 'shareYourEventWithYourTenantNetwork',
  GetNotifiedForEveryNewSignup = 'getNotifiedForEveryNewSignup',
  CustomizeYourMessageEvent = 'customizeYourMessageEvent',

  PersonalizeTitle = 'personalizeTitle',
  PersonalizeText = 'personalizeText',

  BookAlveoleEvent = 'bookAlveoleEvent',
  HostedByBeekeeper = 'hostedByBeekeeper',

  EventsLeft = 'eventsLeft',
  EventLeft = 'eventLeft',

  HoneyLabelDontWorry = 'honeyLabelDontWorry',
  HoneyLabelError = 'honeyLabelError',

  ChangeImage = 'changeImage',

  ShareSoCanRegister = 'shareSoCanRegister',

  AlveoleEvent = 'alveoleEvent',

  CheckOutPage = 'checkOutPage',

  RegisterForEvent = 'registerForEvent',

  Company = 'company',

  AllSet = 'allSet',

  ScanList = 'scanList',
  Scanning = 'scanning',
  Scan = 'scan',
  AddMore = 'addMore',
  LoginToScanSubscriberLists = 'loginToScanSubscriberLists',

  KioskUnavailable = 'kioskUnavailable',
  KioskInvalid = 'kioskInvalid',

  SelectedFile = 'selectedFile',
  ReviewScannedContacts = 'reviewScannedContacts',

  AddRow = 'addRow',

  FailedToSubmitList = 'failedToSubmitList',
  ContactListSubmitted = 'ContactListSubmitted',

  DefaulthiveDesc = 'defaulthiveDesc',

  OpenLiveReg = 'openLiveReg',

  EventRegistrants = 'eventRegistrants',

  RegisteredForEvent = 'registeredForEvent',

  HoneyLabelPopupTitle = 'honeyLabelPopupTitle',
  HoneyLabelPopupDescription = 'honeyLabelPopupDescription',
  EditDesign = 'editDesign',

  Approve = 'approve',

  InviteColleagueTitle = 'inviteColleagueTitle',
  InviteColleagueDescription = 'inviteColleagueDescription',
  InviteColleagueButton = 'inviteColleagueButton',
  InviteColleagueSuccess = 'inviteColleagueSuccess',

  HoneyLabelPopupCreateTitle = 'honeyLabelPopupCreateTitle',
  HoneyLabelPopupCreateDescription = 'honeyLabelPopupCreateDescription',
  GetStarted = 'getStarted',
  ReachEveryoneRegistered = 'reachEveryoneRegistered',
  YourMessageLands = 'yourMessageLands',
  ShareYourLogoHere = 'shareYourLogoHere',
  UploadYourLogoAnd = 'uploadYourLogoAnd',
  Attendees = 'attendees',

  CelebrateSubscribersTitle = 'celebrateSubscribersTitle',
  CelebrateSubscribersDescription = 'celebrateSubscribersDescription',

  CreditsRemainingSingular = 'creditsRemainingSingular',
  CreditsRemainingPlural = 'creditsRemainingPlural',
  EventCreditsUsedTagline = 'eventCreditsUsedTagline',
  AdditionalBookingsFeeNote = 'additionalBookingsFeeNote',
  CreditsUsedBannerTitleStrong = 'creditsUsedBannerTitleStrong',
  CreditsUsedBannerBodyPre = 'creditsUsedBannerBodyPre',
  CreditsUsedBannerBodyLink = 'creditsUsedBannerBodyLink',
  CreditsUsedBannerBodyPost = 'creditsUsedBannerBodyPost',

  Main = 'main',
  Site = 'site',

  TeamRemoveContactTitle = 'teamRemoveContactTitle',
  TeamRemoveContactMessage = 'teamRemoveContactMessage',
  TeamDiscardChangesTitle = 'teamDiscardChangesTitle',
  TeamDiscardChangesMessage = 'teamDiscardChangesMessage',
  TeamDiscard = 'teamDiscard',
  TeamConfirm = 'teamConfirm',
  TeamResendInviteEmailTitle = 'teamResendInviteEmailTitle',
  TeamResendInviteEmailMessage = 'teamResendInviteEmailMessage',
  TeamColumnContact = 'teamColumnContact',
  TeamColumnRole = 'teamColumnRole',
  TeamColumnPhone = 'teamColumnPhone',
  TeamColumnVisitReminders = 'teamColumnVisitReminders',
  TeamColumnEmailPreferences = 'teamColumnEmailPreferences',
  TeamColumnActions = 'teamColumnActions',
  TeamTitle = 'teamTitle',
  TeamAddContact = 'teamAddContact',
  TeamMembersCount = 'teamMembersCount',
  TeamNoUsersFound = 'teamNoUsersFound',
  TeamSendInviteEmail = 'teamSendInviteEmail',
  TeamInviteEmailSent = 'teamInviteEmailSent',
  TeamInviteEmailSentTooltip = 'teamInviteEmailSentTooltip',
  TeamDelete = 'teamDelete',
  TeamReassignBeforeRemoving = 'teamReassignBeforeRemoving',
  TeamRemoveContact = 'teamRemoveContact',
  TeamVisitReminders = 'teamVisitReminders',
  TeamEmailLabel = 'teamEmailLabel',
  TeamSmsLabel = 'teamSmsLabel',
  TeamSmsDisabledTooltip = 'teamSmsDisabledTooltip',
  TeamSmsEnabledTooltip = 'teamSmsEnabledTooltip',
  TeamVisitReminderEmailTooltip = 'teamVisitReminderEmailTooltip',
  TeamMobileLabel = 'teamMobileLabel',
  TeamOfficeLabel = 'teamOfficeLabel',
  TeamPhoneLabel = 'teamPhoneLabel',
  TeamEmailFieldLabel = 'teamEmailFieldLabel',
  TeamLastSeenAgo = 'teamLastSeenAgo',
  TeamPreferencesLabel = 'teamPreferencesLabel',
  TeamContactTypeLabel = 'teamContactTypeLabel',
  TeamEmailsLabel = 'teamEmailsLabel',
  TeamNoneOption = 'teamNoneOption',
  TeamNoEmails = 'teamNoEmails',
  TeamAllEmails = 'teamAllEmails',
  TeamEmailPrefCount = 'teamEmailPrefCount',
  TeamRoleTeam = 'teamRoleTeam',
  TeamStatusUnknown = 'teamStatusUnknown',
  TeamStatusDelivering = 'teamStatusDelivering',
  TeamStatusNonSms = 'teamStatusNonSms',
  TeamStatusInvalid = 'teamStatusInvalid',
  TeamStatusOptedOut = 'teamStatusOptedOut',
  TeamEmailUnreachableBadge = 'teamEmailUnreachableBadge',
  TeamEmailUnreachableTooltip = 'teamEmailUnreachableTooltip',
  TeamLastCarrierResponseTooltip = 'teamLastCarrierResponseTooltip',
  TeamContactTypeMainOption = 'teamContactTypeMainOption',
  TeamContactTypeHiveOption = 'teamContactTypeHiveOption',
  TeamContactTypeRemoveHint = 'teamContactTypeRemoveHint',
  TeamCreateNewUserTitle = 'teamCreateNewUserTitle',
  TeamCreateNewUserDescription = 'teamCreateNewUserDescription',
  TeamCreateUser = 'teamCreateUser',
  TeamCreatingUser = 'teamCreatingUser',
  TeamFirstNamePlaceholder = 'teamFirstNamePlaceholder',
  TeamLastNamePlaceholder = 'teamLastNamePlaceholder',
  TeamEmailPlaceholder = 'teamEmailPlaceholder',
  UnsubscribeGenericError = 'unsubscribeGenericError',
  UnsubscribeTitle = 'unsubscribeTitle',
  UnsubscribeSubtitle = 'unsubscribeSubtitle',
  UnsubscribeEmail = 'unsubscribeEmail',
  UnsubscribePage = 'unsubscribePage',
  UnsubscribeManagePrompt = 'unsubscribeManagePrompt',
  UnsubscribeSignIn = 'unsubscribeSignIn',
  UnsubscribeNotifications = 'unsubscribeNotifications',
  UnsubscribeVisitReminders = 'unsubscribeVisitReminders',
  UnsubscribeVisitRemindersLockedDescription = 'unsubscribeVisitRemindersLockedDescription',
  UnsubscribeVisitRemindersDescription = 'unsubscribeVisitRemindersDescription',
  UnsubscribeSubscriberAlerts = 'unsubscribeSubscriberAlerts',
  UnsubscribeSubscriberAlertsDescription = 'unsubscribeSubscriberAlertsDescription',
  UnsubscribeNewPosts = 'unsubscribeNewPosts',
  UnsubscribeNewPostsDescription = 'unsubscribeNewPostsDescription',
  UnsubscribeEventWaitingList = 'unsubscribeEventWaitingList',
  UnsubscribeEventWaitingListDescription = 'unsubscribeEventWaitingListDescription',
  SmsOptInBlockedTitle = 'smsOptInBlockedTitle',
  SmsOptInBlockedMessage = 'smsOptInBlockedMessage',
  Ok = 'ok',
  UnsubscribeMainContact = 'unsubscribeMainContact',
  UnsubscribeHiveContact = 'unsubscribeHiveContact',
  UnsubscribeManagerLockedDescription = 'unsubscribeManagerLockedDescription',
  UnsubscribeUpdateError = 'unsubscribeUpdateError',
  UnsubscribeCancel = 'unsubscribeCancel',
  UnsubscribeSave = 'unsubscribeSave',

  // Hive strength tile
  HiveStrengthInsideTheHive = 'hiveStrengthInsideTheHive',
  HiveStrengthHeading = 'hiveStrengthHeading',
  HiveStrengthFramesOfBees = 'hiveStrengthFramesOfBees',
  HiveStrengthHarvest = 'hiveStrengthHarvest',
  HiveStrengthNow = 'hiveStrengthNow',
  HiveStrengthQueenSeenNow = 'hiveStrengthQueenSeenNow',
  HiveStrengthHoneyTooltip = 'hiveStrengthHoneyTooltip',
  HiveStrengthQueenTooltip = 'hiveStrengthQueenTooltip',
  HiveStrengthBroodTooltip = 'hiveStrengthBroodTooltip',
  HiveStrengthWeekShort = 'hiveStrengthWeekShort',
  HiveStrengthLastNWeeks = 'hiveStrengthLastNWeeks',
  HiveStrengthNectarFlow = 'hiveStrengthNectarFlow',
  HiveStrengthNectarFlowDescription = 'hiveStrengthNectarFlowDescription',
  HiveStrengthHoney = 'hiveStrengthHoney',
  HiveStrengthQueen = 'hiveStrengthQueen',
  HiveStrengthBrood = 'hiveStrengthBrood',
  HiveStrengthFramesUnit = 'hiveStrengthFramesUnit',
  HiveStrengthDaysAgoUnit = 'hiveStrengthDaysAgoUnit',
  HiveStrengthNeverSeen = 'hiveStrengthNeverSeen',
  HiveStrengthEmpty = 'hiveStrengthEmpty',
  HiveStrengthBannerAlt = 'hiveStrengthBannerAlt',
  HiveStrengthStateThriving = 'hiveStrengthStateThriving',
  HiveStrengthStateThrivingSub = 'hiveStrengthStateThrivingSub',
  HiveStrengthStateGrowing = 'hiveStrengthStateGrowing',
  HiveStrengthStateGrowingSub = 'hiveStrengthStateGrowingSub',
  HiveStrengthStateStable = 'hiveStrengthStateStable',
  HiveStrengthStateStableSub = 'hiveStrengthStateStableSub',
  HiveStrengthStateConserving = 'hiveStrengthStateConserving',
  HiveStrengthStateConservingSub = 'hiveStrengthStateConservingSub',
  HiveStrengthStateReducing = 'hiveStrengthStateReducing',
  HiveStrengthStateReducingSub = 'hiveStrengthStateReducingSub',
  // V2 widget — new copy
  HiveStrengthInsightsTitle = 'hiveStrengthInsightsTitle',
  HiveStrengthMostRecent = 'hiveStrengthMostRecent',
  HiveStrengthBeesLabel = 'hiveStrengthBeesLabel',
  HiveStrengthStrengthLabel = 'hiveStrengthStrengthLabel',
  HiveStrengthFramesOfBeesLong = 'hiveStrengthFramesOfBeesLong',
  HiveStrengthDaysShort = 'hiveStrengthDaysShort',
  HiveStrengthSpottedSuffix = 'hiveStrengthSpottedSuffix',
  HiveStrengthDidYouKnow = 'hiveStrengthDidYouKnow',
  HiveStrengthAHiveHas3Members = 'hiveStrengthAHiveHas3Members',
  HiveStrengthMemberQueenDescription = 'hiveStrengthMemberQueenDescription',
  HiveStrengthMemberWorkers = 'hiveStrengthMemberWorkers',
  HiveStrengthMemberWorkersDescription = 'hiveStrengthMemberWorkersDescription',
  HiveStrengthMemberWorkersCount = 'hiveStrengthMemberWorkersCount',
  HiveStrengthMemberDrones = 'hiveStrengthMemberDrones',
  HiveStrengthMemberDronesDescription = 'hiveStrengthMemberDronesDescription',
  HiveStrengthMemberDronesCount = 'hiveStrengthMemberDronesCount',
  HiveStrengthInAHive = 'hiveStrengthInAHive',
  HiveStrengthAtPeak = 'hiveStrengthAtPeak',
  HiveStrengthBeekeeperInspectionsTitle = 'hiveStrengthBeekeeperInspectionsTitle',
  HiveStrengthBeekeeperInspectionsBody = 'hiveStrengthBeekeeperInspectionsBody',
  HiveStrengthBeesTooltip = 'hiveStrengthBeesTooltip',
  HiveStrengthStrengthTooltip = 'hiveStrengthStrengthTooltip',

  DataCardTitle = 'dataCardTitle',

  BeeHomeWhatIsTitle = 'beeHomeWhatIsTitle',
  BeeHomeWhatIsBody = 'beeHomeWhatIsBody',
  BeeHomeLikelyBuilders = 'beeHomeLikelyBuilders',
  BeeHomeMaterialLumpyMudTitle = 'beeHomeMaterialLumpyMudTitle',
  BeeHomeMaterialLumpyMudDescription = 'beeHomeMaterialLumpyMudDescription',
  BeeHomeMaterialLumpyMudBuilders = 'beeHomeMaterialLumpyMudBuilders',
  BeeHomeMaterialSmoothMudTitle = 'beeHomeMaterialSmoothMudTitle',
  BeeHomeMaterialSmoothMudDescription = 'beeHomeMaterialSmoothMudDescription',
  BeeHomeMaterialSmoothMudBuilders = 'beeHomeMaterialSmoothMudBuilders',
  BeeHomeMaterialMasticLeafPulpTitle = 'beeHomeMaterialMasticLeafPulpTitle',
  BeeHomeMaterialMasticLeafPulpDescription = 'beeHomeMaterialMasticLeafPulpDescription',
  BeeHomeMaterialMasticLeafPulpBuilders = 'beeHomeMaterialMasticLeafPulpBuilders',
  BeeHomeMaterialWoolPlantHairsTitle = 'beeHomeMaterialWoolPlantHairsTitle',
  BeeHomeMaterialWoolPlantHairsDescription = 'beeHomeMaterialWoolPlantHairsDescription',
  BeeHomeMaterialWoolPlantHairsBuilders = 'beeHomeMaterialWoolPlantHairsBuilders',
  BeeHomeMaterialGrassTitle = 'beeHomeMaterialGrassTitle',
  BeeHomeMaterialGrassDescription = 'beeHomeMaterialGrassDescription',
  BeeHomeMaterialGrassBuilders = 'beeHomeMaterialGrassBuilders',
  BeeHomeMaterialLooseLeafPiecesTitle = 'beeHomeMaterialLooseLeafPiecesTitle',
  BeeHomeMaterialLooseLeafPiecesDescription = 'beeHomeMaterialLooseLeafPiecesDescription',
  BeeHomeMaterialLooseLeafPiecesBuilders = 'beeHomeMaterialLooseLeafPiecesBuilders',
  BeeHomeMaterialResinTitle = 'beeHomeMaterialResinTitle',
  BeeHomeMaterialResinDescription = 'beeHomeMaterialResinDescription',
  BeeHomeMaterialResinBuilders = 'beeHomeMaterialResinBuilders',
  BeeHomeMaterialMembranousCellophaneLikeLiningTitle = 'beeHomeMaterialMembranousCellophaneLikeLiningTitle',
  BeeHomeMaterialMembranousCellophaneLikeLiningDescription = 'beeHomeMaterialMembranousCellophaneLikeLiningDescription',
  BeeHomeMaterialMembranousCellophaneLikeLiningBuilders = 'beeHomeMaterialMembranousCellophaneLikeLiningBuilders',
  BeeHomeMaterialLeafPulpSandGrainsLeafDiscsTitle = 'beeHomeMaterialLeafPulpSandGrainsLeafDiscsTitle',
  BeeHomeMaterialLeafPulpSandGrainsLeafDiscsDescription = 'beeHomeMaterialLeafPulpSandGrainsLeafDiscsDescription',
  BeeHomeMaterialLeafPulpSandGrainsLeafDiscsBuilders = 'beeHomeMaterialLeafPulpSandGrainsLeafDiscsBuilders',
  BeeHomeMaterialMudSomeLeafPulpOrangePollenTitle = 'beeHomeMaterialMudSomeLeafPulpOrangePollenTitle',
  BeeHomeMaterialMudSomeLeafPulpOrangePollenDescription = 'beeHomeMaterialMudSomeLeafPulpOrangePollenDescription',
  BeeHomeMaterialMudSomeLeafPulpOrangePollenBuilders = 'beeHomeMaterialMudSomeLeafPulpOrangePollenBuilders',
  BeeHomeMaterialOtherCombinationTitle = 'beeHomeMaterialOtherCombinationTitle',
  BeeHomeMaterialOtherCombinationDescription = 'beeHomeMaterialOtherCombinationDescription',
  BeeHomeMaterialOtherCombinationBuilders = 'beeHomeMaterialOtherCombinationBuilders',
  BeeHomeResultsTitle = 'beeHomeResultsTitle',
  BeeHomeTubesUnit = 'beeHomeTubesUnit',
  BeeHomeTubesNestedThisSeason = 'beeHomeTubesNestedThisSeason',
  BeeHomeDescriptionWithData = 'beeHomeDescriptionWithData',
  BeeHomeDescriptionNoData = 'beeHomeDescriptionNoData',

  BioacousticsCardTitle = 'bioacousticsCardTitle',
  BioacousticsHeaderBadge = 'bioacousticsHeaderBadge',
  BioacousticsErrorLoading = 'bioacousticsErrorLoading',
  BioacousticsTenantHeading = 'bioacousticsTenantHeading',
  BioacousticsTenantBody = 'bioacousticsTenantBody',
  BioacousticsManagerHeading = 'bioacousticsManagerHeading',
  BioacousticsManagerBody = 'bioacousticsManagerBody',
  BioacousticsTenantCta = 'bioacousticsTenantCta',
  BioacousticsManagerCta = 'bioacousticsManagerCta',
  BioacousticsPollinators = 'bioacousticsPollinators',
  BioacousticsLive = 'bioacousticsLive',
  BioacousticsLast14Days = 'bioacousticsLast14Days',
  BioacousticsSelected = 'bioacousticsSelected',
  BioacousticsMostRecent = 'bioacousticsMostRecent',
  BioacousticsActivity = 'bioacousticsActivity',
  BioacousticsDetectionsPerHour = 'bioacousticsDetectionsPerHour',
  BioacousticsRangeOverPeriod = 'bioacousticsRangeOverPeriod',
  BioacousticsDiversityScore = 'bioacousticsDiversityScore',
  BioacousticsDiversityScoreDescription = 'bioacousticsDiversityScoreDescription',
  BioacousticsDiversityScoreFootnote = 'bioacousticsDiversityScoreFootnote',
  BioacousticsVsPrevious7Days = 'bioacousticsVsPrevious7Days',
  BioacousticsPollinatorBreakdownLink = 'bioacousticsPollinatorBreakdownLink',
  BioacousticsBirds = 'bioacousticsBirds',
  BioacousticsAllTime = 'bioacousticsAllTime',
  BioacousticsUniqueBirdSpecies = 'bioacousticsUniqueBirdSpecies',
  BioacousticsTotalDetections = 'bioacousticsTotalDetections',
  BioacousticsMostHeard = 'bioacousticsMostHeard',
  BioacousticsDetections = 'bioacousticsDetections',
  BioacousticsLastSeen = 'bioacousticsLastSeen',
  BioacousticsNoBirdData = 'bioacousticsNoBirdData',
  BioacousticsDawnChorusLink = 'bioacousticsDawnChorusLink',
  BioacousticsWhenBuzzPeaks = 'bioacousticsWhenBuzzPeaks',
  BioacousticsAverageDayAllTime = 'bioacousticsAverageDayAllTime',
  BioacousticsListenToRecentDetections = 'bioacousticsListenToRecentDetections',
  BioacousticsNoBuzzDetections = 'bioacousticsNoBuzzDetections',
  BioacousticsDawnChorus = 'bioacousticsDawnChorus',
  BioacousticsWhenBirdsSingAllTime = 'bioacousticsWhenBirdsSingAllTime',
  BioacousticsByTheNumbers = 'bioacousticsByTheNumbers',
  BioacousticsBirdDiversityScore = 'bioacousticsBirdDiversityScore',
  BioacousticsBirdDiversityScoreDescription = 'bioacousticsBirdDiversityScoreDescription',
  BioacousticsEffectiveSpeciesFromAllDetections = 'bioacousticsEffectiveSpeciesFromAllDetections',
  BioacousticsPeakWindowBetween = 'bioacousticsPeakWindowBetween',
  BioacousticsSongPeaksBetween = 'bioacousticsSongPeaksBetween',
  BioacousticsAnd = 'bioacousticsAnd',
  BioacousticsVariety = 'bioacousticsVariety',
  BioacousticsUniqueFrequencies = 'bioacousticsUniqueFrequencies',
  BioacousticsWeather = 'bioacousticsWeather',

  // BioacousticsPage public page keys
  BioacousticsPageHeroTitleSamplePre = 'bioacousticsPageHeroTitleSamplePre',
  BioacousticsPageHeroTitleSampleCity = 'bioacousticsPageHeroTitleSampleCity',
  BioacousticsPageHeroTitleLivePre = 'bioacousticsPageHeroTitleLivePre',
  BioacousticsPageHeroDescription = 'bioacousticsPageHeroDescription',
  BioacousticsPageAlignedWith = 'bioacousticsPageAlignedWith',
  BioacousticsPageWhereTitle = 'bioacousticsPageWhereTitle',
  BioacousticsPageWhereDescription = 'bioacousticsPageWhereDescription',
  BioacousticsPageLandCoverLabel = 'bioacousticsPageLandCoverLabel',
  BioacousticsPageLandCoverNatural = 'bioacousticsPageLandCoverNatural',
  BioacousticsPageLandCoverAgricultural = 'bioacousticsPageLandCoverAgricultural',
  BioacousticsPageLandCoverArtificial = 'bioacousticsPageLandCoverArtificial',
  BioacousticsPageLandCoverWater = 'bioacousticsPageLandCoverWater',
  BioacousticsPagePollinatorsDescription = 'bioacousticsPagePollinatorsDescription',
  BioacousticsPageBirdsDescription = 'bioacousticsPageBirdsDescription',
  BioacousticsPageDawnChorusDescPre = 'bioacousticsPageDawnChorusDescPre',
  BioacousticsPageDawnChorusDescEmphasis = 'bioacousticsPageDawnChorusDescEmphasis',
  BioacousticsPageDawnChorusDescPost = 'bioacousticsPageDawnChorusDescPost',
  BioacousticsPageUniqueSpecies = 'bioacousticsPageUniqueSpecies',
  BioacousticsPageBirdSensorNotActive = 'bioacousticsPageBirdSensorNotActive',
  BioacousticsPageBirdSensorDescription = 'bioacousticsPageBirdSensorDescription',
  BioacousticsPageUpsellTitlePre = 'bioacousticsPageUpsellTitlePre',
  BioacousticsPageUpsellTitleMid = 'bioacousticsPageUpsellTitleMid',
  BioacousticsPageUpsellTitleYour = 'bioacousticsPageUpsellTitleYour',
  BioacousticsPageUpsellTitlePost = 'bioacousticsPageUpsellTitlePost',
  BioacousticsPageUpsellDescription = 'bioacousticsPageUpsellDescription',
  BioacousticsPageSensorName = 'bioacousticsPageSensorName',
  BioacousticsPageSensorDescription = 'bioacousticsPageSensorDescription',
  BioacousticsPageTheProblem = 'bioacousticsPageTheProblem',
  BioacousticsPageProblemDescPre = 'bioacousticsPageProblemDescPre',
  BioacousticsPageProblemDescPost = 'bioacousticsPageProblemDescPost',
  BioacousticsPageTheSolution = 'bioacousticsPageTheSolution',
  BioacousticsPageSolutionDescription = 'bioacousticsPageSolutionDescription',
  BioacousticsPageThreeWaysTitle = 'bioacousticsPageThreeWaysTitle',
  BioacousticsPageThreeWaysOnePlatformTitle = 'bioacousticsPageThreeWaysOnePlatformTitle',
  BioacousticsPageThreeWaysOnePlatformBody = 'bioacousticsPageThreeWaysOnePlatformBody',
  BioacousticsPageThreeWaysOnlyDataTitle = 'bioacousticsPageThreeWaysOnlyDataTitle',
  BioacousticsPageThreeWaysOnlyDataBody = 'bioacousticsPageThreeWaysOnlyDataBody',
  BioacousticsPageThreeWaysDDQsTitle = 'bioacousticsPageThreeWaysDDQsTitle',
  BioacousticsPageThreeWaysDDQsBody = 'bioacousticsPageThreeWaysDDQsBody',
  BioacousticsPageAsFeaturedIn = 'bioacousticsPageAsFeaturedIn',
  BioacousticsPageDeployedAtPre = 'bioacousticsPageDeployedAtPre',
  BioacousticsPageDeployedAtBrand = 'bioacousticsPageDeployedAtBrand',
  BioacousticsPagePerYearPerProperty = 'bioacousticsPagePerYearPerProperty',
  BioacousticsPagePricingNote = 'bioacousticsPagePricingNote',
  BioacousticsPageWhatsIncluded = 'bioacousticsPageWhatsIncluded',
  BioacousticsPageIncluded1 = 'bioacousticsPageIncluded1',
  BioacousticsPageIncluded2 = 'bioacousticsPageIncluded2',
  BioacousticsPageIncluded3 = 'bioacousticsPageIncluded3',
  BioacousticsPageIncluded4 = 'bioacousticsPageIncluded4',
  BioacousticsPageFreeScreeningTitle = 'bioacousticsPageFreeScreeningTitle',
  BioacousticsPageTryItFree = 'bioacousticsPageTryItFree',

  // BioacousticsDailyChart x-axis labels
  BioacousticsChartToday = 'bioacousticsChartToday',
  BioacousticsChartYesterday = 'bioacousticsChartYesterday',
  BioacousticsChart1WkAgo = 'bioacousticsChart1WkAgo',
  BioacousticsChart2WksAgo = 'bioacousticsChart2WksAgo',

  // BioacousticsHourlyRadarChart clock labels
  BioacousticsChartMidnight = 'bioacousticsChartMidnight',
  BioacousticsChartNoon = 'bioacousticsChartNoon',
  BioacousticsChart6AM = 'bioacousticsChart6AM',
  BioacousticsChart6PM = 'bioacousticsChart6PM',

  AuraNatureAroundBuilding = 'auraNatureAroundBuilding',
  AuraPoweredBy = 'auraPoweredBy',
  AuraLandCover = 'auraLandCover',
  AuraWithin500m = 'auraWithin500m',
  AuraSeeFullPicture = 'auraSeeFullPicture',
  AuraLandCoverAgricultural = 'auraLandCoverAgricultural',
  AuraLandCoverArtificial = 'auraLandCoverArtificial',
  AuraLandCoverNatural = 'auraLandCoverNatural',
  AuraLandCoverWater = 'auraLandCoverWater',
  AuraDescription = 'auraDescription',
  AuraExploreSpecies = 'auraExploreSpecies',

  EdnaCardTitle = 'ednaCardTitle',
  EdnaCardUniquePlants = 'ednaCardUniquePlants',
  EdnaCardDescription = 'ednaCardDescription',
  EdnaCardEveryPlantDetected = 'ednaCardEveryPlantDetected',
  EdnaCardTenantHeading = 'ednaCardTenantHeading',
  EdnaCardTenantBody = 'ednaCardTenantBody',
  EdnaCardManagerHeading = 'ednaCardManagerHeading',
  EdnaCardManagerBody = 'ednaCardManagerBody',
  EdnaCardSeeSampleData = 'ednaCardSeeSampleData',

  EdnaGrowthTreesShrubs = 'ednaGrowthTreesShrubs',
  EdnaGrowthWildflowers = 'ednaGrowthWildflowers',
  EdnaGrowthVinesGrasses = 'ednaGrowthVinesGrasses',
  EdnaGrowthMixed = 'ednaGrowthMixed',
  EdnaGrowthPctOfGroups = 'ednaGrowthPctOfGroups',
  EdnaGrowthKindsByForm = 'ednaGrowthKindsByForm',

  ShareWithTenantsTitle = 'shareWithTenantsTitle',
  ShareWithTenantsSubheader = 'shareWithTenantsSubheader',
  InviteByEmailTab = 'inviteByEmailTab',
  ShareALinkTab = 'shareALinkTab',
  QRCodeTab = 'qrCodeTab',
  ShareableLink = 'shareableLink',
  ShareableLinkHint = 'shareableLinkHint',
  MakeItYours = 'makeItYours',
  MakeItYoursHint = 'makeItYoursHint',
  PageNameLabel = 'pageNameLabel',
  PageNameExampleHint = 'pageNameExampleHint',
  PageLinkLabel = 'pageLinkLabel',
  PageLinkExampleHint = 'pageLinkExampleHint',
  QRScanHeading = 'qrScanHeading',
  QRScanHint = 'qrScanHint',
  DownloadQRCode = 'downloadQRCode',
  SavedConfirmation = 'savedConfirmation',

  ErrorPageGenericTitle = 'errorPageGenericTitle',
  ErrorPageGenericBody = 'errorPageGenericBody',
  ErrorPageLoadUserTitle = 'errorPageLoadUserTitle',
  ErrorPageLoadUserBody = 'errorPageLoadUserBody',
  ErrorPageHoneyLabelTitle = 'errorPageHoneyLabelTitle',
  ErrorPageHoneyLabelBody = 'errorPageHoneyLabelBody',
  ErrorPageNotFoundTitle = 'errorPageNotFoundTitle',
  ErrorPageNotFoundBody = 'errorPageNotFoundBody',
  ErrorPageNoAccessTitle = 'errorPageNoAccessTitle',
  ErrorPageNoAccessAuthed = 'errorPageNoAccessAuthed',
  ErrorPageNoAccessGuest = 'errorPageNoAccessGuest',
  ErrorPageContactSupport = 'errorPageContactSupport',
  ErrorPageSupportUrl = 'errorPageSupportUrl',
}

export const myhiveLocalization: LocalizedStrings = {
  en: {
    [MyHiveLocalizationKey.Unset]: 'Unset',
    [MyHiveLocalizationKey.Main]: 'Main',
    [MyHiveLocalizationKey.Site]: 'Site',
    [MyHiveLocalizationKey.Attendees]: 'Attendees:',
    [MyHiveLocalizationKey.ShareYourLogoHere]: 'Share your logo here!',
    [MyHiveLocalizationKey.UploadYourLogoAnd]: "Upload your logo and we'll take care of the rest.",
    [MyHiveLocalizationKey.ReachEveryoneRegistered]: `Reach everyone registered for your event in one go. Share last-minute details, reminders, or helpful context so everyone shows up prepared.`,
    [MyHiveLocalizationKey.YourMessageLands]: 'Your message lands instantly in their inbox.',
    [MyHiveLocalizationKey.AMessageFrom]: 'A message from your event host',
    [MyHiveLocalizationKey.PreHeader]: 'Pre-header',
    [MyHiveLocalizationKey.MessageAttendees]: 'Message attendees',
    [MyHiveLocalizationKey.MessageYourAttendees]: 'Message your attendees',
    [MyHiveLocalizationKey.CustomMessageAttendeesHint]:
      'Add your message here — last-minute details, what to bring, where to meet...',
    [MyHiveLocalizationKey.CustomizeYourMessageEvent]: `Join us for a special event as part of our building’s bee program with Alvéole!

{{WORKSHOP_TITLE}} offers a unique, hands-on experience you won’t want to miss. 

Discover how small actions support urban biodiversity, and how our workplace is contributing to a more nature-positive city.

Check out the details below and secure your spot. 🐝`,
    [MyHiveLocalizationKey.GetNotifiedForEveryNewSignup]:
      'Get notified for every new signup and view or contact your registrant list anytime on your page.',
    [MyHiveLocalizationKey.ShareYourEventWithYourTenantNetwork]:
      'Share your event with your tenant network! They can register directly on your Alvéole page, while our event tool tracks attendance and sends confirmations and reminders automatically.',
    [MyHiveLocalizationKey.PersonalizeTitle]: 'Personalize your page name',
    [MyHiveLocalizationKey.PersonalizeText]: 'Choose a name and add your logo so tenants instantly recognize the page!',
    [AlveolePackages.Base]: 'Base',
    [AlveolePackages.CultivateChange]: 'Cultivate Change',
    [AlveolePackages.Deluxe]: 'Deluxe',
    [AlveolePackages.EducationalPackage]: 'Educational Package',
    [AlveolePackages.MeetTheBees]: 'Meet the Bees',
    [AlveolePackages.MeetTheWildBees]: 'Meet the Wild Bees',
    [AlveolePackages.NatureImpact]: 'Nature Impact',
    [AlveolePackages.NatureRisk]: 'Nature Risk',
    [AlveolePackages.Premium]: 'Premium',
    [AlveolePackages.School]: 'School',
    [AlveolePackages.Standard]: 'Standard',
    [AlveolePackages.TrackYourImpact]: 'Track Your Impact',
    [AlveolePackages.WelcomeLocalPollinators]: 'Welcome Local Pollinator',
    [MyHiveLocalizationKey.SearchYourReportTypes]: 'Search your report types',
    [MyHiveLocalizationKey.NoResultsMatching]: 'No results matching your search',
    [MyHiveLocalizationKey.Certifications]: 'Certifications',
    [MyHiveLocalizationKey.SearchYourAssets]: 'Search your assets',
    [MyHiveLocalizationKey.AskNature]: 'Ask Nature',
    [MyHiveLocalizationKey.AvailableReports]: 'Available Reports',
    [MyHiveLocalizationKey.SearchForAnAsset]: 'Search for an asset',
    [MyHiveLocalizationKey.AssetLevelResults]: 'Asset-level results',
    [MyHiveLocalizationKey.Properties]: 'Properties',
    [MyHiveLocalizationKey.PortfolioInsights]: 'Portfolio insights',
    [MyHiveLocalizationKey.ExploreYourData]: 'Explore your data',
    [MyHiveLocalizationKey.ReportsAtYourFingertips]: 'Reports at your fingertips',
    [MyHiveLocalizationKey.NatureData]: 'Nature Data',
    [MyHiveLocalizationKey.AllAssets]: 'All Assets',
    [MyHiveLocalizationKey.AssetAnalytics]: 'Asset Analytics',
    [MyHiveLocalizationKey.Dashboard]: 'Dashboard',
    [MyHiveLocalizationKey.Property]: 'Property',
    [MyHiveLocalizationKey.Reports]: 'Reports',
    [MyHiveLocalizationKey.Discover]: 'Discover',
    [MyHiveLocalizationKey.ActConfidently]: 'Act Confidently',
    [MyHiveLocalizationKey.ExploreUnderstand]: 'Ready to explore your nature data?',
    [MyHiveLocalizationKey.Back]: `Back`,
    [MyHiveLocalizationKey.Hey]: `Hey`,
    [MyHiveLocalizationKey.Imyour]: `I’m your`,
    [MyHiveLocalizationKey.HereToHelp]: `Your partner for understanding nature and biodiversity across your portfolio, from data to certifications to insights.`,
    [MyHiveLocalizationKey.Heresafew]: 'Here’s a few things you should know about me:',

    [MyHiveLocalizationKey.Curious]: `Curious?`,
    [MyHiveLocalizationKey.JustAsk]: `Just ask.`,
    [MyHiveLocalizationKey.ChatWithMe]: `Ask me anything about your nature data and I’ll help you find answers quickly.`,
    [MyHiveLocalizationKey.BuiltToGuide]: `Always clear, never overwhelming.`,
    [MyHiveLocalizationKey.ITurnComplexFrameworks]: `I give you the metrics and indicators you need for complex frameworks like TNFD and CSRD, ready to export in PDF or CSV.`, // @todo
    [MyHiveLocalizationKey.WeGrowBetterTogether]: `Learning with you.`,
    [MyHiveLocalizationKey.EveryConversationHelpsMeLearn]: `I adapt to your priorities, so the guidance gets better every time we talk.`,
    [MyHiveLocalizationKey.Whatsyourrole]: `What is your role?`,
    [MyHiveLocalizationKey.Egassetmanager]: `Eg: Asset Manager, Sustainability Manager, Property Manager`,
    [MyHiveLocalizationKey.Howareyouplanning]: `How are you planning to use Nature Agent?`,
    [MyHiveLocalizationKey.Sustainabilityreporting]: `Sustainability reporting`,
    [MyHiveLocalizationKey.Hivehealthandbiodiversity]: `Nature & biodiversity`,
    [MyHiveLocalizationKey.Tenantandcommunityengagement]: `Tenant & community engagement`,
    [MyHiveLocalizationKey.Frameworksandcertifications]: `Frameworks & certifications`,
    [MyHiveLocalizationKey.Sitelevelinsights]: `Site-level insights`,
    [MyHiveLocalizationKey.Portfoliooverview]: `Portfolio overview`,
    [MyHiveLocalizationKey.Natureagentschoice]: `Nature Agent's choice`,
    [MyHiveLocalizationKey.Whichareyouinterestedin]: `Which are you interested in?`,
    [MyHiveLocalizationKey.Frameworks]: `Frameworks`,
    [MyHiveLocalizationKey.Greencertifications]: `Certifications`,
    [MyHiveLocalizationKey.Leedleadershipinenergy]: `LEED - Leadership in Energy and Environmental Design`,
    [MyHiveLocalizationKey.Wellbuildingstandard]: `WELL - Building Standard`,
    [MyHiveLocalizationKey.Fitwelhealth]: `Fitwel - Health-promoting environments`,
    [MyHiveLocalizationKey.Gresbbenchmarkinges]: `GRESB- Benchmarking ESG performance`,
    [MyHiveLocalizationKey.Tnfdtaskforceon]: `TNFD - Taskforce on Nature-related Financial Disclosures`,
    [MyHiveLocalizationKey.Csrdcorporatesustainability]: `CSRD - Corporate Sustainability Reporting Directive`,
    [MyHiveLocalizationKey.Breeaminuse]: `BREEAM -  Assessing building sustainability performance`,
    [MyHiveLocalizationKey.BNG]: `BNG - Biodiversity Net Gain (UK)`,

    [MyHiveLocalizationKey.Continue]: `Continue`,
    [MyHiveLocalizationKey.Doyouprefer]: `Which insights matter more to you? `,
    [MyHiveLocalizationKey.Sitelevel]: `Site-level performance`,
    [MyHiveLocalizationKey.Portfoliolevel]: `Portfolio-wide trends`,
    [MyHiveLocalizationKey.Completeonboarding]: `Get started`,
    [MyHiveLocalizationKey.Iunderstand]: `I understand`,
    [MyHiveLocalizationKey.Skip]: `Skip`,

    [ContactRole.AssetManagementTeam]: 'Asset Management Team',
    [ContactRole.PropertyTeam]: 'Property Team',
    [ContactRole.SustainabilityTeam]: 'Sustainability Team',
    [ContactRole.TenantOccupant]: 'Tenant / Occupant',
    [ContactRole.MarketingAndCommsTeam]: 'Marketing & Communications Team',
    [MyHiveLocalizationKey.NatureAgentToolTipTitle]: 'Meet your Nature Agent',
    [MyHiveLocalizationKey.NatureAgentToolTipDesc]: `This is your space to ask questions about your biodiversity impacts and opportunities. Your Nature Agent can provide insights related to nature and biodiversity reporting for your program, help you explore environmental frameworks, and more! It can help you learn, discover and support your nature-related goals. 
    
Ask about your impacts, or say simply say hello to get started!`,
    [MyHiveLocalizationKey.MarketingSiteUrl]: getMarketingSiteUrl('en'),
    [MyHiveLocalizationKey.EmailPreview]: 'Email Preview',
    [MyHiveLocalizationKey.ShareSuccess1]: 'Your email is on its way!',
    [MyHiveLocalizationKey.ShareSuccess2]: 'Check your inbox for a confirmation email.',
    [MyHiveLocalizationKey.AddFromCsv]: 'Upload .csv',
    [MyHiveLocalizationKey.BodyEmail]: 'Message:',
    [MyHiveLocalizationKey.Close]: 'Close',
    [MyHiveLocalizationKey.More]: 'more',
    [MyHiveLocalizationKey.EmailAddressesPlaceholder]:
      'Example: main.tenant@company.com, main.tenant2@company.com, main.tenant3@company.com',
    [MyHiveLocalizationKey.BackToEdit]: 'Back to Edit',
    [MyHiveLocalizationKey.Send]: 'Send',
    [MyHiveLocalizationKey.Share]: 'Share',
    [MyHiveLocalizationKey.WithTenants]: 'with Tenants',
    [MyHiveLocalizationKey.BoostEngagementShare]:
      'Boost engagement! Share your MyHive page with your tenant network and main tenant contacts so everyone can join in.',
    [MyHiveLocalizationKey.InviteYourTenantsToRegister]:
      'Boost engagement! Share your event with your tenant network and main tenant contacts so everyone can join in.',
    [MyHiveLocalizationKey.EmailAddresses]: 'Email Addresses',
    [MyHiveLocalizationKey.EmailAddressesHint]: 'Separate multiple emails with commas or line breaks',
    [MyHiveLocalizationKey.CustomMessage]: 'Customize your message (optional):',
    [MyHiveLocalizationKey.CustomMessageRequired]: 'Customize your message:',
    [MyHiveLocalizationKey.CustomMessageText]:
      'As part of our sustainability program, we’re excited to share our building’s Alvéole page - a space for you and your team to see what the bees are up to, sign up for events, and claim honey jars.\n\nPlease share this with your team so they can take part!',
    [MyHiveLocalizationKey.CustomMessageHint]: 'Add a message to share with tenants',
    [MyHiveLocalizationKey.PreviewSend]: 'Preview & Send',
    [MyHiveLocalizationKey.PreviewFrom]: 'From:',
    [MyHiveLocalizationKey.PreviewTo]: 'To:',
    [MyHiveLocalizationKey.PreviewSubject]: 'Subject:',
    [MyHiveLocalizationKey.PreviewSubjectText]: 'invites you to discover nature at your building',
    [MyHiveLocalizationKey.PreviewSubjectTextEvent]: 'invites you to',
    [MyHiveLocalizationKey.PreviewClickToExplore]: 'Click to explore:',

    [MyHiveLocalizationKey.NeedSupport]: 'Need support?',
    [MyHiveLocalizationKey.WelcomeToMyhive]: 'Welcome to Myhive',
    [MyHiveLocalizationKey.Subscribe]: 'Subscribe',
    [MyHiveLocalizationKey.PreferencesEnableEventInterestList]: 'Event Interest List',
    [MyHiveLocalizationKey.PreferencesEnableHoneyInterestList]: 'Honey Interest List',
    [MyHiveLocalizationKey.PreferencesEnableAiSupportAgent]: 'AI Support Agent',
    [MyHiveLocalizationKey.PreferencesEnableQueenFeature]: 'Queen Bee Naming',
    [MyHiveLocalizationKey.PreferencesEnableQueenCommunityVoting]: 'Community Voting',
    [MyHiveLocalizationKey.PreferencesShowUpcomingEvents]: 'Show upcoming events',
    [MyHiveLocalizationKey.PreferencesShowUpcomingVisits]: 'Show upcoming beekeeping visits',
    [MyHiveLocalizationKey.PreferencesSubscriberAlerts]:
      'Get email alerts for new subscriptions and event/honey interest sign-ups',
    [MyHiveLocalizationKey.FaqLink]: 'https://www.alveole.buzz/faq/',
    [MyHiveLocalizationKey.Subscriber]: 'Subscriber',
    [MyHiveLocalizationKey.Subscribers]: 'Subscribers',
    [MyHiveLocalizationKey.AppTitle]: 'alvéole',
    [MyHiveLocalizationKey.MenuHeading]: 'alvéole',
    [MyHiveLocalizationKey.FindAHive]: 'Find a hive',
    [MyHiveLocalizationKey.HowCanWeHelp]: 'How can we help?',
    [MyHiveLocalizationKey.Website]: 'Website',
    [MyHiveLocalizationKey.Blog]: 'Blog',
    [MyHiveLocalizationKey.English]: 'English',
    [MyHiveLocalizationKey.French]: 'Français',
    [MyHiveLocalizationKey.SignIn]: 'Sign in',
    [MyHiveLocalizationKey.Change]: 'Change',
    [MyHiveLocalizationKey.HeroTitle]: 'Myhive',
    [MyHiveLocalizationKey.HeroDescription]:
      'You are currently not linked to any Pages, please reach out to your Alvéole contact person to get started.',
    [MyHiveLocalizationKey.HeroSearch]: 'Search for a project by name or address',
    [MyHiveLocalizationKey.HeroHives]: 'hives',
    [MyHiveLocalizationKey.HeroBees]: 'bees',
    [MyHiveLocalizationKey.HeroCities]: 'cities',
    [MyHiveLocalizationKey.HeroPeople]: 'people reached',
    [MyHiveLocalizationKey.NoHivesFound]: 'No hives found',

    [MyHiveLocalizationKey.NearbyBuzzTitle]: 'Nearby buzzes',
    [MyHiveLocalizationKey.NearbyBuzzDescription]: "What's happening at hive projects all over your city.",
    [MyHiveLocalizationKey.NearbyBuzzVisit]: 'Visit this hive',

    [MyHiveLocalizationKey.WhereWeBuzzTitle]: 'Where we buzz',
    [MyHiveLocalizationKey.WhereWeBuzzDescription]: 'Alvéole has hives buzzing all over the world. Explore!',
    [MyHiveLocalizationKey.WhereWeBuzzUnitedStates]: 'United States',
    [MyHiveLocalizationKey.WhereWeBuzzVisit]: 'Visit this hive',

    [MyHiveLocalizationKey.JoinMovementTitle]: 'Join the movement',
    [MyHiveLocalizationKey.JoinMovementDescription]:
      'Engage your employees and achieve your sustainability goals by getting involved. Urban beekeeping has something for everyone.',
    [MyHiveLocalizationKey.JoinMovementButton]: 'DISCOVER',
    [MyHiveLocalizationKey.FooterCopyright]: '© 2021 Alvéole, Inc. All rights reserved',
    [MyHiveLocalizationKey.FooterTerms]: 'Terms & Conditions',
    [MyHiveLocalizationKey.FooterPrivacy]: 'Privacy Policy',

    [MyHiveLocalizationKey.Edit]: 'Edit',
    [MyHiveLocalizationKey.Save]: 'Save',
    [MyHiveLocalizationKey.Cancel]: 'Cancel',
    [MyHiveLocalizationKey.Remove]: 'Remove',

    [MyHiveLocalizationKey.RemoveBuzzTitle]: 'Remove buzz',
    [MyHiveLocalizationKey.RemoveBuzzDescription]:
      'This will permanently remove this buzz from this page, and other pages it might be shared to.',

    [MyHiveLocalizationKey.CreateABuzz]: 'Create a buzz',
    [MyHiveLocalizationKey.CreateABuzzPlaceholder]: 'What’s the buzz?',
    [MyHiveLocalizationKey.CreateABuzzPost]: 'Post',
    [MyHiveLocalizationKey.CreateABuzzUploadText]: 'Add up to 5 photos/videos',
    [MyHiveLocalizationKey.CreateABuzzPostToText]: 'Post to',
    [MyHiveLocalizationKey.CreateABuzzPagesText]: 'pages',
    [MyHiveLocalizationKey.Order]: 'Order',

    [MyHiveLocalizationKey.BuzzTimeLine]: 'Timeline',
    [MyHiveLocalizationKey.Community]: 'Community',
    [MyHiveLocalizationKey.BuzzCharacters]: 'characters',

    [MyHiveLocalizationKey.JoinWaitingList]: `I'm interested`,
    [MyHiveLocalizationKey.GuestsInterested]: 'Guests interested',
    [MyHiveLocalizationKey.JoinWaitingListTitle]: 'Join the event waiting list',
    [MyHiveLocalizationKey.JoinWaitingListDescription]:
      'Provide your details to be the first to know about upcoming events!',
    [MyHiveLocalizationKey.FullName]: 'Full name',
    [MyHiveLocalizationKey.OrgName]: 'Enter your organization name',
    [MyHiveLocalizationKey.JoinList]: 'Join list',
    [MyHiveLocalizationKey.InterestedInEvents]: 'Nature events',
    [MyHiveLocalizationKey.EveryAlveoleProgram]: 'Every Alvéole program includes experiences with nature experts.',
    [MyHiveLocalizationKey.ConnectWithUrbanBio]: 'Connect with urban biodiversity',
    [MyHiveLocalizationKey.GetHandsOn]: 'Get hands-on with nature',
    [MyHiveLocalizationKey.EnjoyWorkshops]: 'Enjoy workshops, hive tours and behind-the-scenes access',
    [MyHiveLocalizationKey.WatchForNextEvent]: `Watch for your next buzz-worthy event!`,
    [MyHiveLocalizationKey.BookAnEvent]: 'Book an event',
    [MyHiveLocalizationKey.ViewList]: 'View list',
    [MyHiveLocalizationKey.Export]: 'Export',
    [MyHiveLocalizationKey.ExportFilteredList]: 'Export filtered list',
    [MyHiveLocalizationKey.PeopleFollowingThisPage]: 'people following this page',
    [MyHiveLocalizationKey.FilterAll]: 'All',
    [MyHiveLocalizationKey.FollowNewPosts]: 'Follow new posts',
    [MyHiveLocalizationKey.FollowEvents]: 'Follow Events',
    [MyHiveLocalizationKey.InterestedInHoneyTab]: 'Interested in Honey',
    [MyHiveLocalizationKey.InviteMoreTenants]: 'Invite more tenants',
    [MyHiveLocalizationKey.NoSubscribersYet]: 'No subscribers yet',
    [MyHiveLocalizationKey.NoSubscribersMatchFilter]: 'No subscribers match this filter',
    [MyHiveLocalizationKey.InterestedUsers]: 'Interested Users',
    [MyHiveLocalizationKey.PeopleMarkedAsInterested]: 'people marked as interested',
    [MyHiveLocalizationKey.PersonMarkedAsInterested]: 'person marked as interested',
    [MyHiveLocalizationKey.StayUpdated]: 'Stay updated on events and honey',
    [MyHiveLocalizationKey.MoreUpcomingEvents]: 'More upcoming events',
    [MyHiveLocalizationKey.InterstedInEvents]: 'Interested in events',
    [MyHiveLocalizationKey.InterestedInHoney]: 'Interested in honey',
    [MyHiveLocalizationKey.AddMeToTheList]: 'Add me',
    [MyHiveLocalizationKey.WaitingListJoined]: 'Waiting List Joined!',
    [MyHiveLocalizationKey.ThanksWaitingList]: `Thanks! You've been added to the waiting list for upcoming events.`,
    [MyHiveLocalizationKey.ReferWorkBestie]: 'Refer your work bestie',
    [MyHiveLocalizationKey.WorkBestieEvents]:
      'Know a colleague who would love to learn about bees? Invite them to join the waiting list too!',
    [MyHiveLocalizationKey.ShareThisLink]: 'Share this link:',
    [MyHiveLocalizationKey.CopyLink]: 'Copy Link',
    [MyHiveLocalizationKey.CopyEmail]: 'Copy Email',
    [MyHiveLocalizationKey.Copied]: 'Copied!',

    [MyHiveLocalizationKey.GetOnTheHoneyList]: 'Get on the Honey List',
    [MyHiveLocalizationKey.HoneyFromHive]: `Honey, straight from the hive! You'll be the first to know about available jars.`,
    [MyHiveLocalizationKey.HarvestBegins]: 'Harvest begins',
    [MyHiveLocalizationKey.DeliveredBy]: 'Delivered by',

    [MyHiveLocalizationKey.Delivery]: 'Delivery',
    [MyHiveLocalizationKey.ComingSoon]: 'Coming Soon!',

    [MyHiveLocalizationKey.HoneyInterestJoined]: 'Honey interest joined!',
    [MyHiveLocalizationKey.ThanksWellNotify]: `Thanks! We'll notify you when fresh honey is ready.`,
    [MyHiveLocalizationKey.WorkBestieHoney]:
      'Think your work bestie would love artisanal honey? Let them know about it!',

    [MyHiveLocalizationKey.FollowTheBuzz]: 'Stay updated',
    [MyHiveLocalizationKey.FollowTheBuzzDescription]: 'Be the first to know about events and honey',
    [MyHiveLocalizationKey.FollowTheBuzzYourEmail]: 'Your company email',
    [MyHiveLocalizationKey.FollowTheBuzzSignUp]: 'Subscribe',
    [MyHiveLocalizationKey.FollowTheBuzzThankyou]: 'Thank you!',
    [MyHiveLocalizationKey.ProgramOverview]: 'Program Overview',
    [MyHiveLocalizationKey.ProgramOverviewDescription]:
      'As part of our program, we are proud to host a hive with thousands of happy and hard working honey bees who pollinate the neighborhood.',
    [MyHiveLocalizationKey.ProgramOverviewButton]: 'Learn more',
    [MyHiveLocalizationKey.GetInvolved]: 'Get Involved',
    [MyHiveLocalizationKey.KeepLearning]: 'Keep learning',
    [MyHiveLocalizationKey.KeepLearningDescription]:
      'Browse the latest blog articles and access key beekeeping guides.',
    [MyHiveLocalizationKey.KeepLearningButton]: 'Learn more',
    [MyHiveLocalizationKey.HaveAquestion]: 'Have a question?',
    [MyHiveLocalizationKey.HaveAquestionDescription]:
      "We'd love to tell you more about Alvéole's services and answer any questions you have.",
    [MyHiveLocalizationKey.HaveAquestionButton]: 'Visit our FAQ',
    [MyHiveLocalizationKey.UpcomingEvents]: 'Upcoming Events',
    [MyHiveLocalizationKey.ScheduledVisits]: 'Next Scheduled Visits',
    [MyHiveLocalizationKey.Beekeeper]: 'Beekeeper:',
    [MyHiveLocalizationKey.AddToCalendar]: 'Add to calendar',
    [MyHiveLocalizationKey.ShowAll]: 'Show all',
    [MyHiveLocalizationKey.ShowLess]: 'Show less',
    [MyHiveLocalizationKey.NoUpcomingVisits]: 'No upcoming visits scheduled',
    [MyHiveLocalizationKey.NoUpcomingEvents]: 'No upcoming events scheduled',
    [MyHiveLocalizationKey.PleaseEnterAValidEmail]: 'Please enter a valid email address',
    [MyHiveLocalizationKey.BuzzWeatherCold]: "It's cold! The bees are forming a mass around their queen.",
    [MyHiveLocalizationKey.BuzzWeatherHot]: "It's hot! The bees need to ventilate the hive to cool it.",
    [MyHiveLocalizationKey.BuzzWeatherRainy]: "It's raining! The bees are staying inside the hive.",
    [MyHiveLocalizationKey.BuzzWeatherCloudy]: "It's cloudy! The bees are slowing down their activities.",
    [MyHiveLocalizationKey.BuzzWeatherSunny]: "It's sunny! The foragers are bringing in lots of nectar and pollen.",

    [MyHiveLocalizationKey.GalleryTitle]: 'Gallery',
    [MyHiveLocalizationKey.GalleryDescription]:
      'View all images from your MyHive feed in one place. Click an image to expand it, or use the download button to save it to your device.',
    [MyHiveLocalizationKey.HoneyLabelTitle]: 'Honey label design',
    [MyHiveLocalizationKey.HoneyLabelDescription]:
      'Soon you will be able to view and approve your existing design, or create and customize a new design using our design tool.',
    [MyHiveLocalizationKey.HoneyLabelTabYourLabel]: 'Your honey label',
    [MyHiveLocalizationKey.HoneyLabelTabDesignOwn]: 'Design your own label',
    [MyHiveLocalizationKey.HoneyLabelApprove]: 'Approve this design',
    [MyHiveLocalizationKey.HoneyLabelOr]: 'or',
    [MyHiveLocalizationKey.HoneyLabelCreate]: 'Create a new design',
    [MyHiveLocalizationKey.HoneyLabelTabFaq]: 'FAQ',
    [MyHiveLocalizationKey.HoneyLabelNoLabel]: 'No Label Yet',
    [MyHiveLocalizationKey.HoneyLabelDesignSubmitted]: 'Your design has been submitted',
    [MyHiveLocalizationKey.HoneyLabelFaqDesignGuideTitle]: 'Can I design my labels in-house?',
    [MyHiveLocalizationKey.HoneyLabelFaqDesignGuideContent]: 'Short answer: yes, absolutely!',
    [MyHiveLocalizationKey.HoneyLabelFaqDesignGuideContentTwo]: 'Simply follow the guidelines here: ',
    [MyHiveLocalizationKey.HoneyLabelFaqDesignLink]: 'Can I design my labels in-house?',

    [MyHiveLocalizationKey.HoneyLabelFaqDimensionsTitle]: 'Dimensions:',
    [MyHiveLocalizationKey.HoneyLabelFaqDimensionsList]: `Size: 5.5" x 1.0925"
Bleed: 0.125" (This is the extra space around all edges to ensure your design prints correctly.)
Security Margin: 0.125" (Keep all important information within this area to avoid it being cut off.)`,
    [MyHiveLocalizationKey.HoneyLabelFaqRequiredInfoTitle]:
      'Required Information: (You can find the content in our label templates available in the designer tool -> Myhive -> Honey label section)',
    [MyHiveLocalizationKey.HoneyLabelFaqRequiredInfoList]: `"Unpasteurized Honey"
Weight (Make sure to use the metric system of your country): 130g, 100ml, 4.6 oz
Your city and country
"Harvested by Alvéole"
"Not for infants under 1 year old"`,
    [MyHiveLocalizationKey.HoneyLabelFaqExportingTitle]: 'Exporting Your Design:',
    [MyHiveLocalizationKey.HoneyLabelFaqExportingList]: `Format: Save your label as a PNG, SVG, or JPEG file.
Remember to keep the bleed, the final file should measure 5.75" x 1.3425" (14.605 x 3.41 cm).
Make sure to remove all trim marks and borders before saving.`,
    [MyHiveLocalizationKey.HoneyLabelFaqUploadingTitle]: 'Uploading Your Design:',
    [MyHiveLocalizationKey.HoneyLabelFaqUploadingList]: `Log in to your Myhive Portal.
Navigate to the left menu bar and select "Honey Label".
In the designer tool, click "Upload Logo or Design", then upload your file and fit it into the die-cut box.
Once everything looks perfect, submit your label.`,
    [MyHiveLocalizationKey.HoneyLabelFaqWhyFromScratchTitle]:
      'Why can’t I modify my 2025 design? Why do I have to create a new label? ',
    [MyHiveLocalizationKey.HoneyLabelFaqWhyFromScratchIntro]:
      "We know starting from scratch can feel a bit daunting, but let's break it down together.",
    [MyHiveLocalizationKey.HoneyLabelFaqWhyChangeTitle]: 'Why the Change?',
    [MyHiveLocalizationKey.HoneyLabelFaqWhyChangeContent]:
      "To enhance your design experience and make it more efficient, we've integrated a self-design tool. This new tool offers you significantly more templates and customization options, and it helps reduce the back-and-forth emails with our internal designer.",
    [MyHiveLocalizationKey.HoneyLabelFaqWhyNotModifyTitle]:
      "Why can't I modify my existing label design in the self-design tool?",
    [MyHiveLocalizationKey.HoneyLabelFaqWhyNotModifyContent]:
      'Our self-design tool isn\'t compatible with previous label designs designed using Adobe Illustrator, which means your design from last year can only be approved "as-is." If you\'re looking for something new or update your logo, dive into our collection of fresh and bee-utiful templates. Pick your favorite and customize it to your brand colors. 🎨',
    [MyHiveLocalizationKey.HoneyLabelFaqByeByeWaitingTitle]: 'Bye-Bye to Waiting!',
    [MyHiveLocalizationKey.HoneyLabelFaqByeByeWaitingContent]:
      'No more uploading your logo and waiting weeks for the proofing and approval process! With our self-serve tool, you can create and submit your design all in one go!',
    [MyHiveLocalizationKey.HoneyLabelFaqMoreOptionsTitle]: 'More design options, more fun!',
    [MyHiveLocalizationKey.HoneyLabelFaqMoreOptionsContent]:
      "We're very excited to bring you a treasure trove of new design options, fonts, colors and clipart for more freedom with your designs than ever before. Let your creative spirit shine!",
    [MyHiveLocalizationKey.HoneyLabelFaqFreshLabelTitle]: 'A fresh new label, every year!',
    [MyHiveLocalizationKey.HoneyLabelFaqFreshLabelContent]:
      'With multiple templates available, you can easily give your honey jars a fresh and exciting look every year!',
    [MyHiveLocalizationKey.HoneyLabelFaqContentChangesTitle]: 'Label content changes on templates',
    [MyHiveLocalizationKey.HoneyLabelFaqContentChangesContent]:
      'We have revised the content requirements to enhance clarity and simplicity, removing unnecessary elements for a more minimalist design.\n\nIf you plan to sell this product in grocery stores, please reach out to support@alveole.buzz for information on legal requirements.',
    [MyHiveLocalizationKey.HoneyLabelGuideTitle]: 'Design your honey label: Step-by-step guide',
    [MyHiveLocalizationKey.HoneyLabelGuideRequiredCustomizationTitle]: 'Required Customization',
    [MyHiveLocalizationKey.HoneyLabelChooseYourDesign]: 'Step 1: Choose Your Design',
    [MyHiveLocalizationKey.HoneyLabelGuideChooseTemplate]:
      '**Choose a Template:** Click "Design Templates" in the sidebar, and select one you like, or upload your own honey label, ensuring it fits the requirements.*',
    [MyHiveLocalizationKey.HoneyLabelGuideUploadLogo]:
      '**Upload Your Logo:** Click **"Upload Logo"** in the sidebar and upload a high-resolution SVG, PNG or JPEG file.',
    [MyHiveLocalizationKey.HoneyLabelGuideEnterCity]:
      '**Enter Your City:** Replace the placeholder text **"City, Country"** by clicking the text and entering the appropriate location in the sidebar.',
    [MyHiveLocalizationKey.HoneyLabelGuideOptionalCustomizationTitle]: 'Optional Customization',
    [MyHiveLocalizationKey.HoneyLabelGuideAddQRCode]:
      '**Add Your MyHive QR Code:** Click **"QR Code"** in the sidebar and select **"Generate and Add"**; this will generate a QR code linked to your MyHive page. Resize your new QR code and position it as desired. Min size: 0.4" x 0.4"',
    [MyHiveLocalizationKey.HoneyLabelGuideCustomizeColors]:
      '**Customize Colors, Font, and Text:** Adjust design elements, background colors, fonts, and wording to reflect your brand identity.',
    [MyHiveLocalizationKey.HoneyLabelGuideAddArtwork]:
      '**Add Artwork:** Incorporate clipart, illustrations, or shapes to bring your label design to life by clicking **"Add Illustrations"** in the sidebar.',
    [MyHiveLocalizationKey.HoneyLabelGuideSaveSubmitTitle]: 'Save draft and submit your label',
    [MyHiveLocalizationKey.HoneyLabelGuideSaveDraft]:
      '**Save Draft:** Click **"Save Draft"** at the bottom of the tool to save your progress and return later.',
    [MyHiveLocalizationKey.HoneyLabelGuideSubmitDesign]:
      '**To submit,** go to "Your Honey Label" page and click "Approve your design"',
    [MyHiveLocalizationKey.HoneyLabelGuideUploadOwnLabel]:
      '***Upload Your Own Honey Label:** If you prefer to design your label in-house using other design software, please visit the FAQ tab under **"Upload a fully custom design: label specs"**',
    [MyHiveLocalizationKey.HoneyLabelWatchATutorial]: 'Watch a tutorial',
    [MyHiveLocalizationKey.HoneyLabelDesignToolDown]:
      'The label design tool is temporarily unavailable. We apologize for the inconvenience and are working to restore it as soon as possible.',
    [MyHiveLocalizationKey.QueenFormTitle]: 'Name the Queen',
    [MyHiveLocalizationKey.QueenFormSubtitle]: 'Our hive has a hardworking queen - help us give her a royal name!',
    [MyHiveLocalizationKey.QueenFormPlaceholder]: 'Suggest a royal name...',
    [MyHiveLocalizationKey.QueenFormProfilePrompt]:
      'Tell us who you are so we can give you credit for your nomination!',
    [MyHiveLocalizationKey.QueenFormFirstNameLabel]: 'First name',
    [MyHiveLocalizationKey.QueenFormLastNameLabel]: 'Last name',
    [MyHiveLocalizationKey.QueenFormCompanyLabel]: 'Company',
    [MyHiveLocalizationKey.QueenFormFirstNameRequired]: 'First name is required',
    [MyHiveLocalizationKey.QueenFormLastNameRequired]: 'Last name is required',
    [MyHiveLocalizationKey.QueenFormCompanyRequired]: 'Company is required',
    [MyHiveLocalizationKey.QueenFormSubmitting]: 'Submitting…',
    [MyHiveLocalizationKey.QueenFormSubmit]: 'Submit Name',
    [MyHiveLocalizationKey.QueenFormViewSubmissions]: 'View submitted names',
    [MyHiveLocalizationKey.QueenFormSubmitError]: 'Could not submit your nomination. Please try again.',
    [MyHiveLocalizationKey.QueenFormProfileError]: 'Could not update your profile. Please try again.',
    [MyHiveLocalizationKey.QueenSignInTitle]: 'Join the hive to submit your idea 👑',
    [MyHiveLocalizationKey.QueenSignInTitleViewSubmissions]: 'Join the hive to view name submissions',
    [MyHiveLocalizationKey.QueenSignInMessage]: "We'll bring you right back to finish your submission.",
    [MyHiveLocalizationKey.QueenSignInMessageViewSubmissions]: "We'll bring you right back to view the names.",
    [MyHiveLocalizationKey.QueenSubmittedTitle]: 'Name Submitted!',
    [MyHiveLocalizationKey.QueenSubmittedMessage]: 'The hive has received your royal submission.',
    [MyHiveLocalizationKey.QueenSubmittedYourSuggestion]: 'Your suggestion',
    [MyHiveLocalizationKey.QueenSubmittedViewBoard]: 'View All Names & Votes',
    [MyHiveLocalizationKey.QueenInviteColleagueButton]: 'Invite a colleague',
    [MyHiveLocalizationKey.QueenInviteColleagueDescription]:
      'Share this hive with someone else who might want to suggest a royal name.',
    [MyHiveLocalizationKey.QueenInviteSending]: 'Sending…',
    [MyHiveLocalizationKey.QueenInviteSent]: 'Invite sent!',
    [MyHiveLocalizationKey.QueenInviteSendButton]: 'Send invite',
    [MyHiveLocalizationKey.QueenInviteError]: 'Something went wrong. Please try again.',
    [MyHiveLocalizationKey.QueenSubmittedStaticMessage]:
      "Thanks for submitting! We'll let you know once a name has been chosen.",
    [MyHiveLocalizationKey.QueenVotingTitle]: 'The Royal Naming Board',
    [MyHiveLocalizationKey.QueenVotingSubtitle]: 'Upvote your favorites! The most popular name wins',
    [MyHiveLocalizationKey.QueenNoSubmissionsYet]: 'No submissions yet',
    [MyHiveLocalizationKey.QueenBeFirstToSubmit]: 'Be the first to submit a royal name! 👑',
    [MyHiveLocalizationKey.QueenAdminVotingTitle]: 'Submitted Names',
    [MyHiveLocalizationKey.QueenAdminVotingSubtitleVoting]: 'Crown your queen — informed by community votes.',
    [MyHiveLocalizationKey.QueenAdminVotingSubtitleNoVoting]: 'Crown your queen from the community submissions below.',
    [MyHiveLocalizationKey.QueenAdminCrownButton]: 'Crown',
    [MyHiveLocalizationKey.QueenAdminCrownAriaLabel]: 'Crown {{name}}',
    [MyHiveLocalizationKey.QueenAdminBackToSettings]: 'Back to election settings',
    [MyHiveLocalizationKey.QueenConfirmTitle]: 'Crown the Queen?',
    [MyHiveLocalizationKey.QueenConfirmMessage]: 'This ends the election and announces the winner to all subscribers.',
    [MyHiveLocalizationKey.QueenConfirmSelectedName]: 'Selected name',
    [MyHiveLocalizationKey.QueenConfirmNominatedBy]: 'Nominated by',
    [MyHiveLocalizationKey.QueenConfirmVotesSingular]: '{{count}} vote',
    [MyHiveLocalizationKey.QueenConfirmVotesPlural]: '{{count}} votes',
    [MyHiveLocalizationKey.QueenConfirmSubmit]: 'Confirm & Crown',
    [MyHiveLocalizationKey.QueenConfirmSubmitting]: 'Crowning…',
    [MyHiveLocalizationKey.QueenConfirmError]: 'Could not crown this candidate. Please try again.',
    [MyHiveLocalizationKey.QueenConfirmFinalTitle]: 'Are you sure?',
    [MyHiveLocalizationKey.QueenConfirmFinalMessage]:
      'This will end the election and notify all subscribers. This action cannot be undone.',
    [MyHiveLocalizationKey.QueenConfirmFinalSubmit]: 'Yes, crown the Queen',
    [MyHiveLocalizationKey.QueenWinnerTitle]: 'All Hail the Queen',
    [MyHiveLocalizationKey.QueenWinnerSubtitle]: 'The hive has spoken.',
    [MyHiveLocalizationKey.QueenWinnerNamePrefix]: "Our queen's name is...",
    [MyHiveLocalizationKey.QueenWinnerCrownedWithVotesSingular]: 'Crowned with {{count}} vote',
    [MyHiveLocalizationKey.QueenWinnerCrownedWithVotesPlural]: 'Crowned with {{count}} votes',
    [MyHiveLocalizationKey.QueenWinnerCrownedByCommunity]: 'Crowned by our community',
    [MyHiveLocalizationKey.QueenAdminHomeTitle]: 'Manage Your Queen Naming Contest',
    [MyHiveLocalizationKey.QueenAdminWinnerChosen]: 'Winner chosen',
    [MyHiveLocalizationKey.QueenAdminWinnerNominatedBy]: 'Nominated by {{initials}} · {{organization}}',
    [MyHiveLocalizationKey.QueenAdminDeadlineMessage]: 'Subscribers have until {{date}} to submit names.',
    [MyHiveLocalizationKey.QueenAdminNoDeadlineMessage]:
      'Set a deadline and crown your winner once submissions are in.',
    [MyHiveLocalizationKey.QueenAdminDeadlineLabel]: 'Submission deadline',
    [MyHiveLocalizationKey.QueenAdminDeadlineTooltip]:
      "We'll notify subscribers of the deadline, send reminders, and prompt you to crown a winner 👑",
    [MyHiveLocalizationKey.QueenAdminDeadlineSetButton]: 'Set Deadline',
    [MyHiveLocalizationKey.QueenAdminDeadlineUpdateButton]: 'Update Deadline',
    [MyHiveLocalizationKey.QueenAdminDeadlineSaving]: 'Saving…',
    [MyHiveLocalizationKey.QueenAdminDeadlineError]: 'Could not save the deadline. Please try again.',
    [MyHiveLocalizationKey.QueenAdminShareWithTenants]: 'Share with tenants',
    [MyHiveLocalizationKey.QueenAdminShareDeadlineRequired]: 'Set a deadline before inviting tenants',
    [MyHiveLocalizationKey.QueenAdminUpdateDeadlineConfirmTitle]: 'Update deadline?',
    [MyHiveLocalizationKey.QueenAdminUpdateDeadlineConfirmMessage]:
      'Updating your deadline will trigger a new deadline notification to page subscribers.',
    [MyHiveLocalizationKey.QueenAdminSuggestNameLabel]: 'Suggest a name yourself',
    [MyHiveLocalizationKey.QueenCountdownClosed]: 'Election closed',
    [MyHiveLocalizationKey.QueenCountdownDaysSingular]: '🗓️ {{count}} day until election day',
    [MyHiveLocalizationKey.QueenCountdownDaysPlural]: '🗓️ {{count}} days until election day',
    [MyHiveLocalizationKey.QueenShareTenantsHeading]: 'Invite your community to help name your Queen Bee!',
    [MyHiveLocalizationKey.QueenShareTenantsSubheading]:
      'Share the engagement opportunity with your tenant network and main tenant contacts so everyone can join in.',
    [MyHiveLocalizationKey.QueenShareTenantsFallbackSomeone]: 'Someone',
    [MyHiveLocalizationKey.QueenShareTenantsFallbackHive]: 'our hive',
    [MyHiveLocalizationKey.QueenShareTenantsDefaultMessage]: `{{senderName}} wants you to help name the Queen! 👑🐝

Our hive at {{pageTitle}} has a hardworking Queen Bee… and she needs a name! We're asking our community to submit royal name ideas and vote on their favorites on our Alvéole page.

Whether you go clever, classic, or completely unexpected, we can't wait to see what you come up with. The winning name will be announced soon! 🎉`,
    [MyHiveLocalizationKey.WorkshopsTitle]: 'Events',
    [MyHiveLocalizationKey.WorkshopsButton]: 'Watch video',
    [MyHiveLocalizationKey.WorkShopsInfo1Title]: 'Have booking questions?',
    [MyHiveLocalizationKey.WorkShopsInfo1Description]:
      "Not finding a date, time or workshop that fits your needs? Don't hesitate to contact support@alveole.buzz",
    [MyHiveLocalizationKey.WorkShopsInfo2Title]: 'Modify / Cancel',
    [MyHiveLocalizationKey.WorkShopsInfo2Description]:
      'To modify or cancel a workshop, refer to your confirmation email.',
    [MyHiveLocalizationKey.RequestWorkshopTitle]: 'Request a workshop',
    [MyHiveLocalizationKey.RequestWorkshopDescription]:
      "Can't find a timeslot that works? Submit a request and we'll do our best to accommodate you.",
    [MyHiveLocalizationKey.RequestWorkshopDescriptionPre]: "Can't find a timeslot that works? Submit a ",
    [MyHiveLocalizationKey.RequestWorkshopDescriptionLink]: 'request',
    [MyHiveLocalizationKey.RequestWorkshopDescriptionPost]: " and we'll do our best to accommodate you.",
    [MyHiveLocalizationKey.RequestWorkshopTypePlaceholder]: 'Select a workshop type',
    [MyHiveLocalizationKey.RequestWorkshopDateLabel]: 'Preferred date and time',
    [MyHiveLocalizationKey.RequestWorkshopSubmit]: 'Submit request',
    [MyHiveLocalizationKey.RequestWorkshopSuccess]: 'Your workshop request has been submitted successfully!',
    [MyHiveLocalizationKey.DownloadsTitle]: 'Promotional toolkit',
    [MyHiveLocalizationKey.DownloadsDescription]:
      'Everything you need to promote your biodiversity program—right at your fingertips. Browse and download from our wide selection of promotional materials.',
    [MyHiveLocalizationKey.DownloadsPartnersTitle]: 'Partnership announcement',
    [MyHiveLocalizationKey.DownloadsPartnersDescription]:
      'Everything you need to announce your Alvéole partnership: customizable posters, email templates, and social media templates.',
    [MyHiveLocalizationKey.DownloadsWorkshopPromotionTitle]: 'Workshop promotion',
    [MyHiveLocalizationKey.DownloadsWorkshopPromotionDescription]:
      'Everything you need to promote your next Alvéole workshop: customizable posters for print or digital use and email templates.',
    [MyHiveLocalizationKey.DownloadsSpecialHolidayTitle]: 'Special holidays',
    [MyHiveLocalizationKey.DownloadsSpecialHolidayDescription]:
      'Social media templates to celebrate Earth Day, Pollinator Week, and World Bee Day.',
    [MyHiveLocalizationKey.DownloadsAveoleMediaKitTitle]: 'Alvéole media kit',
    [MyHiveLocalizationKey.DownloadsAveoleMediaKitDescription]:
      'Everything you need to know about Alvéole: Who we are, urban beekeeping facts, company logo, and photo bank.',
    [MyHiveLocalizationKey.DownloadsButton]: 'Download',

    [MyHiveLocalizationKey.PreferencesTitle]: 'Account Settings',
    [MyHiveLocalizationKey.PreferencesTabTeam]: 'Team',
    [MyHiveLocalizationKey.PreferencesTabManagement]: 'Page',
    [MyHiveLocalizationKey.PreferencesHiveName]: 'MyHive name',
    [MyHiveLocalizationKey.PreferencesHiveNameDescription]: 'This is used on public pages and in buzzes.',
    [MyHiveLocalizationKey.PreferencesHiveDescription]: 'MyHive description',
    [MyHiveLocalizationKey.PreferencesHiveDescriptionDescription]:
      "The description is shown under your project's name on the main MyHive tab.",
    [MyHiveLocalizationKey.PreferencesHivePermalink]: 'Friendly permalink',
    [MyHiveLocalizationKey.PreferencesHivePermalinkDescription]:
      "Customize your hive's URL. Just the bit after the last “/” in your URL, lowercase with hyphens.",
    [MyHiveLocalizationKey.PreferencesHivePermalinkFormatErrorMessage]:
      'Only lowercase letters, numbers, and hyphens—no spaces or full URLs.',
    [MyHiveLocalizationKey.PerferencesLanguage]: 'Language of communication',
    [MyHiveLocalizationKey.PreferencesVisibility]: 'Should this page appear in public search results?',
    [MyHiveLocalizationKey.PreferencesQRCode]: 'QR Code',
    [MyHiveLocalizationKey.PreferencesQRCodeDescription]:
      'This QR code points directly to your MyHive page! Include it on signage, in newsletters, on screens. Click below for a high-resolution version to save. Be sure to test the code before printing!',
    [MyHiveLocalizationKey.PreferencesLogoUploadTitle]: 'Logo Upload',
    [MyHiveLocalizationKey.PreferencesLogoUploadDescription]:
      'Upload your logo for use on branded materials such as signage, honey and product labels. High resolution PNG or SVG files are recommended.',
    [MyHiveLocalizationKey.PreferencesLogoUploadChooseFile]: 'Choose file',
    [MyHiveLocalizationKey.PreferencesLogoUploadError]: 'Failed to upload logo. Please try again.',
    [MyHiveLocalizationKey.PreferencesManagementDescription]:
      'This hive project can be managed by as many colleagues as you like. Hive editors are able to contribute buzzes and media, customize the hive, and schedule workshops.',
    [MyHiveLocalizationKey.PreferencesResendInvitation]: 'Resend a MyHive invite email',
    [MyHiveLocalizationKey.PreferencesRemoveUser]: "Remove this user's authorization",
    [MyHiveLocalizationKey.PreferencesVisitReminder]: 'Get email reminders for upcoming visits',
    [MyHiveLocalizationKey.PreferencesBuzzReminder]: 'Get email alerts for new buzz posts',
    [MyHiveLocalizationKey.PreferencesVisible]: 'Visible',
    [MyHiveLocalizationKey.PreferencesUnlisted]: 'Unlisted',

    [MyHiveLocalizationKey.EmailAddress]: 'Email address',
    [MyHiveLocalizationKey.FirstName]: 'First name',
    [MyHiveLocalizationKey.LastName]: 'Last name',
    [MyHiveLocalizationKey.AddUser]: 'Add user',
    [MyHiveLocalizationKey.Phone]: 'Phone',
    [MyHiveLocalizationKey.MobilePhone]: 'Mobile phone',
    [MyHiveLocalizationKey.Role]: 'Role',
    [MyHiveLocalizationKey.ThisFieldIsRequired]: 'This field is required',
    [MyHiveLocalizationKey.ApiError]: 'An error occurred, please try again.',
    [MyHiveLocalizationKey.SlugUnavailable]: 'Your new hive url may not be available.',
    [MyHiveLocalizationKey.PreferencesMainContact]: 'Main contact',
    [MyHiveLocalizationKey.PreferencesHiveContact]: 'Site contact',
    [MyHiveLocalizationKey.PreferencesMainContactDescription]:
      'Responsible for core program management, including contracts, event booking, and label approval.',
    [MyHiveLocalizationKey.PreferencesHiveContactDescription]: 'On site contact for routine visits.',
    [MyHiveLocalizationKey.PreferencesEditMainContactHint]: 'To change your main contact, click the "change" button',
    [MyHiveLocalizationKey.PreferencesAdditionalContacts]: 'Additional contacts:',
    [MyHiveLocalizationKey.PreferencesAdditionalContactsDescription]:
      'Team members who can view and support your program alongside you.',

    [MyHiveLocalizationKey.PreferencesSavedSucessHeader]: 'Successfully Saved Preferences!',

    [MyHiveLocalizationKey.MissingFieldsAlertHeader]: 'Missing Required Fields',
    [MyHiveLocalizationKey.MissingFieldsAlertDescription]: 'Please complete or correct the required fields.',

    [MyHiveLocalizationKey.HighlightedEventLabel]: 'Highlighted Event',
    [MyHiveLocalizationKey.ReadMore]: 'Read More',

    [MyHiveLocalizationKey.EventListSubscriberCountLabel]: 'interested in events',
    [MyHiveLocalizationKey.HoneyListSubscriberCountLabel]: 'interested in honey',

    [MyHiveLocalizationKey.PageSubscribeModalHeader]: 'Stay up to date with the bees',
    [MyHiveLocalizationKey.PageSubscribeModalText]:
      'Be the first to know about new beekeeper posts, upcoming events and honey jars.',

    [MyHiveLocalizationKey.SubscribeSucess]: 'Hive subscription confirmed!',
    [MyHiveLocalizationKey.ThanksSubscribe]: 'Thanks! You’ll now receive updates on the latest buzz.',
    [MyHiveLocalizationKey.WorkBestieSubscribe]:
      'Know someone who’d enjoy following the bees too? Invite them to subscribe.',

    [MyHiveLocalizationKey.Register]: 'Register',
    [MyHiveLocalizationKey.RegisterAlmostThere]: 'One last step before you can register',
    [MyHiveLocalizationKey.RegisterSuccess]: "You're registered!",
    [MyHiveLocalizationKey.Registered]: 'Registered',
    [MyHiveLocalizationKey.Attended]: 'Attended',
    [MyHiveLocalizationKey.RegisteredCountLabel]: 'registered',

    [MyHiveLocalizationKey.InviteColleague]: 'Want company? Invite a colleague',
    [MyHiveLocalizationKey.SendInvite]: 'Send Invite',
    [MyHiveLocalizationKey.Sending]: 'Sending...',

    [MyHiveLocalizationKey.Warning]: 'Warning',
    [MyHiveLocalizationKey.CancelRegistration]: 'Cancel Registration',
    [MyHiveLocalizationKey.Cancelling]: 'Cancelling...',
    [MyHiveLocalizationKey.WarningRegistrationCancel]: 'You are about to cancel your registration',

    [MyHiveLocalizationKey.SeatsLeft]: 'seats left',
    [MyHiveLocalizationKey.AtCapacity]: 'At Capacity',

    [MyHiveLocalizationKey.FirstNameRequired]: 'First Name is Required',
    [MyHiveLocalizationKey.LastNameRequired]: 'Last Name is Required',
    [MyHiveLocalizationKey.OrgNameRequired]: 'Organization Name is Required',

    [MyHiveLocalizationKey.SomethingWentWrong]: 'Something Went Wrong',

    [MyHiveLocalizationKey.FailedToUpdateProfile]: 'Failed to update profile. Please try again.',

    [MyHiveLocalizationKey.FailedToRegisterForEvent]: 'Failed to register for event. Please try again.',
    [MyHiveLocalizationKey.FailedToUnregisterEvent]: 'Failed to unregister from event. Please try again.',

    [MyHiveLocalizationKey.EventRegistration]: 'Event Registration',

    //Event registration info

    [MyHiveLocalizationKey.EffortlessRegistration]: 'Effortless event registration',
    [MyHiveLocalizationKey.HowItWorks]: 'How it works',

    [MyHiveLocalizationKey.EasyRegistrationSectionHeader]: 'Easy registration, right on MyHive',
    [MyHiveLocalizationKey.EasyRegistrationSectionText]:
      'Your event details and registration button appear directly on your MyHive page, making it simple for your community to find and sign up. To promote your event, simply share your MyHive link.',

    [MyHiveLocalizationKey.InviteSubscribersSectionHeader]: 'We’ll invite your subscribers',
    [MyHiveLocalizationKey.InviteSubscribersSectionText]:
      'All page subscribers who’ve opted in for event notifications will automatically get an invitation with a link to your MyHive page to register.',

    [MyHiveLocalizationKey.AutomaticRemindersSectionHeader]: 'Automatic reminders & updates',
    [MyHiveLocalizationKey.AutomaticRemindersSectionText]:
      'Attendees receive a confirmation email and a series of reminders leading up to the event. They can update their RSVP anytime through your MyHive page, and if you modify or cancel the event, we’ll notify them automatically.',

    [MyHiveLocalizationKey.RealTimeTrackingSectionHeader]: 'Real-time tracking',
    [MyHiveLocalizationKey.RealTimeTrackingSectionText]:
      'The tool monitors capacity limits and keeps you updated with registration numbers in real time. You can view and download a list of registrants at any time on the event card your MyHive feed.',

    [MyHiveLocalizationKey.PromoteWorkshopCta]: 'Promote your workshop',

    [MyHiveLocalizationKey.ShareMyHivePageHeader]: 'Share your MyHive page!',
    [MyHiveLocalizationKey.ShareMyHivePageText]:
      'When you book an event, the details and registration button automatically appear on your public MyHive feed. To promote your event, share the link to your page and direct people there to register. You can copy your MyHive page’s URL from the top of your browser, or download your dedicated QR code in Settings.',

    [MyHiveLocalizationKey.PromoKitTemplatesHeader]: 'Use ready-made templates',
    [MyHiveLocalizationKey.PromoKitTemplatesText]:
      'Head to the Promo kit tab for eye-catching, customizable designs and event invitations. Whether you need a snazzy image for a newsletter, a poster for the lobby, or a file for your building’s screens, we’ve got you covered.',

    [MyHiveLocalizationKey.QrCodeHeader]: 'Download and share your page’s QR code',
    [MyHiveLocalizationKey.QrCodeText]:
      'Give your community a quick way in! Pop your page’s QR code onto posters or invites, it’s scannable in seconds on any phone. Download your QR code anytime in Settings and share away.',

    [MyHiveLocalizationKey.RegistrationDefaultNote]:
      'By default, registration is turned on for every event. You can disable it anytime in ',
    [MyHiveLocalizationKey.Settings]: 'Settings',
    [MyHiveLocalizationKey.NatureAgent]: 'Nature Agent',

    [MyHiveLocalizationKey.Integrations]: 'Integrations',
    [MyHiveLocalizationKey.TenantApps]: 'Tenant apps',
    [MyHiveLocalizationKey.DigitalScreensAndSignage]: 'Digital screens & signage',
    [MyHiveLocalizationKey.TenantAppsHeader]:
      'Adding your building’s Alvéole page to your tenant app (VTS, HqO, ZO, etc.) is quick and easy. Tenants can then explore your bees and biodiversity program right alongside their building updates and amenities.',
    [MyHiveLocalizationKey.TenantAppsDropdownHeader]: 'How to add your Alvéole page to tenant apps',

    [MyHiveLocalizationKey.TenantAppsYoullNeedHeader]: 'You’ll need (all included below):',
    [MyHiveLocalizationKey.TenantAppsRequirementUrl]: 'Your building’s Alvéole page URL',
    [MyHiveLocalizationKey.TenantAppsRequirementImage]: 'A widget image',
    [MyHiveLocalizationKey.TenantAppsRequirementNameDesc]: 'A name & short description',
    [MyHiveLocalizationKey.TenantAppsWebviewHowToHeader]: 'How to integrate as a webview / URL:',
    [MyHiveLocalizationKey.TenantAppsWebviewWhatIs]:
      'Webview integrations allow you to link to a third-party webpage, while keeping the user in your app.',
    [MyHiveLocalizationKey.TenantAppsStepLogin]:
      '**Log into your tenant platform** and navigate to the section where you **add a new “Service,” “Resource” or “Widget.”**',
    [MyHiveLocalizationKey.TenantAppsStepUploadImage]:
      '**Upload the widget image** provided below (choose a square or rectangle depending on the app’s requirements).',
    [MyHiveLocalizationKey.TenantAppsStepPasteUrl]: '**Paste in your Alvéole URL**, provided below.',
    [MyHiveLocalizationKey.TenantAppsStepAddNameDesc]:
      '**Add a name and description**; use our suggested option below, or customize your own.',
    [MyHiveLocalizationKey.TenantAppsStepSavePublish]:
      '**Save and publish!** Your tenants will now see “Alvéole” or “MyHive” in their app.',
    [MyHiveLocalizationKey.TenantAppsNote]:
      'Note: Steps may vary slightly by platform, but with the URL, image, and copy provided here, you’re ready to launch Alvéole on anywhere.',

    [MyHiveLocalizationKey.IntegrationKit]: 'Integration kit',

    [MyHiveLocalizationKey.TenantAppsUrlLabel]: 'Alvéole page URL:',
    [MyHiveLocalizationKey.TenantAppsUrlHelp]:
      'This is the link to your public-facing MyHive page, where tenants can sign up for events, see biodiversity updates and more.',
    [MyHiveLocalizationKey.TenantAppsSuggestedDescHeader]: 'Suggested description',
    [MyHiveLocalizationKey.TenantAppsSuggestedDescHelp]:
      'Include a brief description for your Alvéole – MyHive widget.',
    [MyHiveLocalizationKey.TenantAppsSuggestedDescExample]:
      'Discover events, updates, and harvests from our bees and biodiversity program.',

    [MyHiveLocalizationKey.TenantAppsWidgetsHeader]: 'Widget / Icon images',
    [MyHiveLocalizationKey.TenantAppsWidgetsDesc]: 'Pre-sized files to use as the icon for your Alvéole widget.',

    [MyHiveLocalizationKey.Profile]: 'Profile',
    [MyHiveLocalizationKey.ChangePassoword]: 'Change Password',
    [MyHiveLocalizationKey.SignOut]: 'Sign Out',

    [MyHiveLocalizationKey.WeWillSendToEmail]: 'We will send an email to:',
    [MyHiveLocalizationKey.SendToEmail]: 'Send to Email',

    [MyHiveLocalizationKey.Tagline]: 'Tagline',
    [MyHiveLocalizationKey.TaglineDescription]:
      'Your tagline, or bio, will appear to the public on your hive posts. It can be your job title, or just something short and catchy!',
    [MyHiveLocalizationKey.BeekeeperBio]: 'Beekeeper bio',
    [MyHiveLocalizationKey.BeekeeperBioDescription]: 'As a beekeeper, a longer bio might be presented to your clients',
    [MyHiveLocalizationKey.ProfilePhoto]: 'Profile Photo',
    [MyHiveLocalizationKey.ProfileIntro]:
      'Let others know all about you! Your profile will be visible when you create buzzes or add photos to a gallery.',
    [MyHiveLocalizationKey.Saving]: 'Saving...',

    [MyHiveLocalizationKey.ShareOnLinkedin]: 'Share on LinkedIn',

    [MyHiveLocalizationKey.YearEndHeader]: 'A look back at 2025!',
    [MyHiveLocalizationKey.Caption]: 'Caption',
    [MyHiveLocalizationKey.CaptionHint]: 'Customize the caption for your LinkedIn post',

    [MyHiveLocalizationKey.RequestedReport]: `This report type isn't yet available on demand. Your request has been submitted and our team is working on it!`,
    [MyHiveLocalizationKey.YouWillReceiveEmail]: `You will receive an email once it's ready for you.`,

    [MyHiveLocalizationKey.Loading]: 'Loading',
    [MyHiveLocalizationKey.ChatBotWelcomeMessage]:
      'Ask me anything about your nature data. I use information from your specific site so answers are tailored to you and never shared with others.',
    [MyHiveLocalizationKey.ChatBotDisclaimerMessage]:
      'This content was generated using AI and may contain mistakes or inaccuracies.',
    [MyHiveLocalizationKey.ChatBotInputPlaceholder]: 'What is Mean Species Abundance and why does it matter?',
    [MyHiveLocalizationKey.NoMatchesFor]: 'No matches for',

    [MyHiveLocalizationKey.OnRequest]: 'On request',
    [MyHiveLocalizationKey.StartTypingToSearch]: 'Start typing to search...',

    [MyHiveLocalizationKey.Conversations]: 'Conversations',
    [MyHiveLocalizationKey.NewConversation]: 'New conversation',

    [MyHiveLocalizationKey.ReportsSmartReportsTitle]: 'Smart Reports',
    [MyHiveLocalizationKey.ReportsRequestButton]: 'Report request',
    [MyHiveLocalizationKey.ReportsLoadingTitle]: 'Loading...',
    [MyHiveLocalizationKey.ReportsLoadingSubtitle]: 'Nature is getting your insights in bloom...',

    [MyHiveLocalizationKey.ReportsPortfolioPlaceholder]: 'Portfolio',

    [MyHiveLocalizationKey.ReportsPreviouslyGeneratedReportsTitle]: 'Previously Generated Reports',

    [MyHiveLocalizationKey.ReportsPortfolioOptionTitle]: 'Portfolio',
    [MyHiveLocalizationKey.ReportsPortfolioOptionDesc]: 'Data from all of your sites together',

    [MyHiveLocalizationKey.PaginationShowing]: 'Showing',
    [MyHiveLocalizationKey.PaginationTo]: 'to',
    [MyHiveLocalizationKey.PaginationOf]: 'of',
    [MyHiveLocalizationKey.PaginationResults]: 'results',

    [MyHiveLocalizationKey.PaginationFirstPage]: 'First page',
    [MyHiveLocalizationKey.PaginationPreviousPage]: 'Previous page',
    [MyHiveLocalizationKey.PaginationNextPage]: 'Next page',
    [MyHiveLocalizationKey.PaginationLastPage]: 'Last page',

    [MyHiveLocalizationKey.Request]: 'Request',
    [MyHiveLocalizationKey.ReportsTableNoReports]: 'No reports yet for this type.',

    [MyHiveLocalizationKey.Report]: 'Report',
    [MyHiveLocalizationKey.Asset]: 'Asset',
    [MyHiveLocalizationKey.Date]: 'Date',

    [MyHiveLocalizationKey.PortfolioAllSites]: 'Portfolio (All Sites)',
    [MyHiveLocalizationKey.PortfolioAllSitesDescription]: 'Data from all of your sites together',

    [MyHiveLocalizationKey.Download]: 'Download',
    [MyHiveLocalizationKey.DownloadList]: 'Download list',
    [MyHiveLocalizationKey.RequestReportErrorGenerating]:
      'Something went wrong while generating your report. Retry — if errors persist, contact support@alveole.buzz.',

    [MyHiveLocalizationKey.Generating]: 'Generating',
    [MyHiveLocalizationKey.RequestReportGenerating]: 'Gathering insights from space, sea, and soil…',
    [MyHiveLocalizationKey.RequestReportGenerated]: 'Your report has been generated!',
    [MyHiveLocalizationKey.RequestReportDownloadAria]: 'Download report',

    [MyHiveLocalizationKey.SubmitRequest]: 'Submit Request',
    [MyHiveLocalizationKey.Submit]: 'Submit',

    [MyHiveLocalizationKey.Format]: 'Format',
    [MyHiveLocalizationKey.Language]: 'Language',

    [MyHiveLocalizationKey.GeneratingReportLine]: 'Gathering insights from space, sea, and soil...',

    [MyHiveLocalizationKey.UpdateContactSettings]: 'Update contact settings',
    [MyHiveLocalizationKey.UnreachableEmailsDescription]:
      'team emails are currently unreachable. Please navigate to your hive settings to update their details',

    [MyHiveLocalizationKey.TakeMeToSettings]: 'Take me to my settings',
    [MyHiveLocalizationKey.UnreachableEmailsCountPlural]: 'team emails are currently unreachable',
    [MyHiveLocalizationKey.UnreachableEmailsCountSingular]: 'team email is currently unreachable',
    [MyHiveLocalizationKey.EmailIsUnreachable]: 'Email is unreachable',

    [MyHiveLocalizationKey.SMSDeliveredHere]: 'SMS visit reminders sent here',

    [MyHiveLocalizationKey.InvalidPhoneNumber]:
      'Invalid phone number — include the country code, e.g. +33 6 12 34 56 78',
    [MyHiveLocalizationKey.InvalidEmail]: 'Invalid email address',

    [MyHiveLocalizationKey.UnknownPhoneNumberStatus]:
      'Unknown phone number reachability status. This field will update the next time this user is sent an SMS. Double check the number is correct and formatted properly.',

    [MyHiveLocalizationKey.InstallationComingUpText]: 'Bees arrive on onsite',
    [MyHiveLocalizationKey.BeekeepingComingUpText]: 'Routine beekeeper visit',
    [MyHiveLocalizationKey.HoneyJarsComingUpText]: 'Jars arrive onsite',
    [MyHiveLocalizationKey.HoneyHarvestComingUpText]: 'Annual honey harvest',

    [MyHiveLocalizationKey.HTHJEventComingUp]: 'Honey extraction event',
    [MyHiveLocalizationKey.MeetYourBeesEventComingUp]: 'Live hive opening',
    [MyHiveLocalizationKey.MeetYourBeekeeperEventComingUp]: 'Beekeeper meet and greet',
    [MyHiveLocalizationKey.WondersOfWaxEventComingUp]: 'Candlemaking event',
    [MyHiveLocalizationKey.HoneyTastingEventComingUp]: 'Honey tasting event',
    [MyHiveLocalizationKey.ExploreBeesEventComingUp]: 'Special presentation event',
    [MyHiveLocalizationKey.ExploreWildEventComingUp]: 'Special presentation event',
    [MyHiveLocalizationKey.KioskEventComingUp]: 'Kiosk event',
    [MyHiveLocalizationKey.EventComingUp]: 'Special event',

    [MyHiveLocalizationKey.BeekeepingNewsText]: 'Your beekeeper was onsite for a routine check up on your bees',
    [MyHiveLocalizationKey.InstallationNewsText]: 'Bzzzz! Your bees and equipment were installed onsite.',
    [MyHiveLocalizationKey.HoneyHarvestNewsText]: 'Honey frames were harvested onsite, ready for jarring.',
    [MyHiveLocalizationKey.HoneyJarsNewsText]: 'The sweetest time of year! Your honey jars arrived onsite.',
    [MyHiveLocalizationKey.EventNewsText]: 'event hosted with /d attendees',

    [MyHiveLocalizationKey.BeekeepingNewsBadgeText]: 'Hive visited',
    [MyHiveLocalizationKey.InstallationNewsBadgeText]: 'Bees installed',
    [MyHiveLocalizationKey.HoneyHarvestNewsBadgeText]: 'Honey harvested',
    [MyHiveLocalizationKey.HoneyJarsNewsBadgeText]: 'Honey delivered',
    [MyHiveLocalizationKey.EventNewsBadgeText]: 'Event hosted',

    [MyHiveLocalizationKey.DesignRequiredLabelStatus]: 'Missing',
    [MyHiveLocalizationKey.NeedsApprovalLabelStatus]: 'Approval',
    [MyHiveLocalizationKey.InProgressLabelStatus]: 'Draft',
    [MyHiveLocalizationKey.SubmittedLabelStatus]: 'Submitted',

    [MyHiveLocalizationKey.DesignRequiredTooltipText]: 'Create your label now',
    [MyHiveLocalizationKey.NeedsApprovalTooltipText]: 'Approval Needed',
    [MyHiveLocalizationKey.InProgressTooltipText]: 'Design in progress',
    [MyHiveLocalizationKey.SubmittedTooltipText]: 'Your label is all set!',

    [MyHiveLocalizationKey.PhotoGallery]: 'Photo Gallery',
    [MyHiveLocalizationKey.PhotoGallerySubtitle]: 'Latest posts across your portfolio',

    [MyHiveLocalizationKey.PortfolioNewsfeed]: 'Portfolio Newsfeed',
    [MyHiveLocalizationKey.PortfolioNewsfeedSubtitle]: 'Recent activity across your properties',
    [MyHiveLocalizationKey.ComingUp]: 'Coming Up',

    [MyHiveLocalizationKey.Region]: 'Region',
    [MyHiveLocalizationKey.MainContact]: 'Main Contact',
    [MyHiveLocalizationKey.Package]: 'Package',
    [MyHiveLocalizationKey.Events]: 'Events',
    [MyHiveLocalizationKey.EventCredits]: 'Event Credits',
    [MyHiveLocalizationKey.Label]: 'Label',
    [MyHiveLocalizationKey.NextVisit]: 'Next Visit',

    [MyHiveLocalizationKey.TenantSubscribers]: 'Tenant Subscribers',

    [MyHiveLocalizationKey.PropertiesInPortfolio]: 'properties in portfolio',

    [MyHiveLocalizationKey.CustomizeColumns]: 'Customize Columns',
    [MyHiveLocalizationKey.InviteTenants]: 'Invite Tenants',
    [MyHiveLocalizationKey.CreditsLeft]: 'Credits Left',
    [MyHiveLocalizationKey.UpcomingVisits]: 'Upcoming Visits',

    [MyHiveLocalizationKey.YearInReview]: 'Year in Review',
    [MyHiveLocalizationKey.BiodiversityReport]: 'Biodiversity Report',
    [MyHiveLocalizationKey.NoReports]: 'No Reports',
    [MyHiveLocalizationKey.Updated]: 'Updated',
    [MyHiveLocalizationKey.TotalAssets]: 'Total Assets',
    [MyHiveLocalizationKey.PesticidesReport]: 'Pesticides Report',

    [MyHiveLocalizationKey.Growth]: 'Growth',
    [MyHiveLocalizationKey.AreaPollinated]: 'Area Pollinated',

    [MyHiveLocalizationKey.YourNextEventIsWaiting]: 'Your next event is waiting! 🎉',
    [MyHiveLocalizationKey.AllWorkshopCreditsUsed]: ' All workshop credits used! ',
    [MyHiveLocalizationKey.EventsBooked]: 'Events Booked',

    [MyHiveLocalizationKey.Invite]: 'Invite',
    [MyHiveLocalizationKey.HoneyLabel]: 'Honey Label',

    [MyHiveLocalizationKey.PostPhotos]: 'Post Photos',
    [MyHiveLocalizationKey.PostVideos]: 'Post Video',
    [MyHiveLocalizationKey.LinkedInChooseHeader]: 'This Buzz has photos and a video — choose:',
    [MyHiveLocalizationKey.LinkedInChooseDescription]:
      'Video will post the first video only. Photos will attempt to post all photos.',

    [MyHiveLocalizationKey.GetFamiliar]: 'Get Familiar',
    [MyHiveLocalizationKey.GetFamiliarTitleOne]: 'Your control center',
    [MyHiveLocalizationKey.GetFamiliarTextOne]:
      'Your sidebar lets you effortlessly navigate between your buildings and tools',

    [MyHiveLocalizationKey.GetFamiliarTitleTwo]: 'Public tenant page',
    [MyHiveLocalizationKey.GetFamiliarTextTwo]:
      'A public page for your bees! \n \n Tenants stay engaged with regular updates from your beekeeper',
    [MyHiveLocalizationKey.GetFamiliarTitleThree]: 'Tenants can register',
    [MyHiveLocalizationKey.GetFamiliarTextThree]:
      'Tenants can register for nature events, subscribe to updates and sign up for honey',

    [MyHiveLocalizationKey.LetsGrow]: "Let's grow",
    [MyHiveLocalizationKey.LetsGrowTitleOne]: 'Bring your community in',
    [MyHiveLocalizationKey.LetsGrowTextOne]:
      'Easily upload emails and invite tenants to follow along, sign up and take part.',
    [MyHiveLocalizationKey.LetsGrowTitleTwo]: 'Create experiences that stand out',
    [MyHiveLocalizationKey.LetsGrowTextTwo]: 'Easily book our trademark events that keep tenants engaged.',
    [MyHiveLocalizationKey.LetsGrowTitleThree]: 'Seamless event registration',
    [MyHiveLocalizationKey.LetsGrowextThree]: 'Notify subscribers automatically and make event sign-up simple.',
    [MyHiveLocalizationKey.LetsGrowTitleFour]: 'You’re all set 🎉',
    [MyHiveLocalizationKey.LetsGrowextFour]:
      'Your program is ready to grow.\n\nUse this checklist to keep the momentum going.',

    [MyHiveLocalizationKey.LivingBusiness]: 'You’re running a living building.',
    [MyHiveLocalizationKey.ConnectNatureTenants]: 'Connect nature, tenants, and impact in one program.',
    [MyHiveLocalizationKey.ControlCenter]: 'This is your Control Centre',
    [MyHiveLocalizationKey.AllInOnePlace]:
      'Manage your program, access reports, plan events, and share your impact, all in one place.',
    [MyHiveLocalizationKey.TenantsToPage]: 'Invite tenants to your page',
    [MyHiveLocalizationKey.ToDoTenantStuff]:
      'To follow hive updates, join events, and share in harvest moments tied to your building.',
    [MyHiveLocalizationKey.HostEvents]: 'Host unforgettable nature events',
    [MyHiveLocalizationKey.EasilyBook]: 'Easily book events that make your property stand out',

    [MyHiveLocalizationKey.InviteTenantsNow]: 'Invite tenants now',
    [MyHiveLocalizationKey.BookEventNow]: 'Book your free event now!',

    [MyHiveLocalizationKey.Next]: 'Next',
    [MyHiveLocalizationKey.Finish]: 'Finish!',

    [MyHiveLocalizationKey.MakeItYourOwn]: 'Make it your own',
    [MyHiveLocalizationKey.MaximizeImpact]: 'Maximize impact',

    [MyHiveLocalizationKey.StartHere]: 'Start here',
    [MyHiveLocalizationKey.LearnHowToGrow]: 'Learn how to manage and grow your program',
    [MyHiveLocalizationKey.InviteYourTenants]: 'Invite your tenants',
    [MyHiveLocalizationKey.InviteYourTenantsToRegisterEvent]: 'Invite your tenants to register!',
    [MyHiveLocalizationKey.ShareYourPage]: 'Share your page with main contacts',
    [MyHiveLocalizationKey.BookAlveoleEvent]: 'Book an Alvéole event',
    [MyHiveLocalizationKey.HostedByBeekeeper]: 'Hosted by your beekeeper',

    [MyHiveLocalizationKey.EventsLeft]: 'more free events to book!',
    [MyHiveLocalizationKey.EventLeft]: 'more free event to book!',

    [MyHiveLocalizationKey.HoneyLabelDontWorry]: "Don't worry! Creating a new design won't delete your existing label.",
    [MyHiveLocalizationKey.HoneyLabelError]:
      'Access to your honey label will be available soon! If you have any questions, feel free to reach out to support@alveole.buzz',
    [MyHiveLocalizationKey.ChangeImage]: 'Change Image',
    [MyHiveLocalizationKey.ShareSoCanRegister]: 'Share your MyHive page so they can register too',

    [MyHiveLocalizationKey.AlveoleEvent]: 'Alvéole event',
    [MyHiveLocalizationKey.CheckOutPage]: "Check out your bee's page!",
    [MyHiveLocalizationKey.RegisterForEvent]: 'Sign in for the Event',
    [MyHiveLocalizationKey.Company]: 'Company',
    [MyHiveLocalizationKey.AllSet]: 'All Set',

    [MyHiveLocalizationKey.ScanList]: 'Scan a list',
    [MyHiveLocalizationKey.Scanning]: 'Scanning',
    [MyHiveLocalizationKey.Scan]: 'Scan',
    [MyHiveLocalizationKey.AddMore]: 'Add more',
    [MyHiveLocalizationKey.LoginToScanSubscriberLists]: 'Login to scan subscriber lists',

    [MyHiveLocalizationKey.KioskUnavailable]: 'Kiosk unavailable',
    [MyHiveLocalizationKey.KioskInvalid]: 'This kiosk link may be invalid, expired, or missing event data.',

    [MyHiveLocalizationKey.SelectedFile]: 'Selected file',
    [MyHiveLocalizationKey.ReviewScannedContacts]: 'Review scanned contacts',

    [MyHiveLocalizationKey.AddRow]: 'Add Row',

    [MyHiveLocalizationKey.FailedToSubmitList]: 'Failed to submit list.',
    [MyHiveLocalizationKey.ContactListSubmitted]: 'Contact list submitted successfully!',

    [MyHiveLocalizationKey.DefaulthiveDesc]:
      "We're proud to host honey bees and support local biodiversity in partnership with Alvéole.",

    [MyHiveLocalizationKey.OpenLiveReg]: 'Open live registration page',
    [MyHiveLocalizationKey.EventRegistrants]: 'Event Registrants',

    [MyHiveLocalizationKey.RegisteredForEvent]: 'Attended or Registered for an event',

    [MyHiveLocalizationKey.HoneyLabelPopupTitle]: 'Look what’s ready!',
    [MyHiveLocalizationKey.HoneyLabelPopupDescription]:
      'Your honey label is looking great! Give it a final thumbs up or edit the design before we send it to print.',
    [MyHiveLocalizationKey.EditDesign]: 'Edit design',
    [MyHiveLocalizationKey.Approve]: 'Approve',

    [MyHiveLocalizationKey.InviteColleagueTitle]: 'Know someone else who’d *love* this?',
    [MyHiveLocalizationKey.InviteColleagueDescription]:
      'Invite a colleague (or work bestie) so they don’t miss out on updates, events, or honey jars!',
    [MyHiveLocalizationKey.InviteColleagueButton]: 'Invite a colleague',
    [MyHiveLocalizationKey.InviteColleagueSuccess]: 'Invitation sent!',

    [MyHiveLocalizationKey.HoneyLabelPopupCreateTitle]: 'It’s time to design your honey label 🍯',
    [MyHiveLocalizationKey.HoneyLabelPopupCreateDescription]:
      'Start from a template, or upload your own design to bring your label to life.',
    [MyHiveLocalizationKey.GetStarted]: 'Get started',
    [MyHiveLocalizationKey.CelebrateSubscribersTitle]: 'New subscribers! 🎉',
    [MyHiveLocalizationKey.CelebrateSubscribersDescription]:
      'Your page is picking up momentum. Click your subscriber count to see who’s joined.',
    [MyHiveLocalizationKey.CreditsRemainingSingular]: 'You still have one credit to use!',
    [MyHiveLocalizationKey.CreditsRemainingPlural]: 'You still have {count} credits to use!',
    [MyHiveLocalizationKey.EventCreditsUsedTagline]: 'You’ve used all your event credits!',
    [MyHiveLocalizationKey.AdditionalBookingsFeeNote]: 'Additional bookings are subject to a fee.',
    [MyHiveLocalizationKey.CreditsUsedBannerTitleStrong]: 'You’ve used all your event credits! 🎉',
    [MyHiveLocalizationKey.CreditsUsedBannerBodyPre]:
      'Ready for more? You can book another event anytime for a fee. Book now to receive an invoice, or ',
    [MyHiveLocalizationKey.CreditsUsedBannerBodyLink]: 'reach out to our team',
    [MyHiveLocalizationKey.CreditsUsedBannerBodyPost]: ' with any questions.',

    [MyHiveLocalizationKey.TeamRemoveContactTitle]: 'Remove contact',
    [MyHiveLocalizationKey.TeamRemoveContactMessage]: 'Are you sure you want to remove {name}?',
    [MyHiveLocalizationKey.TeamDiscardChangesTitle]: 'Discard changes?',
    [MyHiveLocalizationKey.TeamDiscardChangesMessage]: 'You have unsaved changes. Switching will discard them.',
    [MyHiveLocalizationKey.TeamDiscard]: 'Discard',
    [MyHiveLocalizationKey.TeamConfirm]: 'Confirm',
    [MyHiveLocalizationKey.TeamResendInviteEmailTitle]: 'Resend invite email',
    [MyHiveLocalizationKey.TeamResendInviteEmailMessage]: 'Are you sure you want to resend the invite email?',
    [MyHiveLocalizationKey.TeamColumnContact]: 'Contact',
    [MyHiveLocalizationKey.TeamColumnRole]: 'Role',
    [MyHiveLocalizationKey.TeamColumnPhone]: 'Phone',
    [MyHiveLocalizationKey.TeamColumnVisitReminders]: 'Visit reminders',
    [MyHiveLocalizationKey.TeamColumnEmailPreferences]: 'Email preferences',
    [MyHiveLocalizationKey.TeamColumnActions]: 'Actions',
    [MyHiveLocalizationKey.TeamTitle]: 'Team',
    [MyHiveLocalizationKey.TeamAddContact]: 'Add Contact',
    [MyHiveLocalizationKey.TeamMembersCount]: '{count} members',
    [MyHiveLocalizationKey.TeamNoUsersFound]: 'No users found',
    [MyHiveLocalizationKey.TeamSendInviteEmail]: 'Send invite email',
    [MyHiveLocalizationKey.TeamInviteEmailSent]: 'Invite email sent',
    [MyHiveLocalizationKey.TeamInviteEmailSentTooltip]: 'Invite email sent!',
    [MyHiveLocalizationKey.TeamDelete]: 'Delete',
    [MyHiveLocalizationKey.TeamReassignBeforeRemoving]: 'Reassign main/site contact role before removing',
    [MyHiveLocalizationKey.TeamRemoveContact]: 'Remove contact',
    [MyHiveLocalizationKey.TeamVisitReminders]: 'Visit Reminders',
    [MyHiveLocalizationKey.TeamEmailLabel]: 'Email',
    [MyHiveLocalizationKey.TeamSmsLabel]: 'SMS',
    [MyHiveLocalizationKey.TeamSmsDisabledTooltip]:
      'Add a valid phone number to enable SMS. Texts are sent when the beekeeper arrives onsite and when the visit is completed.',
    [MyHiveLocalizationKey.TeamSmsEnabledTooltip]:
      'Texts are sent when the beekeeper arrives onsite and when the visit is completed.',
    [MyHiveLocalizationKey.TeamVisitReminderEmailTooltip]:
      'Receive reminders & notifications about upcoming beekeeping visits',
    [MyHiveLocalizationKey.TeamMobileLabel]: 'Mobile',
    [MyHiveLocalizationKey.TeamOfficeLabel]: 'Office',
    [MyHiveLocalizationKey.TeamPhoneLabel]: 'Phone',
    [MyHiveLocalizationKey.TeamEmailFieldLabel]: 'Email',
    [MyHiveLocalizationKey.TeamLastSeenAgo]: 'Last seen {time}',
    [MyHiveLocalizationKey.TeamPreferencesLabel]: 'Preferences',
    [MyHiveLocalizationKey.TeamContactTypeLabel]: 'Contact Type',
    [MyHiveLocalizationKey.TeamEmailsLabel]: 'Emails',
    [MyHiveLocalizationKey.TeamNoneOption]: 'None',
    [MyHiveLocalizationKey.TeamNoEmails]: 'No emails',
    [MyHiveLocalizationKey.TeamAllEmails]: 'All emails',
    [MyHiveLocalizationKey.TeamEmailPrefCount]: '{count} of {total}',
    [MyHiveLocalizationKey.TeamRoleTeam]: 'Team',
    [MyHiveLocalizationKey.TeamStatusUnknown]: 'Unknown',
    [MyHiveLocalizationKey.TeamStatusDelivering]: 'Delivering',
    [MyHiveLocalizationKey.TeamStatusNonSms]: 'Non-SMS',
    [MyHiveLocalizationKey.TeamStatusInvalid]: 'Invalid',
    [MyHiveLocalizationKey.TeamStatusOptedOut]: 'Opted Out',
    [MyHiveLocalizationKey.TeamEmailUnreachableBadge]: 'This email is unreachable',
    [MyHiveLocalizationKey.TeamEmailUnreachableTooltip]: 'Email address is unreachable',
    [MyHiveLocalizationKey.TeamLastCarrierResponseTooltip]:
      'Last Carrier Response\nStatus: {status}\nTwilio Error Code: {errorCode}\nLast Message Sent: {lastSent}',
    [MyHiveLocalizationKey.TeamContactTypeMainOption]: 'Main contact: Oversees core program management.',
    [MyHiveLocalizationKey.TeamContactTypeHiveOption]: 'Hive contact: Onsite contact for routine visits.',
    [MyHiveLocalizationKey.TeamContactTypeRemoveHint]:
      'To remove a main or site contact, assign another contact first.',
    [MyHiveLocalizationKey.TeamCreateNewUserTitle]: 'Add team member',
    [MyHiveLocalizationKey.TeamCreateNewUserDescription]: 'Add a new contact on your team.',
    [MyHiveLocalizationKey.TeamCreateUser]: 'Create User',
    [MyHiveLocalizationKey.TeamCreatingUser]: 'Creating...',
    [MyHiveLocalizationKey.TeamFirstNamePlaceholder]: 'John',
    [MyHiveLocalizationKey.TeamLastNamePlaceholder]: 'Doe',
    [MyHiveLocalizationKey.TeamEmailPlaceholder]: 'john.doe@example.com',
    [MyHiveLocalizationKey.UnsubscribeGenericError]:
      'Something went wrong. Please try again, or contact support if the issue persists.',
    [MyHiveLocalizationKey.UnsubscribeTitle]: 'Email preferences',
    [MyHiveLocalizationKey.UnsubscribeSubtitle]: 'Choose which updates you want to receive from this page.',
    [MyHiveLocalizationKey.UnsubscribeEmail]: 'Email',
    [MyHiveLocalizationKey.UnsubscribePage]: 'Page',
    [MyHiveLocalizationKey.UnsubscribeManagePrompt]: 'Do you manage this hive program?',
    [MyHiveLocalizationKey.UnsubscribeSignIn]: 'Sign in',
    [MyHiveLocalizationKey.UnsubscribeNotifications]: 'Notifications',
    [MyHiveLocalizationKey.UnsubscribeVisitReminders]: 'Visit reminders',
    [MyHiveLocalizationKey.UnsubscribeVisitRemindersLockedDescription]:
      "You're a site contact, so you'll always receive visit reminders.",
    [MyHiveLocalizationKey.UnsubscribeVisitRemindersDescription]: 'Upcoming visits from your beekeeper',
    [MyHiveLocalizationKey.UnsubscribeSubscriberAlerts]: 'Subscriber alerts',
    [MyHiveLocalizationKey.UnsubscribeSubscriberAlertsDescription]: 'New subscribers to the page',
    [MyHiveLocalizationKey.UnsubscribeNewPosts]: 'Bee updates',
    [MyHiveLocalizationKey.UnsubscribeNewPostsDescription]: 'Get notified about the latest posts from your beekeeper',
    [MyHiveLocalizationKey.UnsubscribeEventWaitingList]: 'Upcoming events',
    [MyHiveLocalizationKey.UnsubscribeEventWaitingListDescription]:
      'Be the first to know about upcoming events & initiatives with your bee program',
    [MyHiveLocalizationKey.SmsOptInBlockedTitle]: 'SMS reminders are off',
    [MyHiveLocalizationKey.SmsOptInBlockedMessage]:
      'You previously opted out of SMS reminders. To opt back in text START to +1 877 676 9995. For email, click the link in the email we sent you or contact your site manager.',
    [MyHiveLocalizationKey.Ok]: 'OK',
    [MyHiveLocalizationKey.UnsubscribeMainContact]: 'Main contact',
    [MyHiveLocalizationKey.UnsubscribeHiveContact]: 'Site contact',
    [MyHiveLocalizationKey.UnsubscribeManagerLockedDescription]:
      'Alerts about your service (contact support, or sign in to change this setting)',
    [MyHiveLocalizationKey.UnsubscribeUpdateError]:
      'An error occurred. Please try again, or contact support if the issue persists.',
    [MyHiveLocalizationKey.UnsubscribeCancel]: 'Cancel',
    [MyHiveLocalizationKey.UnsubscribeSave]: 'Save',

    // Hive strength tile
    [MyHiveLocalizationKey.HiveStrengthInsideTheHive]: 'Inside the Hive',
    [MyHiveLocalizationKey.HiveStrengthHeading]: 'Hive strength',
    [MyHiveLocalizationKey.HiveStrengthFramesOfBees]: 'bees',
    [MyHiveLocalizationKey.HiveStrengthHarvest]: 'HARVEST',
    [MyHiveLocalizationKey.HiveStrengthNow]: 'now',
    [MyHiveLocalizationKey.HiveStrengthQueenSeenNow]: 'Today',
    [MyHiveLocalizationKey.HiveStrengthHoneyTooltip]:
      "6 frames is considered an excellent harvest. Here's where your hive is at.",
    [MyHiveLocalizationKey.HiveStrengthQueenTooltip]:
      'Her majesty can be elusive. This is the most recent time we spotted her.',
    [MyHiveLocalizationKey.HiveStrengthBroodTooltip]:
      "Brood frames contain eggs, larvae, and pupae laid by the queen, representing the colony's future workforce.",
    [MyHiveLocalizationKey.HiveStrengthWeekShort]: 'w',
    [MyHiveLocalizationKey.HiveStrengthLastNWeeks]: 'Last {{weeks}} weeks · {{points}} points',
    [MyHiveLocalizationKey.HiveStrengthNectarFlow]: 'Nectar flow',
    [MyHiveLocalizationKey.HiveStrengthNectarFlowDescription]:
      'The surrounding landscape is in full bloom! The bees are producing honey at a high rate.',
    [MyHiveLocalizationKey.HiveStrengthHoney]: 'Honey',
    [MyHiveLocalizationKey.HiveStrengthQueen]: 'Queen',
    [MyHiveLocalizationKey.HiveStrengthBrood]: 'Brood',
    [MyHiveLocalizationKey.HiveStrengthFramesUnit]: 'frames',
    [MyHiveLocalizationKey.HiveStrengthDaysAgoUnit]: 'd ago',
    [MyHiveLocalizationKey.HiveStrengthNeverSeen]: 'never seen',
    [MyHiveLocalizationKey.HiveStrengthEmpty]: 'No inspections in this window yet',
    [MyHiveLocalizationKey.HiveStrengthBannerAlt]: 'Inside a beehive',
    [MyHiveLocalizationKey.HiveStrengthStateThriving]: 'Thriving',
    [MyHiveLocalizationKey.HiveStrengthStateThrivingSub]: 'Population & production is growing significantly',
    [MyHiveLocalizationKey.HiveStrengthStateGrowing]: 'Growing',
    [MyHiveLocalizationKey.HiveStrengthStateGrowingSub]: 'Colony is expanding with increases in honey and bees',
    [MyHiveLocalizationKey.HiveStrengthStateStable]: 'Healthy',
    [MyHiveLocalizationKey.HiveStrengthStateStableSub]: 'Population and production has remained steady',
    [MyHiveLocalizationKey.HiveStrengthStateConserving]: 'Conserving',
    [MyHiveLocalizationKey.HiveStrengthStateConservingSub]: 'Colony in seasonal conservation mode',
    [MyHiveLocalizationKey.HiveStrengthStateReducing]: 'Reducing',
    [MyHiveLocalizationKey.HiveStrengthStateReducingSub]: 'Colony is reducing in population and production',
    // V2 widget — new copy
    [MyHiveLocalizationKey.HiveStrengthInsightsTitle]: 'Inside the Hive',
    [MyHiveLocalizationKey.HiveStrengthMostRecent]: 'Most recent',
    [MyHiveLocalizationKey.HiveStrengthBeesLabel]: 'Bees',
    [MyHiveLocalizationKey.HiveStrengthStrengthLabel]: 'Strength',
    [MyHiveLocalizationKey.HiveStrengthFramesOfBeesLong]: 'Frames of bees',
    [MyHiveLocalizationKey.HiveStrengthDaysShort]: 'd',
    [MyHiveLocalizationKey.HiveStrengthSpottedSuffix]: 'spotted',
    [MyHiveLocalizationKey.HiveStrengthDidYouKnow]: 'Did you know?',
    [MyHiveLocalizationKey.HiveStrengthAHiveHas3Members]: 'A hive has 3 members',
    [MyHiveLocalizationKey.HiveStrengthMemberQueenDescription]: "Lays all the colony's eggs, up to 2,000 per day.",
    [MyHiveLocalizationKey.HiveStrengthMemberWorkers]: 'Workers',
    [MyHiveLocalizationKey.HiveStrengthMemberWorkersDescription]: 'Female bees that keep the colony running.',
    [MyHiveLocalizationKey.HiveStrengthMemberWorkersCount]: '~50,000',
    [MyHiveLocalizationKey.HiveStrengthMemberDrones]: 'Drones',
    [MyHiveLocalizationKey.HiveStrengthMemberDronesDescription]: 'Male bees who mate with new queens.',
    [MyHiveLocalizationKey.HiveStrengthMemberDronesCount]: '~500',
    [MyHiveLocalizationKey.HiveStrengthInAHive]: 'in a hive',
    [MyHiveLocalizationKey.HiveStrengthAtPeak]: 'at peak',
    [MyHiveLocalizationKey.HiveStrengthBeekeeperInspectionsTitle]: 'Beekeeper inspections',
    [MyHiveLocalizationKey.HiveStrengthBeekeeperInspectionsBody]:
      "We regularly inspect the hive to support the bees' health. At most visits, we look for the queen and record honey and brood frames.",
    [MyHiveLocalizationKey.HiveStrengthBeesTooltip]:
      'An estimate of the total bee population based on the number of frames covered with bees (~2,000 bees per frame).',
    [MyHiveLocalizationKey.HiveStrengthStrengthTooltip]:
      'How many frames of bees the beekeeper observed during recent inspections.',
    [MyHiveLocalizationKey.DataCardTitle]: 'Nature Insights',
    [MyHiveLocalizationKey.BeeHomeWhatIsTitle]: 'What is a beehome?',
    [MyHiveLocalizationKey.BeeHomeWhatIsBody]:
      'BeeHomes offer safe nesting habitat for solitary bees and other cavity-nesting insects, with hundreds of tubes to choose from. Unlike a honey bee colony, each of these insects builds its own nest, lays its own eggs and collects food to feed itself and its young.',
    [MyHiveLocalizationKey.BeeHomeLikelyBuilders]: 'Likely builders:',
    [MyHiveLocalizationKey.BeeHomeMaterialLumpyMudTitle]: 'Lumpy mud',
    [MyHiveLocalizationKey.BeeHomeMaterialLumpyMudDescription]:
      'A coarse, bumpy plug of soil packed grain by grain into a sturdy little wall, like tiny hand-mixed masonry.',
    [MyHiveLocalizationKey.BeeHomeMaterialLumpyMudBuilders]:
      'Mason bees (Osmia), along with their smaller cousins Hoplitis and Chelostoma. Some mason and potter wasps (Ancistrocerus) also cap their nests with mud.',
    [MyHiveLocalizationKey.BeeHomeMaterialSmoothMudTitle]: 'Smooth mud',
    [MyHiveLocalizationKey.BeeHomeMaterialSmoothMudDescription]:
      'Fine soil worked into a smooth, even wall that neatly divides one nursery cell from the next.',
    [MyHiveLocalizationKey.BeeHomeMaterialSmoothMudBuilders]:
      'Mason and potter wasps (Ancistrocerus and relatives), plus some mason bees (Osmia, Chelostoma).',
    [MyHiveLocalizationKey.BeeHomeMaterialMasticLeafPulpTitle]: 'Leaf pulp',
    [MyHiveLocalizationKey.BeeHomeMaterialMasticLeafPulpDescription]:
      'Foliage chewed into a soft green paste, a kind of natural putty, then smoothed into partitions and plugs.',
    [MyHiveLocalizationKey.BeeHomeMaterialMasticLeafPulpBuilders]:
      'Mason bees that chew rather than cut their leaves, including certain widespread Osmia and Hoplitis species.',
    [MyHiveLocalizationKey.BeeHomeMaterialWoolPlantHairsTitle]: 'Wool / Plant hairs',
    [MyHiveLocalizationKey.BeeHomeMaterialWoolPlantHairsDescription]:
      'Soft, cottony fuzz scraped from fuzzy-leaved plants and packed in like a cozy blanket.',
    [MyHiveLocalizationKey.BeeHomeMaterialWoolPlantHairsBuilders]: 'Wool carder bees (Anthidium and Pseudoanthidium).',
    [MyHiveLocalizationKey.BeeHomeMaterialGrassTitle]: 'Grass',
    [MyHiveLocalizationKey.BeeHomeMaterialGrassDescription]:
      'Blades of grass and slender stems tucked into the tunnel, sometimes with a few wisps poking out the entrance.',
    [MyHiveLocalizationKey.BeeHomeMaterialGrassBuilders]: 'Grass-carrying wasps (Isodontia).',
    [MyHiveLocalizationKey.BeeHomeMaterialLooseLeafPiecesTitle]: 'Loose leaf pieces',
    [MyHiveLocalizationKey.BeeHomeMaterialLooseLeafPiecesDescription]:
      "Neat, coin-shaped snippets cut cleanly from a leaf's edge and wrapped around each cell like little parcels.",
    [MyHiveLocalizationKey.BeeHomeMaterialLooseLeafPiecesBuilders]: 'Leafcutter bees (Megachile).',
    [MyHiveLocalizationKey.BeeHomeMaterialResinTitle]: 'Resin',
    [MyHiveLocalizationKey.BeeHomeMaterialResinDescription]:
      'Sticky tree sap gathered drop by drop and molded into a tough, waterproof seal that sets rock-hard.',
    [MyHiveLocalizationKey.BeeHomeMaterialResinBuilders]:
      'Resin bees (Heriades and the small resin-and-pebble bees Anthidiellum), plus some leafcutter bees (Megachile) that build with resin.',
    [MyHiveLocalizationKey.BeeHomeMaterialMembranousCellophaneLikeLiningTitle]: 'Cellophane-like lining',
    [MyHiveLocalizationKey.BeeHomeMaterialMembranousCellophaneLikeLiningDescription]:
      'A thin, shiny, almost plastic-looking film the bee makes herself and paints over the walls, like waterproof wallpaper.',
    [MyHiveLocalizationKey.BeeHomeMaterialMembranousCellophaneLikeLiningBuilders]:
      'Masked or yellow-faced bees (Hylaeus), sometimes called cellophane bees.',
    [MyHiveLocalizationKey.BeeHomeMaterialLeafPulpSandGrainsLeafDiscsTitle]: 'Leaf, pulp & sand mix',
    [MyHiveLocalizationKey.BeeHomeMaterialLeafPulpSandGrainsLeafDiscsDescription]:
      'A mix-and-match seal blending chewed leaves, grains of sand, and cut leaf pieces all in one.',
    [MyHiveLocalizationKey.BeeHomeMaterialLeafPulpSandGrainsLeafDiscsBuilders]:
      'Leafcutter and resin bees (Megachile, Heriades), which sometimes combine materials.',
    [MyHiveLocalizationKey.BeeHomeMaterialMudSomeLeafPulpOrangePollenTitle]: 'Mud, some leaf pulp, orange pollen',
    [MyHiveLocalizationKey.BeeHomeMaterialMudSomeLeafPulpOrangePollenDescription]:
      'Mud and chewed leaf worked together, with a telltale dusting of orange pollen left behind.',
    [MyHiveLocalizationKey.BeeHomeMaterialMudSomeLeafPulpOrangePollenBuilders]:
      'Mason bees and close relatives (Osmia, Hoplitis, Chelostoma).',
    [MyHiveLocalizationKey.BeeHomeMaterialOtherCombinationTitle]: 'Other combination',
    [MyHiveLocalizationKey.BeeHomeMaterialOtherCombinationDescription]:
      "A seal that doesn't fit any one category, maybe two materials blended, maybe something unusual.",
    [MyHiveLocalizationKey.BeeHomeMaterialOtherCombinationBuilders]:
      'Could be several species. Many cavity-nesters improvise when their favorite material runs short.',
    [MyHiveLocalizationKey.BeeHomeResultsTitle]: 'Insect nesting',
    [MyHiveLocalizationKey.BeeHomeTubesUnit]: 'tubes',
    [MyHiveLocalizationKey.BeeHomeTubesNestedThisSeason]: 'tubes nested this season',
    [MyHiveLocalizationKey.BeeHomeDescriptionWithData]:
      'Explore the types of nests you might find in a BeeHome, including those observed on-site, and see which species build them.',
    [MyHiveLocalizationKey.BeeHomeDescriptionNoData]:
      'Explore the types of nests you might find in a BeeHome and see which species build them.',
    [MyHiveLocalizationKey.BioacousticsCardTitle]: 'Bioacoustic Data',
    [MyHiveLocalizationKey.BioacousticsHeaderBadge]: 'Bioacoustics',
    [MyHiveLocalizationKey.BioacousticsErrorLoading]: 'Error loading data',
    [MyHiveLocalizationKey.BioacousticsTenantHeading]: 'Want to hear a building come alive?',
    [MyHiveLocalizationKey.BioacousticsTenantBody]:
      'Acoustic Naute Sensors can pick up on pollinator and bird activity at urban sites.',
    [MyHiveLocalizationKey.BioacousticsManagerHeading]: 'Hear your building come alive',
    [MyHiveLocalizationKey.BioacousticsManagerBody]:
      'Add Nature Sensors to your program, and this widget fills with live pollinator and bird activity from your site',
    [MyHiveLocalizationKey.BioacousticsTenantCta]: 'Check out a live example',
    [MyHiveLocalizationKey.BioacousticsManagerCta]: 'See a live example',
    [MyHiveLocalizationKey.BioacousticsPollinators]: 'Pollinators',
    [MyHiveLocalizationKey.BioacousticsLive]: 'Live',
    [MyHiveLocalizationKey.BioacousticsLast14Days]: 'Last 14 days',
    [MyHiveLocalizationKey.BioacousticsSelected]: 'Selected',
    [MyHiveLocalizationKey.BioacousticsMostRecent]: 'Most Recent',
    [MyHiveLocalizationKey.BioacousticsActivity]: 'Activity',
    [MyHiveLocalizationKey.BioacousticsDetectionsPerHour]: 'detections per hour',
    [MyHiveLocalizationKey.BioacousticsRangeOverPeriod]: 'Range over period',
    [MyHiveLocalizationKey.BioacousticsDiversityScore]: 'Pollinator Diversity Score',
    [MyHiveLocalizationKey.BioacousticsDiversityScoreDescription]:
      "The effective number of pollinator frequency groups at this site, calculated from each frequency's share of total detections. A site dominated by one frequency scores low; an even mix scores high.",
    [MyHiveLocalizationKey.BioacousticsDiversityScoreFootnote]:
      '7-day average. Clusters are acoustic signatures, not species identifications.',
    [MyHiveLocalizationKey.BioacousticsVsPrevious7Days]: 'vs previous · 7 days',
    [MyHiveLocalizationKey.BioacousticsPollinatorBreakdownLink]: 'Full pollinator breakdown below →',
    [MyHiveLocalizationKey.BioacousticsBirds]: 'Birds',
    [MyHiveLocalizationKey.BioacousticsAllTime]: 'All time',
    [MyHiveLocalizationKey.BioacousticsUniqueBirdSpecies]: 'Unique Bird Species',
    [MyHiveLocalizationKey.BioacousticsTotalDetections]: 'Total Detections',
    [MyHiveLocalizationKey.BioacousticsMostHeard]: 'Most Heard',
    [MyHiveLocalizationKey.BioacousticsDetections]: 'detections',
    [MyHiveLocalizationKey.BioacousticsLastSeen]: 'last seen',
    [MyHiveLocalizationKey.BioacousticsNoBirdData]: 'No bird data yet',
    [MyHiveLocalizationKey.BioacousticsDawnChorusLink]: 'Full dawn chorus below →',
    [MyHiveLocalizationKey.BioacousticsWhenBuzzPeaks]: 'When the buzz peaks',
    [MyHiveLocalizationKey.BioacousticsAverageDayAllTime]: 'average day · all-time',
    [MyHiveLocalizationKey.BioacousticsListenToRecentDetections]: 'Listen to recent detections',
    [MyHiveLocalizationKey.BioacousticsNoBuzzDetections]: 'No buzz detections recorded yet',
    [MyHiveLocalizationKey.BioacousticsDawnChorus]: 'The dawn chorus',
    [MyHiveLocalizationKey.BioacousticsWhenBirdsSingAllTime]: 'when birds sing · all-time',
    [MyHiveLocalizationKey.BioacousticsByTheNumbers]: 'By the numbers',
    [MyHiveLocalizationKey.BioacousticsBirdDiversityScore]: 'Bird Diversity Score',
    [MyHiveLocalizationKey.BioacousticsBirdDiversityScoreDescription]:
      "The effective number of bird species at this site, calculated from each species' share of total detections. A site dominated by one species scores low; an even spread across many scores high.",
    [MyHiveLocalizationKey.BioacousticsEffectiveSpeciesFromAllDetections]: 'effective species from all detections',
    [MyHiveLocalizationKey.BioacousticsPeakWindowBetween]: 'Peak window between',
    [MyHiveLocalizationKey.BioacousticsSongPeaksBetween]: 'Song peaks between',
    [MyHiveLocalizationKey.BioacousticsAnd]: 'and',
    [MyHiveLocalizationKey.BioacousticsVariety]: 'Variety',
    [MyHiveLocalizationKey.BioacousticsUniqueFrequencies]: 'Unique Frequencies',
    [MyHiveLocalizationKey.BioacousticsWeather]: 'Weather',

    // BioacousticsPage public page keys
    [MyHiveLocalizationKey.BioacousticsPageHeroTitleSamplePre]: 'Live nature readings from an office building in ',
    [MyHiveLocalizationKey.BioacousticsPageHeroTitleSampleCity]: 'New York City',
    [MyHiveLocalizationKey.BioacousticsPageHeroTitleLivePre]: 'Live nature readings from ',
    [MyHiveLocalizationKey.BioacousticsPageHeroDescription]:
      'Birds, pollinators, and other beneficial species live in and around every building. Explore the asset-level nature readings this building shares with nature-conscious tenants and investors.',
    [MyHiveLocalizationKey.BioacousticsPageAlignedWith]: 'Aligned with',
    [MyHiveLocalizationKey.BioacousticsPageWhereTitle]: 'Where this is happening.',
    [MyHiveLocalizationKey.BioacousticsPageWhereDescription]:
      'Every reading here comes from one site, and the surrounding land shapes what the sensors detect.',
    [MyHiveLocalizationKey.BioacousticsPageLandCoverLabel]: 'land cover',
    [MyHiveLocalizationKey.BioacousticsPageLandCoverNatural]: 'Natural',
    [MyHiveLocalizationKey.BioacousticsPageLandCoverAgricultural]: 'Agricultural',
    [MyHiveLocalizationKey.BioacousticsPageLandCoverArtificial]: 'Artificial',
    [MyHiveLocalizationKey.BioacousticsPageLandCoverWater]: 'Water',
    [MyHiveLocalizationKey.BioacousticsPagePollinatorsDescription]:
      'Each wingbeat carries a frequency signature. We cluster those signatures to gauge how many distinct groups are present and how busy the site is.',
    [MyHiveLocalizationKey.BioacousticsPageBirdsDescription]:
      'Birds tell a slower, wider story, their song peaking in spring with territory and courtship. The dawn chorus at first light is one of the most-listened-to records in ecology.',
    [MyHiveLocalizationKey.BioacousticsPageDawnChorusDescPre]: 'The ',
    [MyHiveLocalizationKey.BioacousticsPageDawnChorusDescEmphasis]: 'dawn chorus',
    [MyHiveLocalizationKey.BioacousticsPageDawnChorusDescPost]:
      " is the wave of song that rises around first light. Its timing and richness tell you a lot about a site's bird community.",
    [MyHiveLocalizationKey.BioacousticsPageUniqueSpecies]: 'Unique Species',
    [MyHiveLocalizationKey.BioacousticsPageBirdSensorNotActive]: 'Bird sensor not active',
    [MyHiveLocalizationKey.BioacousticsPageBirdSensorDescription]:
      'Add a bird sensor to your site to unlock species tracking, diversity scores, and dawn chorus data.',
    [MyHiveLocalizationKey.BioacousticsPageUpsellTitlePre]: 'Imagine this biodiversity',
    [MyHiveLocalizationKey.BioacousticsPageUpsellTitleMid]: 'data for ',
    [MyHiveLocalizationKey.BioacousticsPageUpsellTitleYour]: 'your',
    [MyHiveLocalizationKey.BioacousticsPageUpsellTitlePost]: ' asset.',
    [MyHiveLocalizationKey.BioacousticsPageUpsellDescription]:
      'A nature sensor captures biodiversity data on-site, analyzes it with AI, and delivers reports ready for investors and tenants.',
    [MyHiveLocalizationKey.BioacousticsPageSensorName]: 'The nature sensor',
    [MyHiveLocalizationKey.BioacousticsPageSensorDescription]:
      'A passive bioacoustic unit that measures both pollinator activity and bird species, around the clock.',
    [MyHiveLocalizationKey.BioacousticsPageTheProblem]: 'The Problem',
    [MyHiveLocalizationKey.BioacousticsPageProblemDescPre]: 'GRESB RM7, TNFD, and LP due diligence',
    [MyHiveLocalizationKey.BioacousticsPageProblemDescPost]:
      ' now require asset-level biodiversity data for nature disclosure. Most managers show up with photos instead of data.',
    [MyHiveLocalizationKey.BioacousticsPageTheSolution]: 'The Solution',
    [MyHiveLocalizationKey.BioacousticsPageSolutionDescription]:
      'The nature sensor runs 24/7, streaming real-time biodiversity data analyzed by our AI models and automatically rolled into reports preformatted for GRESB, TNFD, CSRD, or BREEAM.',
    [MyHiveLocalizationKey.BioacousticsPageThreeWaysTitle]: 'Three ways it pays off',
    [MyHiveLocalizationKey.BioacousticsPageThreeWaysOnePlatformTitle]: 'One platform to run your biodiversity strategy',
    [MyHiveLocalizationKey.BioacousticsPageThreeWaysOnePlatformBody]:
      "This building's readings feed our Aura Nature Risk platform, taking you from raw data to a strategy you can act on.",
    [MyHiveLocalizationKey.BioacousticsPageThreeWaysOnlyDataTitle]: 'Only the data that matters',
    [MyHiveLocalizationKey.BioacousticsPageThreeWaysOnlyDataBody]:
      'You get exactly the metrics the industry values for real estate, surfaced in plain language, without the noise.',
    [MyHiveLocalizationKey.BioacousticsPageThreeWaysDDQsTitle]: 'Designed with DDQs in mind',
    [MyHiveLocalizationKey.BioacousticsPageThreeWaysDDQsBody]:
      'Your readings arrive already aligned to GRESB, TNFD, and CSRD, so disclosures and due-diligence questionnaires are quick to answer.',
    [MyHiveLocalizationKey.BioacousticsPageAsFeaturedIn]: 'As featured in',
    [MyHiveLocalizationKey.BioacousticsPageDeployedAtPre]: 'Already deployed at ',
    [MyHiveLocalizationKey.BioacousticsPageDeployedAtBrand]: 'leading global real estate brands',
    [MyHiveLocalizationKey.BioacousticsPagePerYearPerProperty]: '/ year per property',
    [MyHiveLocalizationKey.BioacousticsPagePricingNote]: 'No installation fee. No minimum sites. Live in two weeks.',
    [MyHiveLocalizationKey.BioacousticsPageWhatsIncluded]: "What's included",
    [MyHiveLocalizationKey.BioacousticsPageIncluded1]: '2 nature sensors + installation',
    [MyHiveLocalizationKey.BioacousticsPageIncluded2]: 'Real-time data feed into your dashboard',
    [MyHiveLocalizationKey.BioacousticsPageIncluded3]: 'Tenant-facing live insights',
    [MyHiveLocalizationKey.BioacousticsPageIncluded4]: 'Year-end biodiversity report (GRESB RM7 + TNFD)',
    [MyHiveLocalizationKey.BioacousticsPageFreeScreeningTitle]:
      'See how your asset stacks up with a free nature screening.',
    [MyHiveLocalizationKey.BioacousticsPageTryItFree]: 'Try it free',
    [MyHiveLocalizationKey.BioacousticsChartToday]: 'Today',
    [MyHiveLocalizationKey.BioacousticsChartYesterday]: 'Yesterday',
    [MyHiveLocalizationKey.BioacousticsChart1WkAgo]: '1 wk ago',
    [MyHiveLocalizationKey.BioacousticsChart2WksAgo]: '2 wks ago',
    [MyHiveLocalizationKey.BioacousticsChartMidnight]: 'MIDNIGHT',
    [MyHiveLocalizationKey.BioacousticsChartNoon]: 'NOON',
    [MyHiveLocalizationKey.BioacousticsChart6AM]: '6 AM',
    [MyHiveLocalizationKey.BioacousticsChart6PM]: '6 PM',
    [MyHiveLocalizationKey.AuraNatureAroundBuilding]: 'Nature Around Your Building',
    [MyHiveLocalizationKey.AuraPoweredBy]: 'Powered by Aura',
    [MyHiveLocalizationKey.AuraLandCover]: 'Land Cover',
    [MyHiveLocalizationKey.AuraWithin500m]: 'Within 500m radius',
    [MyHiveLocalizationKey.AuraSeeFullPicture]: 'See the full picture in Aura',
    [MyHiveLocalizationKey.AuraLandCoverAgricultural]: 'Agricultural',
    [MyHiveLocalizationKey.AuraLandCoverArtificial]: 'Artificial',
    [MyHiveLocalizationKey.AuraLandCoverNatural]: 'Natural',
    [MyHiveLocalizationKey.AuraLandCoverWater]: 'Water',
    [MyHiveLocalizationKey.AuraDescription]:
      "Aura is Alvéole's nature platform. It measures the biodiversity around your whole site, beyond just the bees.",
    [MyHiveLocalizationKey.AuraExploreSpecies]:
      'Explore species, habitat and nature risk for this address. Free, opens in a new tab.',

    [MyHiveLocalizationKey.EdnaCardTitle]: 'Honey eDNA',
    [MyHiveLocalizationKey.EdnaCardUniquePlants]: 'unique kinds of plants detected',
    [MyHiveLocalizationKey.EdnaCardDescription]:
      "Honey from your building's hive was tested for plant DNA, revealing a record of the kinds of plants your bees foraged over the year.",
    [MyHiveLocalizationKey.EdnaCardEveryPlantDetected]: 'Every plant detected',
    [MyHiveLocalizationKey.EdnaCardTenantHeading]: "What's growing near you?",
    [MyHiveLocalizationKey.EdnaCardTenantBody]:
      "Your building's honey holds a record of every plant the bees visited — read straight from the DNA.",
    [MyHiveLocalizationKey.EdnaCardManagerHeading]: "See what's growing around your building",
    [MyHiveLocalizationKey.EdnaCardManagerBody]:
      "Your hive's honey holds the DNA of every plant your bees visited. Add an eDNA analysis to reveal the living landscape around your site, and gain biodiversity data for TNFD, GRESB, CSRD.",
    [MyHiveLocalizationKey.EdnaCardSeeSampleData]: 'See sample data',

    [MyHiveLocalizationKey.EdnaGrowthTreesShrubs]: 'Trees & shrubs',
    [MyHiveLocalizationKey.EdnaGrowthWildflowers]: 'Wildflowers',
    [MyHiveLocalizationKey.EdnaGrowthVinesGrasses]: 'Vines & grasses',
    [MyHiveLocalizationKey.EdnaGrowthMixed]: 'Mixed & unspecified',
    [MyHiveLocalizationKey.EdnaGrowthPctOfGroups]: '% of plant groups',
    [MyHiveLocalizationKey.EdnaGrowthKindsByForm]: 'kinds, by\ngrowth form',

    [MyHiveLocalizationKey.ShareWithTenantsTitle]: 'Share with tenants',
    [MyHiveLocalizationKey.ShareWithTenantsSubheader]:
      'Boost engagement — share your Alvéole page with your tenant network so everyone can see the hive, join events, and claim honey.',
    [MyHiveLocalizationKey.InviteByEmailTab]: 'Invite by email',
    [MyHiveLocalizationKey.ShareALinkTab]: 'Share a link',
    [MyHiveLocalizationKey.QRCodeTab]: 'QR code',
    [MyHiveLocalizationKey.ShareableLink]: 'Shareable link',
    [MyHiveLocalizationKey.ShareableLinkHint]:
      'Drop this anywhere — newsletter, email, building app. Anyone with the link can follow the page.',
    [MyHiveLocalizationKey.MakeItYours]: 'Make it yours',
    [MyHiveLocalizationKey.MakeItYoursHint]:
      'Give your page a name and a link your community will recognize and remember.',
    [MyHiveLocalizationKey.PageNameLabel]: 'Page name',
    [MyHiveLocalizationKey.PageNameExampleHint]: 'e.g. The Bees at Smith Tower, Maple Court Hive.',
    [MyHiveLocalizationKey.PageLinkLabel]: 'Page link',
    [MyHiveLocalizationKey.PageLinkExampleHint]: 'e.g. maple-court, 412-king-st.',
    [MyHiveLocalizationKey.QRScanHeading]: 'A scan opens your page',
    [MyHiveLocalizationKey.QRScanHint]: 'No typing, no login needed to follow along.',
    [MyHiveLocalizationKey.DownloadQRCode]: 'Download QR code',
    [MyHiveLocalizationKey.SavedConfirmation]: 'Saved',

    [MyHiveLocalizationKey.ErrorPageGenericTitle]: 'Something went wrong',
    [MyHiveLocalizationKey.ErrorPageGenericBody]:
      'Please try again. If the problem keeps happening, get in touch with our support team.',
    [MyHiveLocalizationKey.ErrorPageLoadUserTitle]: 'There was a problem with your account',
    [MyHiveLocalizationKey.ErrorPageLoadUserBody]:
      "We couldn't load your account. Please try again, or contact support if this keeps happening.",
    [MyHiveLocalizationKey.ErrorPageHoneyLabelTitle]: 'Your honey label is coming soon',
    [MyHiveLocalizationKey.ErrorPageHoneyLabelBody]:
      'Access to your honey label will be available soon. Have a question in the meantime? Get in touch.',
    [MyHiveLocalizationKey.ErrorPageNotFoundTitle]: 'Page not found',
    [MyHiveLocalizationKey.ErrorPageNotFoundBody]:
      "We couldn't find the page you're looking for. Double-check the link, or contact support.",
    [MyHiveLocalizationKey.ErrorPageNoAccessTitle]: "You don't have access to this page",
    [MyHiveLocalizationKey.ErrorPageNoAccessAuthed]:
      'Your account doesn’t have access to this page. Ask a colleague who manages this hive to grant you access, or contact support to request it.',
    [MyHiveLocalizationKey.ErrorPageNoAccessGuest]: 'Redirecting you to sign in…',
    [MyHiveLocalizationKey.ErrorPageContactSupport]: 'Contact support',
    [MyHiveLocalizationKey.ErrorPageSupportUrl]: 'https://support.alveole.buzz/hc/en-us',
  },

  fr: {
    [MyHiveLocalizationKey.Unset]: 'Non défini',
    [MyHiveLocalizationKey.Attendees]: 'Participants :',
    [MyHiveLocalizationKey.UploadYourLogoAnd]: 'Téléchargez votre logo et nous nous occupons du reste.',
    [MyHiveLocalizationKey.ShareYourLogoHere]: 'Partagez votre logo ici !',
    [MyHiveLocalizationKey.YourMessageLands]: ' Votre message est envoyé instantanément dans leur boîte de réception.',
    [MyHiveLocalizationKey.ReachEveryoneRegistered]: `Rejoignez tous les inscrits à votre événement en un seul envoi. Partagez des détails de dernière minute, des rappels ou toute information utile pour que chacun arrive bien préparé.`,
    [MyHiveLocalizationKey.PreHeader]: 'Pre-header',
    [MyHiveLocalizationKey.AMessageFrom]: "Message de l'organisateur",
    [MyHiveLocalizationKey.MessageAttendees]: 'Contacter les participants',
    [MyHiveLocalizationKey.MessageYourAttendees]: 'Envoyez un message à vos participants',
    [MyHiveLocalizationKey.CustomMessageRequired]: 'Personnalisez votre message :',
    [MyHiveLocalizationKey.CustomMessageAttendeesHint]:
      'Ajoutez votre message ici — détails de dernière minute, quoi apporter, où se retrouver...',
    [MyHiveLocalizationKey.CustomizeYourMessageEvent]: `Joignez-vous à nous pour un événement spécial dans le cadre du programme apicole de l’immeuble, en partenariat avec Alvéole!

{{WORKSHOP_TITLE}} vous propose une expérience unique et interactive à ne pas manquer.

Découvrez comment de petits gestes soutiennent la biodiversité urbaine, et comment notre milieu de travail contribue à une ville plus positive pour la nature.

Consultez les détails ci-dessous et réservez votre place. 🐝
`,
    [MyHiveLocalizationKey.GetNotifiedForEveryNewSignup]:
      'Recevez une notification à chaque nouvelle inscription et consultez ou contactez votre liste d’inscrits en tout temps sur votre page.',
    [MyHiveLocalizationKey.ShareYourEventWithYourTenantNetwork]:
      'Partagez votre événement avec votre réseau de locataires! Inscription directe sur votre page Alvéole, avec confirmations et rappels envoyés automatiquement.',
    [MyHiveLocalizationKey.InviteYourTenantsToRegisterEvent]: "Invitez vos locataires à s'inscrire!",
    [MyHiveLocalizationKey.PersonalizeTitle]: 'Personnalisez le nom de votre page',
    [MyHiveLocalizationKey.PersonalizeText]:
      'Choisissez un nom et ajoutez votre logo pour que les locataires reconnaissent facilement la page',
    [AlveolePackages.Deluxe]: 'Deluxe',
    [AlveolePackages.School]: 'Forfait école',
    [AlveolePackages.Base]: 'Forfait de base',
    [AlveolePackages.Premium]: 'Forfait premium',
    [AlveolePackages.Standard]: 'Forfait Standard',
    [AlveolePackages.WelcomeLocalPollinators]: 'Accueillez les pollinisateurs locaux',
    [AlveolePackages.MeetTheWildBees]: 'Rencontrez les abeilles sauvages',
    [AlveolePackages.MeetTheBees]: 'Rencontrez les abeilles',
    [AlveolePackages.CultivateChange]: 'Cultivez le changement',
    [AlveolePackages.TrackYourImpact]: 'Mesurez votre impact',
    [AlveolePackages.EducationalPackage]: 'Forfait Éducatif',
    [AlveolePackages.NatureImpact]: 'Nature Impact',
    [AlveolePackages.NatureRisk]: 'Nature Risk',
    [MyHiveLocalizationKey.SearchYourReportTypes]: 'Rechercher des types de rapports',
    [MyHiveLocalizationKey.NoResultsMatching]: 'Aucun résultat correspondant à votre recherche',
    [MyHiveLocalizationKey.Certifications]: 'Certifications',
    [MyHiveLocalizationKey.SearchYourAssets]: 'Rechercher vos actifs',
    [MyHiveLocalizationKey.AskNature]: 'Demander',
    [MyHiveLocalizationKey.AvailableReports]: 'Rapports disponibles',
    [MyHiveLocalizationKey.SearchForAnAsset]: 'Rechercher un actif',
    [MyHiveLocalizationKey.AssetLevelResults]: 'Résultats au niveau des actifs',
    [MyHiveLocalizationKey.Properties]: 'Propriétés',
    [MyHiveLocalizationKey.PortfolioInsights]: 'Aperçus du portefeuille',
    [MyHiveLocalizationKey.ExploreYourData]: 'Explorez vos données',
    [MyHiveLocalizationKey.ReportsAtYourFingertips]: 'Rapports à portée de main',
    [MyHiveLocalizationKey.NatureData]: 'Données sur la nature',
    [MyHiveLocalizationKey.AllAssets]: 'Tous les actifs',
    [MyHiveLocalizationKey.AssetAnalytics]: 'Analyse des actifs',
    [MyHiveLocalizationKey.Dashboard]: 'Tableau de bord',
    [MyHiveLocalizationKey.Property]: 'Propriété',
    [MyHiveLocalizationKey.Reports]: 'Rapports',
    [MyHiveLocalizationKey.Discover]: 'Découvrez',
    [MyHiveLocalizationKey.ExploreUnderstand]: 'Explorez. Comprenez.',
    [MyHiveLocalizationKey.ActConfidently]: 'Prêt à explorer vos données sur la nature?',
    [MyHiveLocalizationKey.Skip]: `Passer`,
    [MyHiveLocalizationKey.Iunderstand]: `Je comprends`,
    [MyHiveLocalizationKey.Hey]: `Salut`,
    [MyHiveLocalizationKey.Back]: `Retour`,
    [MyHiveLocalizationKey.Imyour]: `Je suis votre Agent Nature.`,
    //TODO
    [MyHiveLocalizationKey.HereToHelp]: `Je suis là pour vous aider à comprendre l'impact environnemental de votre propriété et à concrétiser vos objectifs de durabilité. Voici quelques points à savoir sur moi :`,
    [MyHiveLocalizationKey.Heresafew]: 'Voici quelques points que vous devriez savoir sur moi :',
    [MyHiveLocalizationKey.Curious]: `Curieux ?`,
    [MyHiveLocalizationKey.JustAsk]: `Demandez simplement.`,
    //TODO
    [MyHiveLocalizationKey.ChatWithMe]: `Discutez avec moi de vos données ESG, certifications ou même de la santé de votre ruche — je vous aiderai à explorer des pistes et des prochaines étapes.`,
    [MyHiveLocalizationKey.BuiltToGuide]: `Conçu pour guider, jamais pour submerger.`, //TODO
    [MyHiveLocalizationKey.ITurnComplexFrameworks]: `Je transforme des cadres complexes comme LEED, GRESB ou TNFD en informations simples et visuelles, faciles à comprendre et à utiliser.`, //TODO
    [MyHiveLocalizationKey.WeGrowBetterTogether]: `On progresse mieux ensemble.`,
    [MyHiveLocalizationKey.EveryConversationHelpsMeLearn]: `Chaque conversation m’aide à comprendre ce qui compte pour votre équipe — de la biodiversité à l’engagement des locataires — pour mieux vous servir, vous et la planète.`,
    [MyHiveLocalizationKey.Whatsyourrole]: `Quel est votre rôle ?`,
    [MyHiveLocalizationKey.Egassetmanager]: `Ex. : Gestionnaire d’actifs, Gestionnaire du développement durable, Coordonnateur de l’engagement des locataires.`,
    [MyHiveLocalizationKey.Howareyouplanning]: `Comment comptez-vous utiliser l’Agent Nature ?`,
    [MyHiveLocalizationKey.Sustainabilityreporting]: `Rapport de durabilité`,
    [MyHiveLocalizationKey.Hivehealthandbiodiversity]: `Nature & biodiversité`,
    [MyHiveLocalizationKey.Tenantandcommunityengagement]: `Engagement des locataires & de la communauté`,
    [MyHiveLocalizationKey.Frameworksandcertifications]: `Cadres & certifications`,
    [MyHiveLocalizationKey.Sitelevelinsights]: `Analyses au niveau du site`,
    [MyHiveLocalizationKey.Portfoliooverview]: `Vue d’ensemble du portefeuille`,
    [MyHiveLocalizationKey.Natureagentschoice]: `Choix de l’Agent Nature`,
    [MyHiveLocalizationKey.Whichareyouinterestedin]: `Qu’est-ce qui vous intéresse ?`,
    [MyHiveLocalizationKey.Frameworks]: `Cadres`,
    [MyHiveLocalizationKey.Greencertifications]: `Certifications`,
    [MyHiveLocalizationKey.Leedleadershipinenergy]: `LEED - Leadership en énergie et conception environnementale`,
    [MyHiveLocalizationKey.Wellbuildingstandard]: `WELL - Standard du bâtiment`,
    [MyHiveLocalizationKey.Fitwelhealth]: `Fitwel - Environnements favorisant la santé`,
    [MyHiveLocalizationKey.Gresbbenchmarkinges]: `GRESB - Évaluation de la performance ESG`,
    [MyHiveLocalizationKey.Tnfdtaskforceon]: `TNFD - Groupe de travail sur les informations financières liées à la nature`,
    [MyHiveLocalizationKey.Csrdcorporatesustainability]: `CSRD - Directive sur la publication d’informations extra-financières`,
    [MyHiveLocalizationKey.Breeaminuse]: `BREEAM – Évaluation de la performance durable des bâtiments`,
    [MyHiveLocalizationKey.BNG]: `BNG - Biodiversity Net Gain (UK)`, //TODO
    [MyHiveLocalizationKey.Continue]: `Continuer`,
    [MyHiveLocalizationKey.Doyouprefer]: `Préférez-vous explorer les analyses au niveau du site ou des résumés au niveau du portefeuille ?`, //TODO
    [MyHiveLocalizationKey.Sitelevel]: `Niveau du site`, //TODO
    [MyHiveLocalizationKey.Portfoliolevel]: `Niveau du portefeuille`, //TODO
    [MyHiveLocalizationKey.Completeonboarding]: `Terminer`,

    [ContactRole.PropertyTeam]: 'Équipe de gestion d’immeuble',
    [ContactRole.AssetManagementTeam]: 'Équipe de gestion d’actifs',
    [ContactRole.SustainabilityTeam]: 'Équipe de développement durable',
    [ContactRole.TenantOccupant]: 'Locataire / Occupant',
    [ContactRole.MarketingAndCommsTeam]: 'Équipe marketing et communications',

    [MyHiveLocalizationKey.NatureAgentToolTipTitle]: 'Meet your Nature Agent',
    [MyHiveLocalizationKey.NatureAgentToolTipDesc]: `This is your space to ask questions about your biodiversity impacts and opportunities. Your Nature Agent can provide insights related to nature and biodiversity reporting for your program, tenant engagement and more. It can help you learn, discover and support your nature-related goals. Ask about your impacts, or say simply say hello to get started!

Ask about your impacts, or say simply say hello to get started!`,
    [MyHiveLocalizationKey.MarketingSiteUrl]: getMarketingSiteUrl('fr'),
    [MyHiveLocalizationKey.EmailPreview]: 'Aperçu du courriel',
    [MyHiveLocalizationKey.ShareSuccess1]: 'Votre courriel est en route !',
    [MyHiveLocalizationKey.ShareSuccess2]: 'Vérifiez votre boîte de réception pour un courriel de confirmation.',
    [MyHiveLocalizationKey.AddFromCsv]: 'Téléverser un .csv',
    [MyHiveLocalizationKey.BodyEmail]: 'Message :',
    [MyHiveLocalizationKey.Close]: 'Fermer',
    [MyHiveLocalizationKey.More]: 'autres',
    [MyHiveLocalizationKey.BackToEdit]: 'Retour à la modification',
    [MyHiveLocalizationKey.Send]: 'Envoyer',
    [MyHiveLocalizationKey.WithTenants]: 'avec les locataires',
    [MyHiveLocalizationKey.BoostEngagementShare]:
      'Stimulez l’engagement ! Partagez votre page MaRuche avec votre réseau de locataires et vos principaux contacts afin que tout le monde puisse participer.',
    [MyHiveLocalizationKey.InviteYourTenantsToRegister]:
      'Stimulez l’engagement ! Partagez votre event MaRuche avec votre réseau de locataires et vos principaux contacts afin que tout le monde puisse participer.',
    [MyHiveLocalizationKey.EmailAddresses]: 'Adresses courriel',
    [MyHiveLocalizationKey.EmailAddressesPlaceholder]:
      'Exemple : clé.locataire@entreprise.com, clé.locataire2@entreprise.com, clé.locataire3@entreprise.com',
    [MyHiveLocalizationKey.EmailAddressesHint]: 'Séparez plusieurs adresses avec des virgules ou des sauts de ligne',
    [MyHiveLocalizationKey.CustomMessage]: 'Personnalisez votre message (optionnel) :',
    [MyHiveLocalizationKey.CustomMessageText]:
      'Dans le cadre de notre programme de durabilité, nous sommes heureux de partager la page Alvéole de notre édifice – un espace pour vous et votre équipe afin de suivre ce que font les abeilles, vous inscrire aux événements et réclamer des pots de miel.\n\nMerci de partager ceci avec votre équipe afin qu’elle puisse aussi en profiter !',
    [MyHiveLocalizationKey.CustomMessageHint]: 'Ajouter un message à partager avec les locataires',
    [MyHiveLocalizationKey.PreviewSend]: 'Aperçu et envoi',

    [MyHiveLocalizationKey.PreviewFrom]: 'De :',
    [MyHiveLocalizationKey.PreviewTo]: 'À :',
    [MyHiveLocalizationKey.PreviewSubject]: 'Objet :',
    [MyHiveLocalizationKey.PreviewSubjectText]: 'vous invite à découvrir la nature à votre édifice',
    [MyHiveLocalizationKey.PreviewSubjectTextEvent]: 'vous invite à',
    [MyHiveLocalizationKey.PreviewClickToExplore]: 'Cliquez pour explorer :',
    [MyHiveLocalizationKey.Share]: 'Partager',
    [MyHiveLocalizationKey.NeedSupport]: "Besoin d'aide?",
    [MyHiveLocalizationKey.WelcomeToMyhive]: 'Bienvenue à Maruche',
    [MyHiveLocalizationKey.PreferencesEnableEventInterestList]: `Liste d'intérêt pour les événements`,
    [MyHiveLocalizationKey.PreferencesEnableHoneyInterestList]: `Liste d'intérêt pour le miel`,
    [MyHiveLocalizationKey.PreferencesEnableAiSupportAgent]: 'Agent de support IA',
    [MyHiveLocalizationKey.PreferencesEnableQueenFeature]: 'Nommer la reine',
    [MyHiveLocalizationKey.PreferencesEnableQueenCommunityVoting]: 'Vote communautaire',
    [MyHiveLocalizationKey.PreferencesShowUpcomingEvents]: 'Afficher les événements à venir',
    [MyHiveLocalizationKey.PreferencesShowUpcomingVisits]: 'Afficher les visites apicoles à venir',
    [MyHiveLocalizationKey.PreferencesSubscriberAlerts]:
      "Recevez des alertes par e-mail pour les nouvelles inscriptions et les événements/inscriptions à l'intérêt du miel",
    [MyHiveLocalizationKey.FaqLink]: 'https://www.alveole.buzz/fr/faq/',
    [MyHiveLocalizationKey.Subscriber]: 'Abonné(e)',
    [MyHiveLocalizationKey.Subscribers]: 'Abonné(e)s',
    [MyHiveLocalizationKey.Subscribe]: `Restez à l'affût`,
    [MyHiveLocalizationKey.AppTitle]: 'alvéole',
    [MyHiveLocalizationKey.MenuHeading]: 'alvéole',
    [MyHiveLocalizationKey.FindAHive]: 'Trouvez une ruche',
    [MyHiveLocalizationKey.HowCanWeHelp]: "Besoin d'aide?",
    [MyHiveLocalizationKey.Website]: 'Site web',
    [MyHiveLocalizationKey.Blog]: 'Blogue',
    [MyHiveLocalizationKey.English]: 'English',
    [MyHiveLocalizationKey.French]: 'Français',
    [MyHiveLocalizationKey.SignIn]: 'Connexion',
    [MyHiveLocalizationKey.Change]: 'Changer',
    [MyHiveLocalizationKey.HeroTitle]: 'Trouvez une ruche',
    [MyHiveLocalizationKey.HeroDescription]: `Vous n'êtes actuellement lié à aucune page, veuillez contacter votre personne-ressource chez Alvéole pour commencer.`,
    [MyHiveLocalizationKey.HeroSearch]: 'Rechercher un projet par nom ou par adresse',
    [MyHiveLocalizationKey.HeroHives]: 'ruches',
    [MyHiveLocalizationKey.HeroBees]: "d'abeilles",
    [MyHiveLocalizationKey.HeroCities]: 'villes',
    [MyHiveLocalizationKey.HeroPeople]: 'gens touchés',
    [MyHiveLocalizationKey.NoHivesFound]: 'Aucune ruche trouvée',

    [MyHiveLocalizationKey.NearbyBuzzTitle]: 'Les Buzzs de votre quartier',
    [MyHiveLocalizationKey.NearbyBuzzDescription]: 'Découvrez ce qui se passe chez les ruches voisines à votre ville',
    [MyHiveLocalizationKey.NearbyBuzzVisit]: 'Visitez cette ruche',

    [MyHiveLocalizationKey.WhereWeBuzzTitle]: 'Là où on «Buzz»',
    [MyHiveLocalizationKey.WhereWeBuzzDescription]: 'Alvéole Buzz un peu partout dans le monde. Explorez!',
    [MyHiveLocalizationKey.WhereWeBuzzUnitedStates]: 'États-Unis',
    [MyHiveLocalizationKey.WhereWeBuzzVisit]: 'Visitez cette ruche',

    [MyHiveLocalizationKey.JoinMovementTitle]: 'Joignez-vous au mouvement!',
    [MyHiveLocalizationKey.JoinMovementDescription]:
      "Engagez vos employés et atteignez vos objectifs durables en vous impliquant. L'apiculture urbaine a un petit quelque chose pour tout le monde.",
    [MyHiveLocalizationKey.JoinMovementButton]: 'EXPLOREZ',
    [MyHiveLocalizationKey.FooterCopyright]: '© 2021 Alvéole, Inc. Tous droits réservés',
    [MyHiveLocalizationKey.FooterTerms]: 'Conditions générales',
    [MyHiveLocalizationKey.FooterPrivacy]: 'Politque de vie privée',

    [MyHiveLocalizationKey.Edit]: 'Modifier',
    [MyHiveLocalizationKey.Save]: 'Sauvegarder',
    [MyHiveLocalizationKey.Cancel]: 'Annuler',
    [MyHiveLocalizationKey.Remove]: 'Retirer',

    [MyHiveLocalizationKey.RemoveBuzzTitle]: 'Retirer le buzz',
    [MyHiveLocalizationKey.RemoveBuzzDescription]: 'Êtes-vous sûr de vouloir retirer définitivement ce buzz?',

    [MyHiveLocalizationKey.CreateABuzz]: 'Créer un buzz',
    [MyHiveLocalizationKey.CreateABuzzPlaceholder]: 'Quoi de neuf?',
    [MyHiveLocalizationKey.CreateABuzzPost]: 'Publier',
    [MyHiveLocalizationKey.CreateABuzzUploadText]: "Ajouter Jusqu'à 5 photos/vidéos",
    [MyHiveLocalizationKey.CreateABuzzPostToText]: 'Publier sur',
    [MyHiveLocalizationKey.CreateABuzzPagesText]: 'pages',
    [MyHiveLocalizationKey.Order]: 'Ordre',

    [MyHiveLocalizationKey.BuzzTimeLine]: 'Chronologie',
    [MyHiveLocalizationKey.Community]: 'Communauté',
    [MyHiveLocalizationKey.BuzzCharacters]: 'caractères',

    [MyHiveLocalizationKey.JoinWaitingList]: 'Je suis intéressé(e)',
    [MyHiveLocalizationKey.GuestsInterested]: 'Invités intéressés',
    [MyHiveLocalizationKey.JoinWaitingListTitle]: `Rejoindre la liste d'attente de l'événement`,
    [MyHiveLocalizationKey.JoinWaitingListDescription]:
      'Indiquez vos coordonnées pour être parmi les premiers informés des prochains événements!',
    [MyHiveLocalizationKey.FullName]: 'Nom complet',
    [MyHiveLocalizationKey.OrgName]: 'Entrez le nom de votre organisation',
    [MyHiveLocalizationKey.JoinList]: 'Rejoindre la liste',
    [MyHiveLocalizationKey.InterestedInEvents]: 'Activités liées à la nature',
    [MyHiveLocalizationKey.EveryAlveoleProgram]: `Chaque programme d'Alvéole comprend des activités guidées par des experts de la nature.`,
    [MyHiveLocalizationKey.ConnectWithUrbanBio]: 'Découvrez la biodiversité urbaine ',
    [MyHiveLocalizationKey.GetHandsOn]: 'Participez à des activités interactives avec la nature',
    [MyHiveLocalizationKey.EnjoyWorkshops]: 'Profitez des ateliers, des visites de la ruche et des accès aux coulisses',
    [MyHiveLocalizationKey.WatchForNextEvent]: `Restez à l'affût de votre prochain événement — à ne pas manquer !`,
    [MyHiveLocalizationKey.BookAnEvent]: 'Réservez un événement',
    [MyHiveLocalizationKey.ViewList]: 'Voir la liste',
    [MyHiveLocalizationKey.Export]: 'Exporter',
    [MyHiveLocalizationKey.ExportFilteredList]: 'Exporter la liste filtrée',
    [MyHiveLocalizationKey.PeopleFollowingThisPage]: 'personnes suivent cette page',
    [MyHiveLocalizationKey.FilterAll]: 'Tous',
    [MyHiveLocalizationKey.FollowNewPosts]: 'Suivre les nouvelles publications',
    [MyHiveLocalizationKey.FollowEvents]: 'Suivre les événements',
    [MyHiveLocalizationKey.InterestedInHoneyTab]: 'Intéressé(e) par le miel',
    [MyHiveLocalizationKey.InviteMoreTenants]: 'Inviter d’autres locataires',
    [MyHiveLocalizationKey.NoSubscribersYet]: 'Aucun abonné pour le moment',
    [MyHiveLocalizationKey.NoSubscribersMatchFilter]: 'Aucun abonné ne correspond à ce filtre',
    [MyHiveLocalizationKey.InterestedUsers]: 'Utilisateurs intéressés',
    [MyHiveLocalizationKey.PeopleMarkedAsInterested]: 'personnes marquées comme intéressées',
    [MyHiveLocalizationKey.PersonMarkedAsInterested]: 'personne marquées comme intéressées',
    [MyHiveLocalizationKey.StayUpdated]: 'Restez au courant des événements et du miel.',
    [MyHiveLocalizationKey.MoreUpcomingEvents]: 'Événements à venir',
    [MyHiveLocalizationKey.InterstedInEvents]: 'Intéressé par les événements',
    [MyHiveLocalizationKey.InterestedInHoney]: 'Intéressé par le miel',
    [MyHiveLocalizationKey.GetOnTheHoneyList]: 'Le miel de votre immeuble',
    [MyHiveLocalizationKey.HoneyFromHive]: 'Vous serez le premier à être informé des pots disponibles.',
    [MyHiveLocalizationKey.AddMeToTheList]: 'Ajoutez-moi',
    [MyHiveLocalizationKey.HarvestBegins]: 'La récolte commence',
    [MyHiveLocalizationKey.DeliveredBy]: 'Livré par',
    [MyHiveLocalizationKey.Delivery]: 'Livraison',
    [MyHiveLocalizationKey.ComingSoon]: 'À venir!',
    [MyHiveLocalizationKey.WaitingListJoined]: `Liste d'attente rejointe!`,
    [MyHiveLocalizationKey.ThanksWaitingList]: `Merci! Vous avez été ajouté(e) à la liste d'attente pour les événements à venir.`,
    [MyHiveLocalizationKey.ReferWorkBestie]: 'Invite ton/ta BFF du boulot',
    [MyHiveLocalizationKey.WorkBestieEvents]: `Un(e) collègue curieux(se) des abeilles ? Invitez-le/la à s'inscrire sur la liste d'attente!`,
    [MyHiveLocalizationKey.ShareThisLink]: 'Partager ce lien:',
    [MyHiveLocalizationKey.CopyLink]: 'Copier le lien',
    [MyHiveLocalizationKey.CopyEmail]: "Copier l'adresse courriel",
    [MyHiveLocalizationKey.Copied]: 'Copié!',

    [MyHiveLocalizationKey.HoneyInterestJoined]: 'Intérêt pour le miel enregistré!',
    [MyHiveLocalizationKey.ThanksWellNotify]: `Merci! On vous avertira dès que le miel frais sera prêt.`,
    [MyHiveLocalizationKey.WorkBestieHoney]:
      'Vous pensez que votre collègue apprécierait du miel artisanal? Faites-lui passer le mot!',

    [MyHiveLocalizationKey.FollowTheBuzz]: `Restez à l'affût`,
    [MyHiveLocalizationKey.FollowTheBuzzDescription]: 'Restez au courant des événements et du miel.',
    [MyHiveLocalizationKey.FollowTheBuzzYourEmail]: 'Courriel professionnel',
    [MyHiveLocalizationKey.FollowTheBuzzSignUp]: "S'abonner",
    [MyHiveLocalizationKey.FollowTheBuzzThankyou]: 'Merci!',
    [MyHiveLocalizationKey.ProgramOverview]: 'Aperçu du programme',
    [MyHiveLocalizationKey.ProgramOverviewDescription]:
      "Dans le cadre de notre programme, nous sommes fiers d'héberger une ruche avec des milliers d'abeilles heureuses et travailleuses qui pollinisent le quartier.",
    [MyHiveLocalizationKey.ProgramOverviewButton]: 'Lisez plus',
    [MyHiveLocalizationKey.GetInvolved]: 'Impliquez-vous!',
    [MyHiveLocalizationKey.KeepLearning]: 'Apprenez-en plus',
    [MyHiveLocalizationKey.KeepLearningDescription]:
      "Parcourez nos plus récents articles de blogue et accédez aux guides d'apiculture.",
    [MyHiveLocalizationKey.KeepLearningButton]: 'Lisez plus',
    [MyHiveLocalizationKey.HaveAquestion]: 'Vous avez une question?',
    [MyHiveLocalizationKey.HaveAquestionDescription]:
      'Nous adorerions discuter davantage des services Alvéole et répondre à vos questions.',
    [MyHiveLocalizationKey.HaveAquestionButton]: 'Visitez notre FAQ',
    [MyHiveLocalizationKey.UpcomingEvents]: 'Événements à venir',
    [MyHiveLocalizationKey.ScheduledVisits]: 'Prochaines visites prévues',
    [MyHiveLocalizationKey.Beekeeper]: 'Apiculteur:',
    [MyHiveLocalizationKey.AddToCalendar]: 'Ajouter à votre calendrier',
    [MyHiveLocalizationKey.ShowAll]: 'Tout afficher',
    [MyHiveLocalizationKey.ShowLess]: 'Afficher moins',
    [MyHiveLocalizationKey.NoUpcomingVisits]: 'Aucune visite prévue pour le moment',
    [MyHiveLocalizationKey.NoUpcomingEvents]: 'Aucun événement prévu pour le moment',
    [MyHiveLocalizationKey.PleaseEnterAValidEmail]: 'Veuillez entrer une adresse courriel valide',
    [MyHiveLocalizationKey.BuzzWeatherCold]: 'Il fait froid, les abeilles forment un amas autour de leur reine.',
    [MyHiveLocalizationKey.BuzzWeatherHot]: 'Il fait chaud! Les ventileuses doivent aérer la ruche pour la rafraîchir.',
    [MyHiveLocalizationKey.BuzzWeatherRainy]: 'Il pleut, les abeilles restent confinées à l’intérieur de la ruche.',
    [MyHiveLocalizationKey.BuzzWeatherCloudy]: 'Le ciel est nuageux, les butineuses réduisent leurs activités.',
    [MyHiveLocalizationKey.BuzzWeatherSunny]: 'Il fait soleil! Les butineuses ramènent nectar et pollen en quantité.',

    [MyHiveLocalizationKey.GalleryTitle]: 'Galerie',
    [MyHiveLocalizationKey.GalleryDescription]:
      "Voir toutes les images de votre fil d'actualités MaRuche au même endroit. Cliquez sur une image pour l'agrandir ou utilisez le bouton de téléchargement pour l'enregistrer sur votre appareil.",
    [MyHiveLocalizationKey.HoneyLabelTitle]: "Conception d'étiquette de miel",
    [MyHiveLocalizationKey.HoneyLabelDescription]:
      "Bientôt, vous pourrez consulter et approuver votre design existant, ou créer et personnaliser un nouveau design à l'aide de notre outil de conception.",
    [MyHiveLocalizationKey.HoneyLabelTabYourLabel]: 'Votre étiquette de miel',
    [MyHiveLocalizationKey.HoneyLabelTabDesignOwn]: 'Concevez votre propre étiquette',
    [MyHiveLocalizationKey.HoneyLabelTabFaq]: 'FAQ',
    [MyHiveLocalizationKey.HoneyLabelApprove]: 'Approuver ce design',
    [MyHiveLocalizationKey.HoneyLabelOr]: 'ou',
    [MyHiveLocalizationKey.HoneyLabelCreate]: 'Créer un nouveau design',
    [MyHiveLocalizationKey.HoneyLabelNoLabel]: 'Aucune étiquette pour le moment',
    [MyHiveLocalizationKey.HoneyLabelDesignSubmitted]: 'Votre design a été soumis',
    [MyHiveLocalizationKey.HoneyLabelFaqDesignGuideTitle]: 'Puis-je concevoir mes étiquettes en interne?',
    [MyHiveLocalizationKey.HoneyLabelFaqDesignGuideContentTwo]: 'Suivez simplement les directives ici : ',
    [MyHiveLocalizationKey.HoneyLabelFaqDesignLink]:
      'Puis-je concevoir mes propres étiquettes de pots de miel en interne ?',

    [MyHiveLocalizationKey.HoneyLabelFaqDesignGuideContent]: 'En bref : oui!',
    [MyHiveLocalizationKey.HoneyLabelFaqDimensionsTitle]: 'Dimensions :',
    [MyHiveLocalizationKey.HoneyLabelFaqDimensionsList]: `Taille : 5,5" x 1,0925" (13,97 cm x 2,77 cm)
Fond perdu (bleed) : 0,125" (0,318 cm) (espace supplémentaire autour de l'étiquette)
Marge de sécurité : 0,125" (0,318 cm) (gardez tous les éléments importants à l'intérieur de cette zone)`,
    [MyHiveLocalizationKey.HoneyLabelFaqRequiredInfoTitle]:
      'Informations obligatoires (texte disponibles dans nos modèles)',
    [MyHiveLocalizationKey.HoneyLabelFaqRequiredInfoList]: `Miel non pasteurisé
Poids (selon le système de mesure de votre pays) : 130 g, 100 ml, 4.6 oz
Votre ville et votre pays
« Récolté par Alvéole »
« Ne pas donner aux enfants de moins de 1 an »`,
    [MyHiveLocalizationKey.HoneyLabelFaqExportingTitle]: 'Enregistrez votre design',
    [MyHiveLocalizationKey.HoneyLabelFaqExportingList]: `Format : PNG, SVG ou JPEG
Conservez uniquement le fond perdu, le fichier devrait mesurer au total 5.75 x 1.3425" (14,605 x 3,41 cm)
Supprimez toutes les marques de coupe et les bordures`,
    [MyHiveLocalizationKey.HoneyLabelFaqUploadingTitle]: 'Téléchargez votre design',
    [MyHiveLocalizationKey.HoneyLabelFaqUploadingList]: `Connectez-vous à votre Portail MyHive
Ouvrez le menu de gauche et sélectionnez la section "Étiquette de miel"
Cliquez sur Téléchargez un logo ou un design et ajustez votre fichier dans la zone de découpe
Soumettez votre étiquette ✅`,
    [MyHiveLocalizationKey.HoneyLabelFaqWhyFromScratchTitle]:
      'Pourquoi ne pouvez-vous pas modifier votre design de 2025 ? Et pourquoi devez-vous créer une nouvelle étiquette ?',
    [MyHiveLocalizationKey.HoneyLabelFaqWhyFromScratchIntro]:
      'On comprend, repartir de zéro peut sembler décourageant… Mais laissez-nous vous expliquer pourquoi ! 🌼',
    [MyHiveLocalizationKey.HoneyLabelFaqWhyChangeTitle]: 'Pourquoi ce changement ?',
    [MyHiveLocalizationKey.HoneyLabelFaqWhyChangeContent]:
      "Pour vous offrir une expérience de création plus fluide, plus rapide et, surtout, plus amusante, nous avons mis en place un tout nouvel outil de d'auto-conception d'étiquettes.\nVous y trouverez une foule de modèles, de couleurs, de polices et d'illustrations pour créer une étiquette qui vous ressemble, sans aller-retour par courriel ni délai d'attente. 🎨",
    [MyHiveLocalizationKey.HoneyLabelFaqWhyNotModifyTitle]:
      'Pourquoi ne pouvez-vous pas modifier votre ancienne étiquette dans ce nouvel outil ?',
    [MyHiveLocalizationKey.HoneyLabelFaqWhyNotModifyContent]:
      "Votre design 2024 a été réalisé à l'aide d'Adobe Illustrator. Notre nouvel outil ne permet malheureusement pas de convertir ce format en version modifiable.\nMais la bonne nouvelle, c'est que vous pouvez maintenant explorer nos nouveaux modèles et en choisir un qui vous inspire, puis le personnaliser à votre goût !",
    [MyHiveLocalizationKey.HoneyLabelFaqByeByeWaitingTitle]: "Fini l'attente ✨",
    [MyHiveLocalizationKey.HoneyLabelFaqByeByeWaitingContent]:
      "Plus besoin d'envoyer votre logo par courriel ni d'attendre plusieurs jours (voire semaines) pour recevoir un aperçu et l'approuver! Avec l'outil en libre-service, vous créez, ajustez et soumettez votre design en un seul endroit, en quelques clics.",
    [MyHiveLocalizationKey.HoneyLabelFaqMoreOptionsTitle]: "Plus d'options, plus de créativité 🐝",
    [MyHiveLocalizationKey.HoneyLabelFaqMoreOptionsContent]:
      "On vous propose une toute nouvelle sélection de modèles, de styles, de couleurs et d'illustrations. De quoi laisser libre cours à votre imagination et créer une étiquette qui se démarque.",
    [MyHiveLocalizationKey.HoneyLabelFaqFreshLabelTitle]: 'Une nouvelle étiquette chaque année ? Pourquoi pas !',
    [MyHiveLocalizationKey.HoneyLabelFaqFreshLabelContent]:
      'Et si vous profitiez de chaque saison pour donner un nouveau look à vos pots de miel ? Avec notre outil, vous pouvez créer une nouvelle étiquette chaque année !',
    [MyHiveLocalizationKey.HoneyLabelFaqContentChangesTitle]: 'Changements de contenu sur les étiquettes',
    [MyHiveLocalizationKey.HoneyLabelFaqContentChangesContent]:
      "Nous avons simplifié et clarifié le contenu afin d'offrir un design plus épuré et minimaliste, en retirant les éléments non essentiels.\n👉 Vous comptez vendre ce produit en épicerie ?\n Contactez-nous à support@alveole.buzz pour en savoir plus sur les exigences légales applicables.",
    [MyHiveLocalizationKey.HoneyLabelGuideTitle]: 'Concevez votre étiquette de miel : guide étape par étape',
    [MyHiveLocalizationKey.HoneyLabelGuideRequiredCustomizationTitle]: 'Personnalisation requise',
    [MyHiveLocalizationKey.HoneyLabelChooseYourDesign]: 'Étape 1 : Choisissez Votre Design',
    [MyHiveLocalizationKey.HoneyLabelGuideChooseTemplate]:
      '**Choisissez un modèle :** Cliquez sur **« Options de design »** dans le menu de gauche pour sélectionner un modèle qui vous plaît, ou téléchargez votre propre étiquette en suivant les directives*.',
    [MyHiveLocalizationKey.HoneyLabelGuideUploadLogo]:
      '**Téléchargez votre logo :** Cliquez sur **« Télécharger un logo »** et importez un fichier SVG, PNG, JPEG en haute résolution.',
    [MyHiveLocalizationKey.HoneyLabelGuideEnterCity]:
      "**Entrez votre ville :** Remplacez le texte **« Ville, pays »** par l'emplacement approprié.",
    [MyHiveLocalizationKey.HoneyLabelGuideOptionalCustomizationTitle]: 'Personnalisation facultative',
    [MyHiveLocalizationKey.HoneyLabelGuideAddQRCode]:
      '**Ajoutez votre code QR MaRuche :** Cliquez sur **« Code QR »**, sélectionnez **« Générer et ajouter »**, puis supprimez le code QR par défaut (lié à alveole.buzz). Redimensionnez le nouveau code QR et placez-le à l\'endroit souhaité. Dimension min: 0.4" x 0.4"',
    [MyHiveLocalizationKey.HoneyLabelGuideCustomizeColors]:
      '**Personnalisez les couleurs, la police et le texte:** Adaptez les couleurs, la typographie et les textes pour refléter votre image de marque.',
    [MyHiveLocalizationKey.HoneyLabelGuideAddArtwork]:
      '**Ajoutez des illustrations:** Intégrez des cliparts ou des formes pour embellir votre étiquette.',
    [MyHiveLocalizationKey.HoneyLabelGuideSaveSubmitTitle]: 'Enregistrer le brouillon et soumettre votre étiquette',
    [MyHiveLocalizationKey.HoneyLabelGuideSaveDraft]:
      '**Enregistrez votre brouillon:** Cliquez sur **« Enregistrer le brouillon »** pour sauvegarder votre travail et y revenir plus tard.',
    [MyHiveLocalizationKey.HoneyLabelGuideSubmitDesign]:
      '**Soumettez votre étiquette:** allez sur la page « Votre étiquette de miel » et cliquez « Approuver ce design ».',
    [MyHiveLocalizationKey.HoneyLabelGuideUploadOwnLabel]:
      "***Téléversez votre propre étiquette de miel :** Si vous préférez concevoir votre étiquette à l'interne à l'aide d'un autre logiciel de conception, veuillez consulter l'onglet FAQ sous **« Téléverser un design entièrement personnalisé : spécifications d'étiquette »**",
    [MyHiveLocalizationKey.HoneyLabelWatchATutorial]: 'Regardez un tutoriel',
    [MyHiveLocalizationKey.HoneyLabelDesignToolDown]:
      "L'outil de création d'étiquettes est temporairement indisponible. Nous nous excusons pour le désagrément et travaillons à le rétablir dans les plus brefs délais.",
    [MyHiveLocalizationKey.QueenFormTitle]: 'Nommer la reine',
    [MyHiveLocalizationKey.QueenFormSubtitle]:
      'Notre reine travaille sans relâche. Aidez-nous à lui trouver le nom parfait !',
    [MyHiveLocalizationKey.QueenFormPlaceholder]: 'Proposez un nom royal...',
    [MyHiveLocalizationKey.QueenFormProfilePrompt]:
      "Dites-nous qui vous êtes pour qu'on puisse vous créditer pour votre proposition !",
    [MyHiveLocalizationKey.QueenFormFirstNameLabel]: 'Prénom',
    [MyHiveLocalizationKey.QueenFormLastNameLabel]: 'Nom',
    [MyHiveLocalizationKey.QueenFormCompanyLabel]: 'Entreprise',
    [MyHiveLocalizationKey.QueenFormFirstNameRequired]: 'Le prénom est requis',
    [MyHiveLocalizationKey.QueenFormLastNameRequired]: 'Le nom est requis',
    [MyHiveLocalizationKey.QueenFormCompanyRequired]: "L'entreprise est requise",
    [MyHiveLocalizationKey.QueenFormSubmitting]: 'Envoi en cours…',
    [MyHiveLocalizationKey.QueenFormSubmit]: 'Soumettre le nom',
    [MyHiveLocalizationKey.QueenFormViewSubmissions]: 'Voir les noms proposés',
    [MyHiveLocalizationKey.QueenFormSubmitError]: 'Impossible de soumettre votre proposition. Veuillez réessayer.',
    [MyHiveLocalizationKey.QueenFormProfileError]: 'Impossible de mettre à jour votre profil. Veuillez réessayer.',
    [MyHiveLocalizationKey.QueenSignInTitle]: 'Rejoignez la ruche pour soumettre votre idée 👑',
    [MyHiveLocalizationKey.QueenSignInTitleViewSubmissions]: 'Rejoignez la ruche pour voir les noms soumis',
    [MyHiveLocalizationKey.QueenSignInMessage]: 'On vous ramènera ici pour terminer votre soumission.',
    [MyHiveLocalizationKey.QueenSignInMessageViewSubmissions]: 'On vous ramènera ici pour voir les soumissions.',
    [MyHiveLocalizationKey.QueenSubmittedTitle]: 'Nom soumis !',
    [MyHiveLocalizationKey.QueenSubmittedMessage]: 'La ruche a reçu votre soumission royale.',
    [MyHiveLocalizationKey.QueenSubmittedYourSuggestion]: 'Votre suggestion',
    [MyHiveLocalizationKey.QueenSubmittedViewBoard]: 'Voir tous les noms et votes',
    [MyHiveLocalizationKey.QueenInviteColleagueButton]: 'Inviter un collègue',
    [MyHiveLocalizationKey.QueenInviteColleagueDescription]:
      "Partagez cette ruche avec quelqu'un qui pourrait vouloir proposer un nom royal.",
    [MyHiveLocalizationKey.QueenInviteSending]: 'Envoi en cours…',
    [MyHiveLocalizationKey.QueenInviteSent]: 'Invitation envoyée !',
    [MyHiveLocalizationKey.QueenInviteSendButton]: "Envoyer l'invitation",
    [MyHiveLocalizationKey.QueenInviteError]: "Une erreur s'est produite. Veuillez réessayer.",
    [MyHiveLocalizationKey.QueenSubmittedStaticMessage]:
      "Merci pour votre proposition ! On vous informera dès qu'un nom aura été choisi.",
    [MyHiveLocalizationKey.QueenVotingTitle]: 'Le Conseil royal des noms',
    [MyHiveLocalizationKey.QueenVotingSubtitle]: "Votez pour vos favoris ! Le nom le plus populaire l'emporte",
    [MyHiveLocalizationKey.QueenNoSubmissionsYet]: "Aucune soumission pour l'instant",
    [MyHiveLocalizationKey.QueenBeFirstToSubmit]: 'Soyez le premier à proposer un nom ! 👑',
    [MyHiveLocalizationKey.QueenAdminVotingTitle]: 'Noms soumis',
    [MyHiveLocalizationKey.QueenAdminVotingSubtitleVoting]:
      'Couronnez votre reine — guidé par les votes de la communauté.',
    [MyHiveLocalizationKey.QueenAdminVotingSubtitleNoVoting]:
      'Couronnez votre reine à partir des soumissions ci-dessous.',
    [MyHiveLocalizationKey.QueenAdminCrownButton]: 'Couronner',
    [MyHiveLocalizationKey.QueenAdminCrownAriaLabel]: 'Couronner {{name}}',
    [MyHiveLocalizationKey.QueenAdminBackToSettings]: 'Retour aux paramètres',
    [MyHiveLocalizationKey.QueenConfirmTitle]: 'Couronner la reine ?',
    [MyHiveLocalizationKey.QueenConfirmMessage]:
      "Cette action met fin à l'élection et annonce la gagnante à tous les abonnés.",
    [MyHiveLocalizationKey.QueenConfirmSelectedName]: 'Nom sélectionné',
    [MyHiveLocalizationKey.QueenConfirmNominatedBy]: 'Proposé par',
    [MyHiveLocalizationKey.QueenConfirmVotesSingular]: '{{count}} vote',
    [MyHiveLocalizationKey.QueenConfirmVotesPlural]: '{{count}} votes',
    [MyHiveLocalizationKey.QueenConfirmSubmit]: 'Confirmer et couronner',
    [MyHiveLocalizationKey.QueenConfirmSubmitting]: 'Couronnement…',
    [MyHiveLocalizationKey.QueenConfirmError]: 'Impossible de couronner cette candidate. Veuillez réessayer.',
    [MyHiveLocalizationKey.QueenConfirmFinalTitle]: 'Êtes-vous certain·e ?',
    [MyHiveLocalizationKey.QueenConfirmFinalMessage]:
      "Cette action met fin à l'élection et avise tous les abonnés. Elle est irréversible.",
    [MyHiveLocalizationKey.QueenConfirmFinalSubmit]: 'Oui, couronner la reine',
    [MyHiveLocalizationKey.QueenWinnerTitle]: 'Vive la reine !',
    [MyHiveLocalizationKey.QueenWinnerSubtitle]: 'La ruche a choisi.',
    [MyHiveLocalizationKey.QueenWinnerNamePrefix]: 'Le nom de notre reine est...',
    [MyHiveLocalizationKey.QueenWinnerCrownedWithVotesSingular]: 'Couronnée avec {{count}} vote',
    [MyHiveLocalizationKey.QueenWinnerCrownedWithVotesPlural]: 'Couronnée avec {{count}} votes',
    [MyHiveLocalizationKey.QueenWinnerCrownedByCommunity]: 'Couronnée par notre communauté',
    [MyHiveLocalizationKey.QueenAdminHomeTitle]: 'Gérez votre concours pour nommer la reine',
    [MyHiveLocalizationKey.QueenAdminWinnerChosen]: 'Gagnante choisie',
    [MyHiveLocalizationKey.QueenAdminWinnerNominatedBy]: 'Proposée par {{initials}} · {{organization}}',
    [MyHiveLocalizationKey.QueenAdminDeadlineMessage]: "Les abonnés ont jusqu'au {{date}} pour soumettre des noms.",
    [MyHiveLocalizationKey.QueenAdminNoDeadlineMessage]:
      'Fixez une date limite et couronnez votre gagnante une fois les soumissions reçues.',
    [MyHiveLocalizationKey.QueenAdminDeadlineLabel]: 'Date limite de soumission',
    [MyHiveLocalizationKey.QueenAdminDeadlineTooltip]:
      'Nous informerons les abonnés de la date limite, enverrons des rappels et vous inviterons à choisir le nom gagnant 👑',
    [MyHiveLocalizationKey.QueenAdminDeadlineSetButton]: 'Fixer la date limite',
    [MyHiveLocalizationKey.QueenAdminDeadlineUpdateButton]: 'Modifier la date limite',
    [MyHiveLocalizationKey.QueenAdminDeadlineSaving]: 'Enregistrement…',
    [MyHiveLocalizationKey.QueenAdminDeadlineError]: "Impossible d'enregistrer la date limite. Veuillez réessayer.",
    [MyHiveLocalizationKey.QueenAdminShareWithTenants]: 'Partager avec les locataires',
    [MyHiveLocalizationKey.QueenAdminShareDeadlineRequired]: "Fixez une date limite avant d'inviter les locataires",
    [MyHiveLocalizationKey.QueenAdminUpdateDeadlineConfirmTitle]: 'Mettre à jour la date limite ?',
    [MyHiveLocalizationKey.QueenAdminUpdateDeadlineConfirmMessage]:
      'Mettre à jour la date limite enverra une nouvelle notification aux abonnés de la page.',
    [MyHiveLocalizationKey.QueenAdminSuggestNameLabel]: 'Proposez un nom vous-même',
    [MyHiveLocalizationKey.QueenCountdownClosed]: 'Élection terminée',
    [MyHiveLocalizationKey.QueenCountdownDaysSingular]: "🗓️ {{count}} jour avant l'élection",
    [MyHiveLocalizationKey.QueenCountdownDaysPlural]: "🗓️ {{count}} jours avant l'élection",
    [MyHiveLocalizationKey.QueenShareTenantsHeading]: 'Invitez votre communauté à aider à nommer votre reine !',
    [MyHiveLocalizationKey.QueenShareTenantsSubheading]:
      "Partagez cette occasion d'engagement avec votre réseau de locataires et vos contacts principaux pour que tout le monde puisse participer.",
    [MyHiveLocalizationKey.QueenShareTenantsFallbackSomeone]: "Quelqu'un",
    [MyHiveLocalizationKey.QueenShareTenantsFallbackHive]: 'notre ruche',
    [MyHiveLocalizationKey.QueenShareTenantsDefaultMessage]: `{{senderName}} aimerait votre aide pour nommer la reine ! 👑🐝

Notre ruche à {{pageTitle}} a une reine travailleuse… et il lui faut un nom ! On invite notre communauté à proposer des idées de noms royaux et à voter pour leurs préférés sur notre page Alvéole.

Que ce soit ingénieux, classique ou complètement inattendu, on a hâte de voir vos idées. Le nom gagnant sera annoncé bientôt ! 🎉`,
    [MyHiveLocalizationKey.WorkshopsTitle]: 'Ateliers',
    [MyHiveLocalizationKey.WorkshopsButton]: 'Regarder la vidéo',
    [MyHiveLocalizationKey.WorkShopsInfo1Title]: 'Vous avez des questions concernant la réservation ?',
    [MyHiveLocalizationKey.WorkShopsInfo1Description]:
      "Vous ne trouvez pas de date, d'heure ou d'atelier qui vous convienne ? N'hésitez pas à contacter support@alveole.buzz",
    [MyHiveLocalizationKey.WorkShopsInfo2Title]: 'Modifier / Annuler',
    [MyHiveLocalizationKey.WorkShopsInfo2Description]:
      'Pour modifier ou annuler un atelier, veuillez vous référer à votre e-mail de confirmation.',
    [MyHiveLocalizationKey.RequestWorkshopTitle]: 'Demander un atelier',
    [MyHiveLocalizationKey.RequestWorkshopDescription]:
      'Vous ne trouvez pas de créneau qui vous convienne ? Soumettez une demande et nous ferons de notre mieux pour vous accommoder.',
    [MyHiveLocalizationKey.RequestWorkshopDescriptionPre]:
      'Vous ne trouvez pas de créneau qui vous convienne ? Soumettez une ',
    [MyHiveLocalizationKey.RequestWorkshopDescriptionLink]: 'demande',
    [MyHiveLocalizationKey.RequestWorkshopDescriptionPost]: ' et nous ferons de notre mieux pour vous accommoder.',
    [MyHiveLocalizationKey.RequestWorkshopTypePlaceholder]: "Sélectionnez un type d'atelier",
    [MyHiveLocalizationKey.RequestWorkshopDateLabel]: 'Date et heure souhaitées',
    [MyHiveLocalizationKey.RequestWorkshopSubmit]: 'Soumettre la demande',
    [MyHiveLocalizationKey.RequestWorkshopSuccess]: "Votre demande d'atelier a été soumise avec succès !",
    [MyHiveLocalizationKey.DownloadsTitle]: 'Kit promotionnel',
    [MyHiveLocalizationKey.DownloadsDescription]:
      'Tout ce dont vous avez besoin pour promouvoir votre programme de biodiversité—à portée de main. Parcourez et téléchargez notre vaste sélection de matériel promotionnel.',
    [MyHiveLocalizationKey.DownloadsPartnersTitle]: 'Annonce de partenariat',
    [MyHiveLocalizationKey.DownloadsPartnersDescription]:
      'Tout ce dont vous avez besoin pour annoncer votre partenariat avec Alvéole: des affiches personnalisables, des gabarits de courriels ainsi que des visuels pour les médias sociaux.',
    [MyHiveLocalizationKey.DownloadsWorkshopPromotionTitle]: 'Promotion de vos ateliers',
    [MyHiveLocalizationKey.DownloadsWorkshopPromotionDescription]:
      'Maximisez la visibilité de vos ateliers Alvéole avec des affiches personnalisables, prêtes à imprimer ou à partager sur vos plateformes numériques, ainsi que des gabarits de courriel.',
    [MyHiveLocalizationKey.DownloadsSpecialHolidayTitle]: 'Visuels médias sociaux',
    [MyHiveLocalizationKey.DownloadsSpecialHolidayDescription]:
      'Visuels médias sociaux: des visuels pour célébrer la Journée de la Terre, la Semaine des pollinisateurs et la Journée mondiale des abeilles.',
    [MyHiveLocalizationKey.DownloadsAveoleMediaKitTitle]: 'Kit média Alvéole',
    [MyHiveLocalizationKey.DownloadsAveoleMediaKitDescription]:
      "Trousse média Alvéole: découvrez qui nous sommes, des faits sur l'apiculture urbaine et accédez à des photos de haute qualité.",
    [MyHiveLocalizationKey.DownloadsButton]: 'Télécharger',

    [MyHiveLocalizationKey.PreferencesTitle]: 'Parametres',
    [MyHiveLocalizationKey.PreferencesTabTeam]: 'Équipe',
    [MyHiveLocalizationKey.PreferencesTabManagement]: 'Page',
    [MyHiveLocalizationKey.PreferencesHiveName]: 'Nom de ma ruche',
    [MyHiveLocalizationKey.PreferencesHiveNameDescription]: 'Il sera affiché sur votre page publique et dans vos buzz.',
    [MyHiveLocalizationKey.PreferencesHiveDescription]: 'Description de ma ruche',
    [MyHiveLocalizationKey.PreferencesHiveDescriptionDescription]:
      "Cette description s'affichera sous le nom de votre rucher, sous l'onglet principal de MaRuche.",
    [MyHiveLocalizationKey.PreferencesHivePermalink]: 'Permalien MaRuche',
    [MyHiveLocalizationKey.PreferencesHivePermalinkDescription]:
      'Personnalisez votre lien MaRuche. Juste la partie après le dernier « / » de votre URL, en minuscules et avec des tirets.',
    [MyHiveLocalizationKey.PreferencesHivePermalinkFormatErrorMessage]:
      'Uniquement des lettres minuscules, des chiffres et des tirets — pas d’espaces ni d’URL complètes.',
    [MyHiveLocalizationKey.PerferencesLanguage]: 'Langue',
    [MyHiveLocalizationKey.PreferencesVisibility]:
      'Cette ruche doit-elle apparaître dans les résultats de recherche publics ?',
    [MyHiveLocalizationKey.PreferencesQRCode]: 'Code QR',
    [MyHiveLocalizationKey.PreferencesQRCodeDescription]:
      "Ce code QR mène directement à votre page MaRuche! Ajoutez-le à vos affiches, infolettres, et écrans. Cliquez sur l'image ci-dessous pour obtenir une version haute résolution à sauvegarder.",
    [MyHiveLocalizationKey.PreferencesLogoUploadTitle]: 'Téléversement du logo',
    [MyHiveLocalizationKey.PreferencesLogoUploadDescription]:
      "Téléversez votre logo pour l'utiliser sur des supports de marque tels que la signalisation, les étiquettes de miel et autres produits. Les fichiers PNG ou SVG en haute résolution sont recommandés.",
    [MyHiveLocalizationKey.PreferencesLogoUploadChooseFile]: 'Choisir un fichier',
    [MyHiveLocalizationKey.PreferencesLogoUploadError]: 'Échec du téléversement du logo. Veuillez réessayer.',
    [MyHiveLocalizationKey.PreferencesManagementDescription]:
      "Votre profil MaRuche peut être géré par plusieurs personnes, mais vous êtes la seule personne à pouvoir gérer les permissions de gestion. Le rôle d'éditeur permet la création de buzz, l'ajout de fichiers multimédia, la modification du profil et la planification d'ateliers.",
    [MyHiveLocalizationKey.PreferencesResendInvitation]: "Renvoyer une e-mail d'invitation a MaRuche",
    [MyHiveLocalizationKey.PreferencesRemoveUser]: "Supprimer l'autorisation de cet utilisateur",
    [MyHiveLocalizationKey.PreferencesVisitReminder]: 'Recevez des rappels par courriel pour les prochaines visites',
    [MyHiveLocalizationKey.PreferencesBuzzReminder]: 'Recevez des rappels par courriel quand des Buzzs sont publiés',
    [MyHiveLocalizationKey.PreferencesVisible]: 'Visible',
    [MyHiveLocalizationKey.PreferencesUnlisted]: 'Non répertorié',

    [MyHiveLocalizationKey.EmailAddress]: 'Courriel',
    [MyHiveLocalizationKey.FirstName]: 'Nom',
    [MyHiveLocalizationKey.LastName]: 'Nom de famille',
    [MyHiveLocalizationKey.Phone]: 'Téléphone',
    [MyHiveLocalizationKey.MobilePhone]: 'Téléphone mobile',
    [MyHiveLocalizationKey.Role]: 'Rôle',
    [MyHiveLocalizationKey.AddUser]: 'Ajouter un utilisateur',
    [MyHiveLocalizationKey.ThisFieldIsRequired]: 'Ce champ est requis',
    [MyHiveLocalizationKey.ApiError]: 'Une erreur est survenue, veuillez réessayer.',
    [MyHiveLocalizationKey.SlugUnavailable]: "L'URL de votre ruche n'est pas disponible.",
    [MyHiveLocalizationKey.PreferencesMainContact]: 'Contact principal',
    [MyHiveLocalizationKey.Main]: 'Principal',
    [MyHiveLocalizationKey.PreferencesHiveContact]: 'Contact du site',
    [MyHiveLocalizationKey.Site]: 'Site',
    [MyHiveLocalizationKey.PreferencesAdditionalContacts]: 'Contacts supplémentaires :',
    [MyHiveLocalizationKey.PreferencesMainContactDescription]:
      "Responsable de la gestion principale du programme, y compris les contrats, la réservation d'événements et l'approbation des étiquettes",
    [MyHiveLocalizationKey.PreferencesHiveContactDescription]: 'Contact sur site pour les visites de routine.',
    [MyHiveLocalizationKey.PreferencesEditMainContactHint]:
      'Pour changer votre contact principal, cliquez sur le bouton "modifier"',
    [MyHiveLocalizationKey.PreferencesAdditionalContactsDescription]:
      "Membres de l'équipe qui peuvent voir et soutenir votre programme à vos côtés.",

    [MyHiveLocalizationKey.PreferencesSavedSucessHeader]: 'Préférences enregistrées avec succès!',

    [MyHiveLocalizationKey.MissingFieldsAlertHeader]: 'Champs obligatoires manquants.',
    [MyHiveLocalizationKey.MissingFieldsAlertDescription]: 'Veuillez compléter ou corriger les champs obligatoires.',

    [MyHiveLocalizationKey.HighlightedEventLabel]: 'Événement en vedette',
    [MyHiveLocalizationKey.ReadMore]: 'Vois Plus',

    [MyHiveLocalizationKey.EventListSubscriberCountLabel]: 'intéressés aux événements',
    [MyHiveLocalizationKey.HoneyListSubscriberCountLabel]: 'intéressés au miel',

    [MyHiveLocalizationKey.PageSubscribeModalHeader]: 'Restez à jour avec les abeilles',
    [MyHiveLocalizationKey.PageSubscribeModalText]:
      'Vous serez les premiers au courant des nouvelles publications de l’apiculteur, des événements à venir et des pots de miel.',

    [MyHiveLocalizationKey.SubscribeSucess]: 'Abonnement à la ruche confirmé!',
    [MyHiveLocalizationKey.ThanksSubscribe]:
      'Merci! Vous recevrez maintenant des mises à jour sur les dernières nouvelles bourdonnantes.',
    [MyHiveLocalizationKey.WorkBestieSubscribe]:
      'Vous connaissez quelqu’un qui aimerait aussi suivre les abeilles? Invitez-le à s’abonner.',

    [MyHiveLocalizationKey.Register]: 'S’inscrire',
    [MyHiveLocalizationKey.RegisterAlmostThere]: 'Une dernière étape avant de vous inscrire',
    [MyHiveLocalizationKey.RegisterSuccess]: 'Inscription réussie!',
    [MyHiveLocalizationKey.Registered]: 'Inscrit',
    [MyHiveLocalizationKey.Attended]: 'Présent',
    [MyHiveLocalizationKey.RegisteredCountLabel]: 'inscrits',

    [MyHiveLocalizationKey.InviteColleague]: 'Envie de compagnie? Invitez un collègue',
    [MyHiveLocalizationKey.SendInvite]: 'Envoyer l’invitation',
    [MyHiveLocalizationKey.Sending]: 'Envoi en cours...',

    [MyHiveLocalizationKey.Warning]: 'Avertissement',
    [MyHiveLocalizationKey.CancelRegistration]: 'Annuler l’inscription',
    [MyHiveLocalizationKey.Cancelling]: 'Annulation…',
    [MyHiveLocalizationKey.WarningRegistrationCancel]: 'Vous êtes sur le point d’annuler votre inscription',

    [MyHiveLocalizationKey.SeatsLeft]: 'places restantes',
    [MyHiveLocalizationKey.AtCapacity]: 'Complet',

    [MyHiveLocalizationKey.FirstNameRequired]: 'Le prénom est requis',
    [MyHiveLocalizationKey.LastNameRequired]: 'Le nom de famille est requis',
    [MyHiveLocalizationKey.OrgNameRequired]: "Le nom de l'organisation est requis",

    [MyHiveLocalizationKey.SomethingWentWrong]: 'Une Erreur est Survenue',

    [MyHiveLocalizationKey.FailedToUpdateProfile]: 'Échec de la mise à jour du profil. Veuillez réessayer.',

    [MyHiveLocalizationKey.FailedToRegisterForEvent]: "Échec de l'inscription à l'événement. Veuillez réessayer.",
    [MyHiveLocalizationKey.FailedToUnregisterEvent]: "Échec de la désinscription de l'événement. Veuillez réessayer.",

    [MyHiveLocalizationKey.EventRegistration]: 'Inscription à l’événement',

    //event registration info

    [MyHiveLocalizationKey.EffortlessRegistration]: 'Inscription simplifiée aux événements',
    [MyHiveLocalizationKey.HowItWorks]: 'Comment ça fonctionne ?',

    [MyHiveLocalizationKey.EasyRegistrationSectionHeader]: 'S’inscrire aux ateliers facilement sur MaRuche',
    [MyHiveLocalizationKey.EasyRegistrationSectionText]:
      'Les détails des ateliers prévus et le bouton d’inscription à vos événements apparaissent directement sur votre page MaRuche, ce qui permet à votre communauté de trouver et de s’inscrire facilement. Pour promouvoir votre événement, il suffit de partager le lien de votre page MaRuche.',
    [MyHiveLocalizationKey.InviteSubscribersSectionHeader]: 'Nous invitons vos abonnés',
    [MyHiveLocalizationKey.InviteSubscribersSectionText]:
      'Tous les abonnés à votre page qui ont choisi de recevoir les notifications d’événements recevront automatiquement une invitation avec un lien vers votre page MaRuche pour s’inscrire.',

    [MyHiveLocalizationKey.AutomaticRemindersSectionHeader]: 'Rappels et mises à jour automatiques',
    [MyHiveLocalizationKey.AutomaticRemindersSectionText]:
      'Les participants reçoivent un courriel de confirmation ainsi qu’une série de rappels avant l’événement. Ils peuvent mettre à jour leur participation à tout moment via votre page MaRuche. Si vous modifiez ou annulez l’événement, ils seront automatiquement avisés.',

    [MyHiveLocalizationKey.RealTimeTrackingSectionHeader]: 'Suivi des participants en temps réel',
    [MyHiveLocalizationKey.RealTimeTrackingSectionText]:
      'L’outil surveille les limites de capacité et vous tient informé du nombre d’inscriptions en temps réel. Vous pouvez consulter et télécharger la liste des inscrits à tout moment, directement depuis la fiche de l’événement dans votre fil MaRuche.',

    [MyHiveLocalizationKey.PromoteWorkshopCta]: 'Promouvoir votre événement',

    [MyHiveLocalizationKey.ShareMyHivePageHeader]: 'Partagez votre page MaRuche !',
    [MyHiveLocalizationKey.ShareMyHivePageText]:
      'Lorsque vous créez un événement, les détails et le bouton d’inscription apparaissent automatiquement sur votre fil MaRuche. Pour le promouvoir, partagez le lien de votre page et dirigez les gens vers celle-ci pour s’inscrire. Vous pouvez copier l’URL de votre page MaRuche en haut de votre navigateur, ou télécharger votre code QR dans Paramètres.',

    [MyHiveLocalizationKey.PromoKitTemplatesHeader]: 'Communiqués personnalisables à votre disposition',
    [MyHiveLocalizationKey.PromoKitTemplatesText]:
      'Rendez-vous dans l’onglet Kit Promo pour trouver des visuels personnalisables et attrayants. Que vous ayez besoin d’une image pour un infolettre, d’une affiche pour les espaces communs ou d’un fichier pour les écrans de votre immeuble, tout y est!',

    [MyHiveLocalizationKey.QrCodeHeader]: 'Téléchargez et partagez votre code QR',
    [MyHiveLocalizationKey.QrCodeText]:
      'Facilitez l’accès pour votre communauté! Ajoutez le code QR de votre page sur des affiches ou des invitations - il se scanne en quelques secondes avec n’importe quel téléphone. Téléchargez votre code QR en tout temps dans l’onglet Paramètres et partagez-le facilement.',

    [MyHiveLocalizationKey.RegistrationDefaultNote]:
      'Par défaut, l’inscription est activée pour chaque événement. Vous pouvez la désactiver en tout temps dans les ',

    [MyHiveLocalizationKey.Settings]: 'Paramètres',
    [MyHiveLocalizationKey.NatureAgent]: 'Nature Agent',

    [MyHiveLocalizationKey.Integrations]: 'Intégrations',
    [MyHiveLocalizationKey.TenantApps]: 'Applications pour locataires ',
    [MyHiveLocalizationKey.DigitalScreensAndSignage]: 'Digital screens & signage', //TODO: TRANSLATE
    [MyHiveLocalizationKey.TenantAppsHeader]:
      'Ajouter la page Alvéole de votre immeuble à votre application pour locataire (VTS, HqO, ZO, etc.) est simple et rapide. Vos locataires pourront ensuite découvrir vos abeilles et votre initiative en biodiversité directement aux côtés des mises à jour et des services de votre immeuble.',
    [MyHiveLocalizationKey.TenantAppsDropdownHeader]:
      'Comment ajouter votre page Alvéole dans les applications pour locataires',

    [MyHiveLocalizationKey.TenantAppsYoullNeedHeader]: 'Ce dont vous aurez besoin (tout est inclus ci-dessous)',
    [MyHiveLocalizationKey.TenantAppsRequirementUrl]: 'L’URL de la page Alvéole de votre immeuble',
    [MyHiveLocalizationKey.TenantAppsRequirementImage]: 'Une image pour le widget',
    [MyHiveLocalizationKey.TenantAppsRequirementNameDesc]: 'Un nom et une courte description',
    [MyHiveLocalizationKey.TenantAppsWebviewHowToHeader]: 'Comment l’intégrer en tant que webview / URL :',
    [MyHiveLocalizationKey.TenantAppsWebviewWhatIs]:
      'L’intégration par webview vous permet de créer un lien vers une page web tierce tout en gardant l’utilisateur dans votre application.',
    [MyHiveLocalizationKey.TenantAppsStepLogin]:
      '**Connectez-vous à votre application locataire** et allez à la section où vous ajoutez **un nouveau Service, Ressource ou Widget.**',
    [MyHiveLocalizationKey.TenantAppsStepUploadImage]:
      '**Téléversez l’image du widget** fournie ci-dessous (choisissez un format carré ou rectangulaire selon les exigences de l’application).',
    [MyHiveLocalizationKey.TenantAppsStepPasteUrl]: '**Collez votre URL Alvéole** (fournie ci-dessous).',
    [MyHiveLocalizationKey.TenantAppsStepAddNameDesc]:
      '**Ajoutez un nom et une description**; utilisez notre suggestion ci-dessous ou personnalisez la vôtre.',
    [MyHiveLocalizationKey.TenantAppsStepSavePublish]:
      '**Sauvegardez et publiez!** Vos locataires verront maintenant « Alvéole » ou « MaRuche » dans leur application.',
    [MyHiveLocalizationKey.TenantAppsNote]:
      'Remarque : Les étapes peuvent varier légèrement selon l’application, mais avec l’URL, l’image et le texte fournis ici, vous êtes prêt à partager votre projet dans n’importe quelle application locataire.',

    [MyHiveLocalizationKey.IntegrationKit]: 'Trousse d’intégration',
    // Add inside myhiveLocalization.fr:
    [MyHiveLocalizationKey.TenantAppsUrlLabel]: 'URL de la page Alvéole :',
    [MyHiveLocalizationKey.TenantAppsUrlHelp]:
      'Voici le lien vers votre page publique MaRuche, où vos locataires peuvent s’inscrire aux événements, voir les mises à jour de vos abeilles et plus encore.',
    [MyHiveLocalizationKey.TenantAppsSuggestedDescHeader]: 'Description suggérée',
    [MyHiveLocalizationKey.TenantAppsSuggestedDescHelp]:
      'Incluez une brève description pour votre widget Alvéole – MaRuche.',
    [MyHiveLocalizationKey.TenantAppsSuggestedDescExample]:
      'Découvrez les événements, les nouvelles de nos abeilles, de notre récolte de miel et de notre programme de biodiversité.',

    [MyHiveLocalizationKey.TenantAppsWidgetsHeader]: 'Images du widget / icônes',
    [MyHiveLocalizationKey.TenantAppsWidgetsDesc]:
      ' Fichiers déjà dimensionnés à utiliser comme icônes pour votre widget Alvéole.',

    [MyHiveLocalizationKey.Profile]: 'Profil',

    [MyHiveLocalizationKey.ChangePassoword]: 'Changer le mot de passe',
    [MyHiveLocalizationKey.SignOut]: 'Se déconnecter',
    [MyHiveLocalizationKey.WeWillSendToEmail]: 'Nous vous enverrons un courriel à:',
    [MyHiveLocalizationKey.SendToEmail]: 'Envoyer à votre courriel',

    [MyHiveLocalizationKey.Tagline]: 'Tagline',
    [MyHiveLocalizationKey.TaglineDescription]:
      "Votre description ou votre bio seront visibles par le public sur vos publications. Ça peut être le nom de votre poste ou tout simplement une p'tite phrase qui vous représente bien!",
    [MyHiveLocalizationKey.BeekeeperBio]: 'Biographie',
    [MyHiveLocalizationKey.BeekeeperBioDescription]:
      "En tant qu'apiculteur ou apicultrice, une biographie plus longue sera présentée à vos clients dans une carte «Rencontrez votre apiculteur ou apicultrice» sur leur ruche, accompagnée de votre photo.",
    [MyHiveLocalizationKey.ProfilePhoto]: 'Photo de profil',
    [MyHiveLocalizationKey.ProfileIntro]:
      'Présentez-vous! Votre profil sera visible lorsque vous créerez des buzz ou ajouterez des photos à votre galerie.',
    [MyHiveLocalizationKey.Saving]: 'Enregistrement...',

    [MyHiveLocalizationKey.ShareOnLinkedin]: 'Partager sur LinkedIn',
    [MyHiveLocalizationKey.YearEndHeader]: 'Retour sur 2025!',
    [MyHiveLocalizationKey.Caption]: 'Légende',
    [MyHiveLocalizationKey.CaptionHint]: 'Adaptez votre texte pour LinkedIn',

    [MyHiveLocalizationKey.RequestedReport]: `Ce type de rapport n’est pas encore disponible à la demande. Votre demande a été soumise et notre équipe y travaille.`,
    [MyHiveLocalizationKey.YouWillReceiveEmail]: `Vous recevrez un courriel dès qu’il sera prêt`,
    [MyHiveLocalizationKey.Loading]: 'Chargement',
    [MyHiveLocalizationKey.ChatBotWelcomeMessage]:
      'Posez-moi n’importe quelle question sur vos données nature. J’utilise les informations propres à votre site afin que mes réponses soient adaptées à votre situation et ne soient jamais partagées avec d’autres.',

    [MyHiveLocalizationKey.ChatBotDisclaimerMessage]:
      'Ce contenu a été généré à l’aide de l’IA et peut contenir des erreurs ou des inexactitudes.',
    [MyHiveLocalizationKey.ChatBotInputPlaceholder]:
      'Qu’est-ce que l’abondance moyenne des espèces (MSA) et pourquoi est-ce important?',
    [MyHiveLocalizationKey.NoMatchesFor]: 'Aucun résultat pour',
    [MyHiveLocalizationKey.OnRequest]: 'Sur demande',
    [MyHiveLocalizationKey.StartTypingToSearch]: 'Commencez à taper pour rechercher...',

    [MyHiveLocalizationKey.Conversations]: 'Conversations',
    [MyHiveLocalizationKey.NewConversation]: 'Nouvelle conversation',

    [MyHiveLocalizationKey.ReportsSmartReportsTitle]: 'Rapports intelligents',
    [MyHiveLocalizationKey.ReportsRequestButton]: 'Demander un rapport',
    [MyHiveLocalizationKey.ReportsLoadingTitle]: 'Chargement…',
    [MyHiveLocalizationKey.ReportsLoadingSubtitle]: 'La nature prépare vos analyses…',

    [MyHiveLocalizationKey.ReportsPortfolioPlaceholder]: 'Portefeuille',

    [MyHiveLocalizationKey.ReportsPreviouslyGeneratedReportsTitle]: 'Rapports générés précédemment',

    [MyHiveLocalizationKey.ReportsPortfolioOptionTitle]: 'Portefeuille',
    [MyHiveLocalizationKey.ReportsPortfolioOptionDesc]: 'Données combinées de tous vos sites',

    [MyHiveLocalizationKey.PaginationShowing]: 'Affichage',
    [MyHiveLocalizationKey.PaginationTo]: 'à',
    [MyHiveLocalizationKey.PaginationOf]: 'sur',
    [MyHiveLocalizationKey.PaginationResults]: 'résultats',

    [MyHiveLocalizationKey.PaginationFirstPage]: 'Première page',
    [MyHiveLocalizationKey.PaginationPreviousPage]: 'Page précédente',
    [MyHiveLocalizationKey.PaginationNextPage]: 'Page suivante',
    [MyHiveLocalizationKey.PaginationLastPage]: 'Dernière page',

    [MyHiveLocalizationKey.Request]: 'Demande',

    [MyHiveLocalizationKey.ReportsTableNoReports]: 'Aucun rapport pour ce type.',

    [MyHiveLocalizationKey.Report]: 'Rapport',
    [MyHiveLocalizationKey.Asset]: 'Actif',
    [MyHiveLocalizationKey.Date]: 'Date',

    [MyHiveLocalizationKey.PortfolioAllSites]: 'Portefeuille (tous les sites)',
    [MyHiveLocalizationKey.PortfolioAllSitesDescription]: 'Données de tous vos sites réunies',

    [MyHiveLocalizationKey.Download]: 'Télécharger',
    [MyHiveLocalizationKey.DownloadList]: 'Télécharger la liste',

    [MyHiveLocalizationKey.RequestReportErrorGenerating]:
      'Un problème est survenu lors de la génération de votre rapport. Réessayez — si l’erreur persiste, contactez support@alveole.buzz.',

    [MyHiveLocalizationKey.Generating]: 'Génération en cours',

    [MyHiveLocalizationKey.RequestReportGenerating]: 'Collecte d’insights depuis l’espace, la mer et le sol…',
    [MyHiveLocalizationKey.RequestReportGenerated]: 'Votre rapport a été généré !',
    [MyHiveLocalizationKey.RequestReportDownloadAria]: 'Télécharger le rapport',

    [MyHiveLocalizationKey.SubmitRequest]: 'Soumettre une demande',
    [MyHiveLocalizationKey.Submit]: 'Soumettre',

    [MyHiveLocalizationKey.Format]: 'Format',
    [MyHiveLocalizationKey.Language]: 'Langue',

    [MyHiveLocalizationKey.GeneratingReportLine]: 'Collecte d’insights depuis l’espace, la mer et le sol...',

    [MyHiveLocalizationKey.UpdateContactSettings]: 'Mettre à jour les paramètres de contact',

    [MyHiveLocalizationKey.UnreachableEmailsDescription]:
      'des adresses courriel de membres de l’équipe sont actuellement injoignables. Veuillez accéder aux paramètres de votre ruche pour mettre à jour leurs informations.',

    [MyHiveLocalizationKey.TakeMeToSettings]: 'Prenez-moi à mes paramètres',
    [MyHiveLocalizationKey.UnreachableEmailsCountPlural]:
      'des adresses courriel de l’équipe sont actuellement injoignables',
    [MyHiveLocalizationKey.UnreachableEmailsCountSingular]: 'adresse courriel de l’équipe est actuellement injoignable',
    [MyHiveLocalizationKey.EmailIsUnreachable]: 'Adresse courriel injoignable',

    [MyHiveLocalizationKey.SMSDeliveredHere]: 'Les rappels de visite par SMS sont envoyés ici',

    [MyHiveLocalizationKey.InvalidPhoneNumber]:
      "Numéro de téléphone invalide — incluez l'indicatif du pays, par ex. +33 6 12 34 56 78",
    [MyHiveLocalizationKey.InvalidEmail]: 'Adresse courriel invalide',
    [MyHiveLocalizationKey.UnknownPhoneNumberStatus]:
      'Statut du numéro de téléphone inconnu. Veuillez vérifier le numéro. Ce champ se mettra à jour lors du prochain envoi d’un SMS à cet utilisateur.',

    [MyHiveLocalizationKey.InstallationComingUpText]: 'Arrivée des abeilles sur le site',
    [MyHiveLocalizationKey.BeekeepingComingUpText]: 'Visite d’entretien',
    [MyHiveLocalizationKey.HoneyJarsComingUpText]: 'Arrivée des pots de miel',
    [MyHiveLocalizationKey.HoneyHarvestComingUpText]: 'Récolte annuelle de miel',

    [MyHiveLocalizationKey.HTHJEventComingUp]: 'Événement d’extraction de miel',
    [MyHiveLocalizationKey.MeetYourBeesEventComingUp]: 'Ouverture de ruche en direct',
    [MyHiveLocalizationKey.MeetYourBeekeeperEventComingUp]: 'Rencontre avec l’apiculteur',
    [MyHiveLocalizationKey.WondersOfWaxEventComingUp]: 'Atelier de fabrication de chandelles',
    [MyHiveLocalizationKey.HoneyTastingEventComingUp]: 'Dégustation de miel',
    [MyHiveLocalizationKey.ExploreBeesEventComingUp]: 'Présentation spéciale',
    [MyHiveLocalizationKey.ExploreWildEventComingUp]: 'Présentation spéciale',
    [MyHiveLocalizationKey.KioskEventComingUp]: 'Animation kiosque',
    [MyHiveLocalizationKey.EventComingUp]: 'Événement spécial',

    [MyHiveLocalizationKey.BeekeepingNewsText]:
      'Votre apiculteur était sur place pour une visite d’entretien de routine.',
    [MyHiveLocalizationKey.InstallationNewsText]: 'Bzzzz! Vos abeilles et l’équipement ont été installés sur place.',
    [MyHiveLocalizationKey.HoneyHarvestNewsText]:
      'Les cadres de miel ont été récoltés sur place, prêts pour la mise en pot.',
    [MyHiveLocalizationKey.HoneyJarsNewsText]:
      'Le moment le plus sucré de l’année! Vos pots de miel sont arrivés sur place.',
    [MyHiveLocalizationKey.EventNewsText]: 'réalisé avec /d participants',

    [MyHiveLocalizationKey.BeekeepingNewsBadgeText]: 'Ruche visitée',
    [MyHiveLocalizationKey.InstallationNewsBadgeText]: 'Abeilles installées',
    [MyHiveLocalizationKey.HoneyHarvestNewsBadgeText]: 'Miel récolté',
    [MyHiveLocalizationKey.HoneyJarsNewsBadgeText]: 'Miel livré',
    [MyHiveLocalizationKey.EventNewsBadgeText]: 'Événement realisé',

    [MyHiveLocalizationKey.DesignRequiredLabelStatus]: 'À faire',
    [MyHiveLocalizationKey.NeedsApprovalLabelStatus]: 'À approuver',
    [MyHiveLocalizationKey.InProgressLabelStatus]: 'En cours',
    [MyHiveLocalizationKey.SubmittedLabelStatus]: 'Soumis',

    [MyHiveLocalizationKey.DesignRequiredTooltipText]: 'Créez votre étiquette dès maintenant',
    [MyHiveLocalizationKey.NeedsApprovalTooltipText]: "En attente d'approbation",
    [MyHiveLocalizationKey.InProgressTooltipText]: 'Conception en cours',
    [MyHiveLocalizationKey.SubmittedTooltipText]: 'Votre étiquette est prête!',

    [MyHiveLocalizationKey.PhotoGallery]: 'Galerie de photos',
    [MyHiveLocalizationKey.PhotoGallerySubtitle]: 'Publications les plus récentes de votre portfolio',

    [MyHiveLocalizationKey.PortfolioNewsfeed]: 'Fil d’actualité du portfolio',
    [MyHiveLocalizationKey.PortfolioNewsfeedSubtitle]: 'Activité récente dans vos propriétés',
    [MyHiveLocalizationKey.ComingUp]: 'À venir',

    [MyHiveLocalizationKey.Region]: 'Région',
    [MyHiveLocalizationKey.MainContact]: 'Contact principal',
    [MyHiveLocalizationKey.Package]: 'Forfait',
    [MyHiveLocalizationKey.Events]: 'Événements',
    [MyHiveLocalizationKey.EventCredits]: 'Crédits d’événements',
    [MyHiveLocalizationKey.Label]: 'Étiquette',
    [MyHiveLocalizationKey.NextVisit]: 'Prochaine visite',

    [MyHiveLocalizationKey.TenantSubscribers]: 'Abonnés des locataires',
    [MyHiveLocalizationKey.PropertiesInPortfolio]: 'propriétés dans le portfolio',
    [MyHiveLocalizationKey.CustomizeColumns]: 'Personnaliser les colonnes',
    [MyHiveLocalizationKey.InviteTenants]: 'Inviter des locataires',
    [MyHiveLocalizationKey.CreditsLeft]: 'Crédits restants',

    [MyHiveLocalizationKey.UpcomingVisits]: 'Visites à venir',
    [MyHiveLocalizationKey.YearInReview]: 'Retour sur l’année',
    [MyHiveLocalizationKey.BiodiversityReport]: 'Rapport sur la biodiversité',
    [MyHiveLocalizationKey.NoReports]: 'Aucun rapport',
    [MyHiveLocalizationKey.Updated]: 'Mis à jour',
    [MyHiveLocalizationKey.TotalAssets]: 'actifs totals',

    [MyHiveLocalizationKey.PesticidesReport]: 'Rapport sur les pesticides',
    [MyHiveLocalizationKey.Growth]: 'Croissance',
    [MyHiveLocalizationKey.AreaPollinated]: 'Zone pollinisée',

    [MyHiveLocalizationKey.YourNextEventIsWaiting]: 'Votre prochain événement vous attend ! 🎉',
    [MyHiveLocalizationKey.AllWorkshopCreditsUsed]: 'Tous les crédits d’atelier ont été utilisés !',

    [MyHiveLocalizationKey.EventsBooked]: 'Événements réservés',

    [MyHiveLocalizationKey.Invite]: 'Inviter',

    [MyHiveLocalizationKey.HoneyLabel]: 'Étiquette de miel',

    [MyHiveLocalizationKey.PostPhotos]: 'Publier des photos',
    [MyHiveLocalizationKey.PostVideos]: 'Publier une vidéo',
    [MyHiveLocalizationKey.LinkedInChooseHeader]: 'Ce Buzz a des photos et une vidéo — choisissez :',
    [MyHiveLocalizationKey.LinkedInChooseDescription]:
      'La vidéo publiera uniquement la première vidéo. Les photos essaieront de publier toutes les photos.',

    [MyHiveLocalizationKey.GetFamiliar]: 'Se familiariser',
    [MyHiveLocalizationKey.GetFamiliarTitleOne]: 'Votre centre de contrôle',
    [MyHiveLocalizationKey.GetFamiliarTextOne]:
      'Votre barre latérale vous permet de naviguer facilement entre vos immeubles et vos outils',

    [MyHiveLocalizationKey.GetFamiliarTitleTwo]: 'Page publique des locataires',
    [MyHiveLocalizationKey.GetFamiliarTextTwo]:
      'Une page publique pour vos abeilles! \nLes locataires restent engagés grâce aux mises à jour régulières de votre apiculteur.',

    [MyHiveLocalizationKey.GetFamiliarTitleThree]: 'Les locataires peuvent s’inscrire',
    [MyHiveLocalizationKey.GetFamiliarTextThree]:
      'Les locataires peuvent s’inscrire aux événements nature, s’abonner aux mises à jour et réserver leur miel.',

    [MyHiveLocalizationKey.LetsGrow]: 'Allons plus loin',

    [MyHiveLocalizationKey.LetsGrowTitleOne]: 'Invitez votre communauté',
    [MyHiveLocalizationKey.LetsGrowTextOne]:
      'Importez facilement des adresses courriel et invitez les locataires à suivre, s’inscrire et participer.',

    [MyHiveLocalizationKey.LetsGrowTitleTwo]: 'Créez des expériences mémorables',
    [MyHiveLocalizationKey.LetsGrowTextTwo]:
      'Réservez facilement nos événements signature qui gardent les locataires engagés.',

    [MyHiveLocalizationKey.LetsGrowTitleThree]: 'Inscription simplifiée aux événements',
    [MyHiveLocalizationKey.LetsGrowextThree]:
      'Informez automatiquement vos abonnés et simplifiez l’inscription aux événements.',

    [MyHiveLocalizationKey.LetsGrowTitleFour]: 'Vous êtes prêt·e 🎉',
    [MyHiveLocalizationKey.LetsGrowextFour]:
      'Votre programme est prêt à passer à l’étape suivante.\n\nUtilisez cette liste de vérification pour maintenir l’élan.',

    [MyHiveLocalizationKey.LivingBusiness]: 'Vous gérez un immeuble vivant.',
    [MyHiveLocalizationKey.ConnectNatureTenants]:
      'Connectez la nature, les locataires et l’impact dans un seul programme.',
    [MyHiveLocalizationKey.ControlCenter]: 'Voici votre centre de contrôle',
    [MyHiveLocalizationKey.AllInOnePlace]:
      'Gérez votre programme, accédez aux rapports, planifiez des événements et partagez votre impact, le tout au même endroit.',
    [MyHiveLocalizationKey.TenantsToPage]: 'Invitez les locataires à votre page',
    [MyHiveLocalizationKey.ToDoTenantStuff]:
      'Pour suivre les actualités de la ruche, participer aux événements et vivre les moments de récolte liés à votre immeuble.',
    [MyHiveLocalizationKey.HostEvents]: 'Organisez des événements nature inoubliables',
    [MyHiveLocalizationKey.EasilyBook]: 'Réservez facilement des événements qui démarquent votre propriété',

    [MyHiveLocalizationKey.InviteTenantsNow]: 'Invitez vos locataires ',
    [MyHiveLocalizationKey.BookEventNow]: 'Réservez votre événement!',

    [MyHiveLocalizationKey.Next]: 'Suivant',
    [MyHiveLocalizationKey.Finish]: 'Terminer',

    [MyHiveLocalizationKey.MakeItYourOwn]: 'Faites-en votre espace',
    [MyHiveLocalizationKey.MaximizeImpact]: 'Maximisez votre impact',

    [MyHiveLocalizationKey.StartHere]: 'Commencez ici',
    [MyHiveLocalizationKey.LearnHowToGrow]: 'Apprenez à gérer et à développer votre programme',
    [MyHiveLocalizationKey.InviteYourTenants]: 'Invitez vos locataires',
    [MyHiveLocalizationKey.ShareYourPage]: 'Partagez votre page avec vos contacts principaux',
    [MyHiveLocalizationKey.BookAlveoleEvent]: 'Réservez un événement Alvéole',
    [MyHiveLocalizationKey.HostedByBeekeeper]: 'Animé par votre apiculteur·rice',

    [MyHiveLocalizationKey.EventsLeft]: 'autres événements gratuits à réserver!',
    [MyHiveLocalizationKey.EventLeft]: 'Encore un événement gratuit à réserver !',

    [MyHiveLocalizationKey.HoneyLabelDontWorry]:
      'Ne vous inquiétez pas! Créer un nouveau design ne supprimera pas votre étiquette existante.',
    [MyHiveLocalizationKey.HoneyLabelError]:
      'Votre étiquette de miel sera bientôt accessible. Pour toute question, vous pouvez nous écrire à support@alveole.buzz',
    [MyHiveLocalizationKey.ChangeImage]: 'Changer l’image',
    [MyHiveLocalizationKey.ShareSoCanRegister]: 'Partagez votre page MyHive afin qu’ils puissent s’inscrire eux aussi',

    [MyHiveLocalizationKey.AlveoleEvent]: 'Événement Alvéole',

    [MyHiveLocalizationKey.CheckOutPage]: 'Découvrez la page de vos abeilles !',
    [MyHiveLocalizationKey.RegisterForEvent]: 'S’inscrire à l’événement',

    [MyHiveLocalizationKey.Company]: 'Entreprise',

    [MyHiveLocalizationKey.AllSet]: 'Tout est prêt',

    [MyHiveLocalizationKey.ScanList]: 'Numériser une liste',
    [MyHiveLocalizationKey.Scanning]: 'Numérisation en cours',
    [MyHiveLocalizationKey.Scan]: 'Numériser',
    [MyHiveLocalizationKey.AddMore]: 'Ajouter plus',
    [MyHiveLocalizationKey.LoginToScanSubscriberLists]: "Connectez-vous pour scanner les listes d'abonnés",

    [MyHiveLocalizationKey.KioskUnavailable]: 'Kiosque indisponible',
    [MyHiveLocalizationKey.KioskInvalid]:
      'Ce lien de kiosque peut être invalide, expiré ou ne pas contenir les données de l’événement.',

    [MyHiveLocalizationKey.SelectedFile]: 'Fichier sélectionné',
    [MyHiveLocalizationKey.ReviewScannedContacts]: 'Vérifier les contacts numérisés',

    [MyHiveLocalizationKey.AddRow]: 'Ajouter une ligne',

    [MyHiveLocalizationKey.FailedToSubmitList]: 'Échec de l’envoi de la liste.',
    [MyHiveLocalizationKey.ContactListSubmitted]: 'La liste de contacts a été envoyée avec succès!',

    [MyHiveLocalizationKey.DefaulthiveDesc]:
      'Nous sommes fiers d’accueillir des abeilles et de soutenir la biodiversité locale en partenariat avec Alvéole.',

    [MyHiveLocalizationKey.OpenLiveReg]: 'Ouvrir la page d’inscription en direct',

    [MyHiveLocalizationKey.EventRegistrants]: 'Personnes inscrites à l’événement',

    [MyHiveLocalizationKey.RegisteredForEvent]: 'A assisté à un événement ou s’y est inscrit',

    [MyHiveLocalizationKey.HoneyLabelPopupTitle]: 'C’est prêt!',
    [MyHiveLocalizationKey.HoneyLabelPopupDescription]:
      'Votre étiquette de miel est réussie. Jetez-y un dernier coup d’œil, puis approuvez ou modifiez avant impression.',
    [MyHiveLocalizationKey.EditDesign]: 'Modifier le design',

    [MyHiveLocalizationKey.Approve]: 'Approuver',

    [MyHiveLocalizationKey.InviteColleagueTitle]: 'Vous connaissez quelqu’un qui *adorerait* ça?',
    [MyHiveLocalizationKey.InviteColleagueDescription]:
      'Invitez un collègue pour rester à jour sur les nouvelles, les événements et les pots de miel !',
    [MyHiveLocalizationKey.InviteColleagueButton]: 'Inviter un collègue',
    [MyHiveLocalizationKey.InviteColleagueSuccess]: 'Invitation envoyée !',
    [MyHiveLocalizationKey.HoneyLabelPopupCreateTitle]: 'Créer votre étiquette de miel 🍯',
    [MyHiveLocalizationKey.HoneyLabelPopupCreateDescription]:
      'Commencez avec un modèle ou importez votre propre design pour donner vie à votre étiquette.',
    [MyHiveLocalizationKey.GetStarted]: 'Commencer',
    [MyHiveLocalizationKey.CelebrateSubscribersTitle]: 'Nouveaux abonnés! 🎉',
    [MyHiveLocalizationKey.CelebrateSubscribersDescription]:
      'Votre page prend de l’élan. Cliquez sur votre nombre d’abonnés pour voir qui s’est inscrit.',
    [MyHiveLocalizationKey.CreditsRemainingSingular]: 'Il vous reste un crédit à utiliser !',
    [MyHiveLocalizationKey.CreditsRemainingPlural]: 'Il vous reste {count} crédits à utiliser !',
    [MyHiveLocalizationKey.EventCreditsUsedTagline]: 'Vous avez utilisé tous vos crédits d’événements !',
    [MyHiveLocalizationKey.AdditionalBookingsFeeNote]: 'Les réservations supplémentaires sont payantes.',
    [MyHiveLocalizationKey.CreditsUsedBannerTitleStrong]: 'Vous avez utilisé tous vos crédits d’événements ! 🎉',
    [MyHiveLocalizationKey.CreditsUsedBannerBodyPre]:
      'Envie d’en organiser un de plus ? Vous pouvez réserver un autre événement à tout moment moyennant des frais. Réservez maintenant pour recevoir une facture, ou ',
    [MyHiveLocalizationKey.CreditsUsedBannerBodyLink]: 'contactez notre équipe',
    [MyHiveLocalizationKey.CreditsUsedBannerBodyPost]: ' pour toute question.',

    [MyHiveLocalizationKey.TeamRemoveContactTitle]: 'Retirer le contact',
    [MyHiveLocalizationKey.TeamRemoveContactMessage]: 'Voulez-vous vraiment retirer {name}?',
    [MyHiveLocalizationKey.TeamDiscardChangesTitle]: 'Annuler les modifications?',
    [MyHiveLocalizationKey.TeamDiscardChangesMessage]:
      'Vous avez des modifications non enregistrées. Changer les annulera.',
    [MyHiveLocalizationKey.TeamDiscard]: 'Annuler',
    [MyHiveLocalizationKey.TeamConfirm]: 'Confirmer',
    [MyHiveLocalizationKey.TeamResendInviteEmailTitle]: 'Renvoyer le courriel d’invitation',
    [MyHiveLocalizationKey.TeamResendInviteEmailMessage]: 'Voulez-vous vraiment renvoyer le courriel d’invitation?',
    [MyHiveLocalizationKey.TeamColumnContact]: 'Contact',
    [MyHiveLocalizationKey.TeamColumnRole]: 'Rôle',
    [MyHiveLocalizationKey.TeamColumnPhone]: 'Téléphone',
    [MyHiveLocalizationKey.TeamColumnVisitReminders]: 'Rappels de visite',
    [MyHiveLocalizationKey.TeamColumnEmailPreferences]: 'Préférences de courriel',
    [MyHiveLocalizationKey.TeamColumnActions]: 'Actions',
    [MyHiveLocalizationKey.TeamTitle]: 'Équipe',
    [MyHiveLocalizationKey.TeamAddContact]: 'Ajouter un contact',
    [MyHiveLocalizationKey.TeamMembersCount]: '{count} membres',
    [MyHiveLocalizationKey.TeamNoUsersFound]: 'Aucun utilisateur trouvé',
    [MyHiveLocalizationKey.TeamSendInviteEmail]: 'Envoyer le courriel d’invitation',
    [MyHiveLocalizationKey.TeamInviteEmailSent]: 'Courriel d’invitation envoyé',
    [MyHiveLocalizationKey.TeamInviteEmailSentTooltip]: 'Courriel d’invitation envoyé!',
    [MyHiveLocalizationKey.TeamDelete]: 'Supprimer',
    [MyHiveLocalizationKey.TeamReassignBeforeRemoving]: 'Réassignez le contact principal/du site avant de retirer',
    [MyHiveLocalizationKey.TeamRemoveContact]: 'Retirer le contact',
    [MyHiveLocalizationKey.TeamVisitReminders]: 'Rappels de visite',
    [MyHiveLocalizationKey.TeamEmailLabel]: 'Courriel',
    [MyHiveLocalizationKey.TeamSmsLabel]: 'SMS',
    [MyHiveLocalizationKey.TeamSmsDisabledTooltip]:
      'Ajoutez un numéro valide pour recevoir les SMS. Un texto est envoyé à l’arrivée de l’apiculteur·trice et à la fin de la visite.',
    [MyHiveLocalizationKey.TeamSmsEnabledTooltip]:
      'Un texto est envoyé à l’arrivée de l’apiculteur·trice et à la fin de la visite.',
    [MyHiveLocalizationKey.TeamVisitReminderEmailTooltip]:
      'Recevez des rappels et des notifications concernant les visites apicoles à venir',
    [MyHiveLocalizationKey.TeamMobileLabel]: 'Mobile',
    [MyHiveLocalizationKey.TeamOfficeLabel]: 'Bureau',
    [MyHiveLocalizationKey.TeamPhoneLabel]: 'Téléphone',
    [MyHiveLocalizationKey.TeamEmailFieldLabel]: 'Courriel',
    [MyHiveLocalizationKey.TeamLastSeenAgo]: 'Dernière visite {time}',
    [MyHiveLocalizationKey.TeamPreferencesLabel]: 'Préférences',
    [MyHiveLocalizationKey.TeamContactTypeLabel]: 'Type de contact',
    [MyHiveLocalizationKey.TeamEmailsLabel]: 'Courriels',
    [MyHiveLocalizationKey.TeamNoneOption]: 'Aucun',
    [MyHiveLocalizationKey.TeamNoEmails]: 'Aucun courriel',
    [MyHiveLocalizationKey.TeamAllEmails]: 'Tous les courriels',
    [MyHiveLocalizationKey.TeamEmailPrefCount]: '{count} sur {total}',
    [MyHiveLocalizationKey.TeamRoleTeam]: 'Équipe',
    [MyHiveLocalizationKey.TeamStatusUnknown]: 'Inconnu',
    [MyHiveLocalizationKey.TeamStatusDelivering]: 'Livraison',
    [MyHiveLocalizationKey.TeamStatusNonSms]: 'Non-SMS',
    [MyHiveLocalizationKey.TeamStatusInvalid]: 'Invalide',
    [MyHiveLocalizationKey.TeamStatusOptedOut]: 'Désabonné',
    [MyHiveLocalizationKey.TeamEmailUnreachableBadge]: 'Ce courriel est inaccessible',
    [MyHiveLocalizationKey.TeamEmailUnreachableTooltip]: 'L’adresse courriel est inaccessible',
    [MyHiveLocalizationKey.TeamLastCarrierResponseTooltip]:
      'Dernière réponse du transporteur\nStatut : {status}\nCode d’erreur Twilio : {errorCode}\nDernier message envoyé : {lastSent}',
    [MyHiveLocalizationKey.TeamContactTypeMainOption]:
      'Contact principal : Supervise la gestion principale du programme.',
    [MyHiveLocalizationKey.TeamContactTypeHiveOption]:
      'Contact de la ruche : Personne-ressource sur place pour les visites de routine.',
    [MyHiveLocalizationKey.TeamContactTypeRemoveHint]:
      'Pour retirer un contact principal ou de site, assignez d’abord un autre contact.',
    [MyHiveLocalizationKey.TeamCreateNewUserTitle]: 'Ajouter un membre de l’équipe',
    [MyHiveLocalizationKey.TeamCreateNewUserDescription]: 'Créer un nouveau contact dans votre équipe',
    [MyHiveLocalizationKey.TeamCreateUser]: 'Créer l’utilisateur',
    [MyHiveLocalizationKey.TeamCreatingUser]: 'Création...',
    [MyHiveLocalizationKey.TeamFirstNamePlaceholder]: 'Jean',
    [MyHiveLocalizationKey.TeamLastNamePlaceholder]: 'Tremblay',
    [MyHiveLocalizationKey.TeamEmailPlaceholder]: 'jean.tremblay@exemple.com',
    [MyHiveLocalizationKey.UnsubscribeGenericError]:
      "Une erreur s'est produite. Veuillez réessayer, ou contacter le soutien si le problème persiste.",
    [MyHiveLocalizationKey.UnsubscribeTitle]: 'Préférences de courriel',
    [MyHiveLocalizationKey.UnsubscribeSubtitle]:
      'Choisissez les communications que vous souhaitez recevoir de cette page.',
    [MyHiveLocalizationKey.UnsubscribeEmail]: 'Courriel',
    [MyHiveLocalizationKey.UnsubscribePage]: 'Page',
    [MyHiveLocalizationKey.UnsubscribeManagePrompt]: 'Vous gérez ce programme apicole ?',
    [MyHiveLocalizationKey.UnsubscribeSignIn]: 'Connectez-vous',
    [MyHiveLocalizationKey.UnsubscribeNotifications]: 'Notifications',
    [MyHiveLocalizationKey.UnsubscribeVisitReminders]: 'Rappels de visite',
    [MyHiveLocalizationKey.UnsubscribeVisitRemindersLockedDescription]:
      'Vous êtes un contact du site, vous recevrez donc toujours les rappels de visite.',
    [MyHiveLocalizationKey.UnsubscribeVisitRemindersDescription]: 'Les prochaines visites de votre apiculteur·trice',
    [MyHiveLocalizationKey.UnsubscribeSubscriberAlerts]: 'Alertes d’abonnés',
    [MyHiveLocalizationKey.UnsubscribeSubscriberAlertsDescription]: 'Nouveaux abonnés à la page',
    [MyHiveLocalizationKey.UnsubscribeNewPosts]: 'Nouvelles des abeilles',
    [MyHiveLocalizationKey.UnsubscribeNewPostsDescription]:
      'Soyez informé·e des dernières publications de votre apiculteur·trice',
    [MyHiveLocalizationKey.UnsubscribeEventWaitingList]: 'Évènements à venir',
    [MyHiveLocalizationKey.UnsubscribeEventWaitingListDescription]:
      'Soyez parmi les premier·ères à être informé·e des évènements et initiatives à venir de votre programme apicole',
    [MyHiveLocalizationKey.SmsOptInBlockedTitle]: 'Les rappels SMS sont désactivés',
    [MyHiveLocalizationKey.SmsOptInBlockedMessage]:
      'Vous vous êtes précédemment désinscrit·e des rappels SMS. Pour vous réinscrire, envoyez START au +1 877 676 9995. Pour les courriels, cliquez sur le lien dans le courriel que nous vous avons envoyé ou contactez le·la gestionnaire de votre site.',
    [MyHiveLocalizationKey.Ok]: 'OK',
    [MyHiveLocalizationKey.UnsubscribeMainContact]: 'Contact principal',
    [MyHiveLocalizationKey.UnsubscribeHiveContact]: 'Contact du site',
    [MyHiveLocalizationKey.UnsubscribeManagerLockedDescription]:
      'Alertes concernant votre service (contactez le soutien, ou connectez-vous pour modifier ce paramètre)',
    [MyHiveLocalizationKey.UnsubscribeUpdateError]:
      "Une erreur s'est produite. Veuillez réessayer, ou contacter le soutien si le problème persiste.",
    [MyHiveLocalizationKey.UnsubscribeCancel]: 'Annuler',
    [MyHiveLocalizationKey.UnsubscribeSave]: 'Enregistrer',

    // Hive strength tile
    [MyHiveLocalizationKey.HiveStrengthInsideTheHive]: 'Dans la Ruche',
    [MyHiveLocalizationKey.HiveStrengthHeading]: 'Force de la ruche',
    [MyHiveLocalizationKey.HiveStrengthFramesOfBees]: 'abeilles',
    [MyHiveLocalizationKey.HiveStrengthHarvest]: 'RÉCOLTE',
    [MyHiveLocalizationKey.HiveStrengthNow]: 'auj.',
    [MyHiveLocalizationKey.HiveStrengthQueenSeenNow]: 'Auj.',
    [MyHiveLocalizationKey.HiveStrengthHoneyTooltip]:
      "6 cadres, c'est une excellente récolte! Voici où en est votre ruche.",
    [MyHiveLocalizationKey.HiveStrengthQueenTooltip]:
      "Sa majesté peut être insaisissable. Voici la dernière fois que nous l'avons aperçue.",
    [MyHiveLocalizationKey.HiveStrengthBroodTooltip]:
      "Les cadres de couvain contiennent des œufs, des larves et des nymphes pondus par la reine, représentant la future main-d'œuvre de la colonie.",
    [MyHiveLocalizationKey.HiveStrengthWeekShort]: 'sem.',
    [MyHiveLocalizationKey.HiveStrengthLastNWeeks]: '{{weeks}} dernières semaines · {{points}} points',
    [MyHiveLocalizationKey.HiveStrengthNectarFlow]: 'Miellée',
    [MyHiveLocalizationKey.HiveStrengthNectarFlowDescription]:
      'Le paysage environnant est en pleine floraison! Les abeilles produisent du miel à un rythme élevé.',
    [MyHiveLocalizationKey.HiveStrengthHoney]: 'Miel',
    [MyHiveLocalizationKey.HiveStrengthQueen]: 'Reine',
    [MyHiveLocalizationKey.HiveStrengthBrood]: 'Couvain',
    [MyHiveLocalizationKey.HiveStrengthFramesUnit]: 'cadres',
    [MyHiveLocalizationKey.HiveStrengthDaysAgoUnit]: 'j',
    [MyHiveLocalizationKey.HiveStrengthNeverSeen]: 'jamais vue',
    [MyHiveLocalizationKey.HiveStrengthEmpty]: 'Aucune inspection dans cette période',
    [MyHiveLocalizationKey.HiveStrengthBannerAlt]: "À l'intérieur d'une ruche",
    [MyHiveLocalizationKey.HiveStrengthStateThriving]: 'Prospère',
    [MyHiveLocalizationKey.HiveStrengthStateThrivingSub]: 'La population et la production augmentent fortement',
    [MyHiveLocalizationKey.HiveStrengthStateGrowing]: 'En croissance',
    [MyHiveLocalizationKey.HiveStrengthStateGrowingSub]:
      "La colonie s'agrandit avec une augmentation du miel et des abeilles",
    [MyHiveLocalizationKey.HiveStrengthStateStable]: 'En santé',
    [MyHiveLocalizationKey.HiveStrengthStateStableSub]: 'La population et la production sont restées stables',
    [MyHiveLocalizationKey.HiveStrengthStateConserving]: 'Conservation',
    [MyHiveLocalizationKey.HiveStrengthStateConservingSub]: 'Colonie en mode de conservation saisonnière',
    [MyHiveLocalizationKey.HiveStrengthStateReducing]: 'En déclin',
    [MyHiveLocalizationKey.HiveStrengthStateReducingSub]: 'La colonie diminue en population et en production',
    // V2 widget — new copy
    [MyHiveLocalizationKey.HiveStrengthInsightsTitle]: "À l'intérieur de la ruche",
    [MyHiveLocalizationKey.HiveStrengthMostRecent]: 'Plus récent',
    [MyHiveLocalizationKey.HiveStrengthBeesLabel]: 'Abeilles',
    [MyHiveLocalizationKey.HiveStrengthStrengthLabel]: 'Force de la colonie',
    [MyHiveLocalizationKey.HiveStrengthFramesOfBeesLong]: "Cadres d'abeilles",
    [MyHiveLocalizationKey.HiveStrengthDaysShort]: 'j',
    [MyHiveLocalizationKey.HiveStrengthSpottedSuffix]: 'vue',
    [MyHiveLocalizationKey.HiveStrengthDidYouKnow]: 'Le saviez-vous ?',
    [MyHiveLocalizationKey.HiveStrengthAHiveHas3Members]: 'Une ruche a 3 membres',
    [MyHiveLocalizationKey.HiveStrengthMemberQueenDescription]:
      "Pond tous les œufs de la colonie, jusqu'à 2 000 par jour.",
    [MyHiveLocalizationKey.HiveStrengthMemberWorkers]: 'Ouvrières',
    [MyHiveLocalizationKey.HiveStrengthMemberWorkersDescription]: 'Abeilles femelles qui font tourner la colonie.',
    [MyHiveLocalizationKey.HiveStrengthMemberWorkersCount]: '~50 000',
    [MyHiveLocalizationKey.HiveStrengthMemberDrones]: 'Faux-bourdons',
    [MyHiveLocalizationKey.HiveStrengthMemberDronesDescription]:
      "Abeilles mâles qui s'accouplent avec les nouvelles reines.",
    [MyHiveLocalizationKey.HiveStrengthMemberDronesCount]: '~500',
    [MyHiveLocalizationKey.HiveStrengthInAHive]: 'dans une ruche',
    [MyHiveLocalizationKey.HiveStrengthAtPeak]: 'au max',
    [MyHiveLocalizationKey.HiveStrengthBeekeeperInspectionsTitle]: 'Visites apicoles',
    [MyHiveLocalizationKey.HiveStrengthBeekeeperInspectionsBody]:
      'Nous inspectons régulièrement la ruche pour veiller à la santé des abeilles. À la plupart des visites, nous cherchons la reine et notons le nombre de cadres de miel et de couvain.',
    [MyHiveLocalizationKey.HiveStrengthBeesTooltip]:
      "Estimation de la population totale d'abeilles à partir du nombre de cadres couverts d'abeilles (~2 000 abeilles par cadre).",
    [MyHiveLocalizationKey.HiveStrengthStrengthTooltip]:
      "Le nombre de cadres d'abeilles observés par l'apiculteur lors des inspections récentes.",
    [MyHiveLocalizationKey.DataCardTitle]: 'Aperçus nature',
    [MyHiveLocalizationKey.BeeHomeWhatIsTitle]: "Qu'est-ce qu'une BeeHome ?",
    [MyHiveLocalizationKey.BeeHomeWhatIsBody]:
      "Les BeeHomes offrent un habitat de nidification sécuritaire aux abeilles solitaires et à d'autres insectes qui nichent dans des cavités naturelles, avec des centaines de tubes où s'installer. Contrairement aux abeilles mellifères, chacun construit son propre nid, pond ses œufs et récolte la nourriture nécessaire pour se nourrir et nourrir sa descendance.",
    [MyHiveLocalizationKey.BeeHomeLikelyBuilders]: 'Espèces probables :',
    [MyHiveLocalizationKey.BeeHomeMaterialLumpyMudTitle]: 'Boue grumeleuse',
    [MyHiveLocalizationKey.BeeHomeMaterialLumpyMudDescription]:
      'Un bouchon de terre grossier et bosselé, tassé grain par grain en un petit mur solide, comme une maçonnerie miniature faite à la main.',
    [MyHiveLocalizationKey.BeeHomeMaterialLumpyMudBuilders]:
      'Abeilles maçonnes (osmies), ainsi que leurs petites cousines Hoplitis et Chelostoma. Certaines guêpes maçonnes et potières (Ancistrocerus) scellent aussi leur nid avec de la boue.',
    [MyHiveLocalizationKey.BeeHomeMaterialSmoothMudTitle]: 'Boue lisse',
    [MyHiveLocalizationKey.BeeHomeMaterialSmoothMudDescription]:
      'Une terre fine travaillée en un mur lisse et régulier qui sépare nettement une cellule de la suivante.',
    [MyHiveLocalizationKey.BeeHomeMaterialSmoothMudBuilders]:
      'Guêpes maçonnes et potières (Ancistrocerus et apparentées), ainsi que certaines abeilles maçonnes (osmies, Chelostoma).',
    [MyHiveLocalizationKey.BeeHomeMaterialMasticLeafPulpTitle]: 'Pâte de feuilles',
    [MyHiveLocalizationKey.BeeHomeMaterialMasticLeafPulpDescription]:
      'Du feuillage mâché en une pâte verte et souple, une sorte de mastic naturel, puis lissé en cloisons et bouchons.',
    [MyHiveLocalizationKey.BeeHomeMaterialMasticLeafPulpBuilders]:
      'Abeilles maçonnes qui mâchent leurs feuilles au lieu de les découper, dont certaines osmies et Hoplitis très répandues.',
    [MyHiveLocalizationKey.BeeHomeMaterialWoolPlantHairsTitle]: 'Laine / Poils végétaux',
    [MyHiveLocalizationKey.BeeHomeMaterialWoolPlantHairsDescription]:
      'Un duvet doux et cotonneux gratté sur des plantes aux feuilles velues et tassé comme une couverture douillette.',
    [MyHiveLocalizationKey.BeeHomeMaterialWoolPlantHairsBuilders]: 'Abeilles cotonnières (Anthidium et Pseudoanthidium).',
    [MyHiveLocalizationKey.BeeHomeMaterialGrassTitle]: 'Herbe',
    [MyHiveLocalizationKey.BeeHomeMaterialGrassDescription]:
      "Des brins d'herbe et de fines tiges glissés dans le tunnel, parfois avec quelques mèches qui dépassent de l'entrée.",
    [MyHiveLocalizationKey.BeeHomeMaterialGrassBuilders]: 'Guêpes porte-herbe (Isodontia).',
    [MyHiveLocalizationKey.BeeHomeMaterialLooseLeafPiecesTitle]: 'Morceaux de feuilles',
    [MyHiveLocalizationKey.BeeHomeMaterialLooseLeafPiecesDescription]:
      "De petits fragments nets en forme de pièces, découpés proprement au bord d'une feuille et enroulés autour de chaque cellule comme de petits colis.",
    [MyHiveLocalizationKey.BeeHomeMaterialLooseLeafPiecesBuilders]: 'Abeilles coupeuses de feuilles (mégachiles).',
    [MyHiveLocalizationKey.BeeHomeMaterialResinTitle]: 'Résine',
    [MyHiveLocalizationKey.BeeHomeMaterialResinDescription]:
      'De la sève d\'arbre collante, récoltée goutte à goutte et moulée en un scellement solide et imperméable qui durcit comme de la pierre.',
    [MyHiveLocalizationKey.BeeHomeMaterialResinBuilders]:
      'Abeilles résinières (Heriades et les petites abeilles à résine et cailloux Anthidiellum), ainsi que certaines mégachiles qui bâtissent avec de la résine.',
    [MyHiveLocalizationKey.BeeHomeMaterialMembranousCellophaneLikeLiningTitle]: 'Revêtement type cellophane',
    [MyHiveLocalizationKey.BeeHomeMaterialMembranousCellophaneLikeLiningDescription]:
      "Un film fin, brillant et presque plastifié que l'abeille fabrique elle-même et applique sur les parois, comme un papier peint imperméable.",
    [MyHiveLocalizationKey.BeeHomeMaterialMembranousCellophaneLikeLiningBuilders]:
      'Abeilles masquées (Hylaeus), parfois appelées abeilles cellophane.',
    [MyHiveLocalizationKey.BeeHomeMaterialLeafPulpSandGrainsLeafDiscsTitle]: 'Mélange feuilles, pâte et sable',
    [MyHiveLocalizationKey.BeeHomeMaterialLeafPulpSandGrainsLeafDiscsDescription]:
      'Un scellement composite mêlant feuilles mâchées, grains de sable et morceaux de feuilles découpés, le tout réuni.',
    [MyHiveLocalizationKey.BeeHomeMaterialLeafPulpSandGrainsLeafDiscsBuilders]:
      'Abeilles coupeuses de feuilles et abeilles résinières (mégachiles, Heriades), qui combinent parfois les matériaux.',
    [MyHiveLocalizationKey.BeeHomeMaterialMudSomeLeafPulpOrangePollenTitle]: 'Boue, pâte de feuilles, pollen',
    [MyHiveLocalizationKey.BeeHomeMaterialMudSomeLeafPulpOrangePollenDescription]:
      'De la boue et des feuilles mâchées travaillées ensemble, avec une petite touche révélatrice de pollen orange laissée derrière.',
    [MyHiveLocalizationKey.BeeHomeMaterialMudSomeLeafPulpOrangePollenBuilders]:
      'Abeilles maçonnes et proches parentes (osmies, Hoplitis, Chelostoma).',
    [MyHiveLocalizationKey.BeeHomeMaterialOtherCombinationTitle]: 'Autre combinaison',
    [MyHiveLocalizationKey.BeeHomeMaterialOtherCombinationDescription]:
      "Un scellement qui n'entre dans aucune catégorie précise, peut-être deux matériaux mêlés, peut-être quelque chose d'inhabituel.",
    [MyHiveLocalizationKey.BeeHomeMaterialOtherCombinationBuilders]:
      'Plusieurs espèces possibles. Beaucoup de nicheurs de cavités improvisent quand leur matériau favori vient à manquer.',
    [MyHiveLocalizationKey.BeeHomeResultsTitle]: 'Nidification des insectes',
    [MyHiveLocalizationKey.BeeHomeTubesUnit]: 'tubes',
    [MyHiveLocalizationKey.BeeHomeTubesNestedThisSeason]: 'tubes nichés cette saison',
    [MyHiveLocalizationKey.BeeHomeDescriptionWithData]:
      'Découvrez les types de nids que vous pourriez trouver dans une BeeHome, y compris ceux observés sur place, et les espèces qui les construisent.',
    [MyHiveLocalizationKey.BeeHomeDescriptionNoData]:
      'Découvrez les types de nids que vous pourriez trouver dans une BeeHome et les espèces qui les construisent.',
    [MyHiveLocalizationKey.BioacousticsCardTitle]: 'Données bioacoustiques',
    [MyHiveLocalizationKey.BioacousticsHeaderBadge]: 'Bioacoustique',
    [MyHiveLocalizationKey.BioacousticsErrorLoading]: 'Erreur lors du chargement des données',
    [MyHiveLocalizationKey.BioacousticsTenantHeading]: "Envie d'entendre un immeuble prendre vie ?",
    [MyHiveLocalizationKey.BioacousticsTenantBody]:
      "Les capteurs acoustiques Naute détectent l'activité des pollinisateurs et des oiseaux sur les sites urbains.",
    [MyHiveLocalizationKey.BioacousticsManagerHeading]: 'Entendez votre immeuble prendre vie',
    [MyHiveLocalizationKey.BioacousticsManagerBody]:
      "Ajoutez des capteurs Nature à votre programme, et ce widget s'animera avec l'activité en direct des pollinisateurs et des oiseaux sur votre site",
    [MyHiveLocalizationKey.BioacousticsTenantCta]: 'Voir un exemple en direct →',
    [MyHiveLocalizationKey.BioacousticsManagerCta]: 'Voir un exemple en direct →',
    [MyHiveLocalizationKey.BioacousticsPollinators]: 'Pollinisateurs',
    [MyHiveLocalizationKey.BioacousticsLive]: 'Live',
    [MyHiveLocalizationKey.BioacousticsLast14Days]: '14 derniers jours',
    [MyHiveLocalizationKey.BioacousticsSelected]: 'Sélectionné',
    [MyHiveLocalizationKey.BioacousticsMostRecent]: 'Plus récent',
    [MyHiveLocalizationKey.BioacousticsActivity]: 'Activité',
    [MyHiveLocalizationKey.BioacousticsDetectionsPerHour]: 'détections par heure',
    [MyHiveLocalizationKey.BioacousticsRangeOverPeriod]: 'Plage sur la période',
    [MyHiveLocalizationKey.BioacousticsDiversityScore]: 'Score de diversité des pollinisateurs',
    [MyHiveLocalizationKey.BioacousticsDiversityScoreDescription]:
      'Le nombre effectif de groupes de fréquences de pollinisateurs sur ce site, calculé à partir de la part de chaque fréquence dans le total des détections. Un site dominé par une seule fréquence obtient un score faible ; un mélange équilibré obtient un score élevé.',
    [MyHiveLocalizationKey.BioacousticsDiversityScoreFootnote]:
      "Moyenne sur 7 jours. Les groupes sont des signatures acoustiques, pas des identifications d'espèces.",
    [MyHiveLocalizationKey.BioacousticsVsPrevious7Days]: 'vs précédent · 7 jours',
    [MyHiveLocalizationKey.BioacousticsPollinatorBreakdownLink]: 'Détail complet des pollinisateurs ci-dessous →',
    [MyHiveLocalizationKey.BioacousticsBirds]: 'Oiseaux',
    [MyHiveLocalizationKey.BioacousticsAllTime]: 'Depuis toujours',
    [MyHiveLocalizationKey.BioacousticsUniqueBirdSpecies]: "Espèces d'oiseaux uniques",
    [MyHiveLocalizationKey.BioacousticsTotalDetections]: 'Détections totales',
    [MyHiveLocalizationKey.BioacousticsMostHeard]: 'Les plus entendus',
    [MyHiveLocalizationKey.BioacousticsDetections]: 'détections',
    [MyHiveLocalizationKey.BioacousticsLastSeen]: 'vu pour la dernière fois',
    [MyHiveLocalizationKey.BioacousticsNoBirdData]: "Aucune donnée d'oiseaux pour l'instant",
    [MyHiveLocalizationKey.BioacousticsDawnChorusLink]: "Chœur de l'aube complet ci-dessous →",
    [MyHiveLocalizationKey.BioacousticsWhenBuzzPeaks]: 'Quand le bourdonnement atteint son pic',
    [MyHiveLocalizationKey.BioacousticsAverageDayAllTime]: 'jour moyen · depuis toujours',
    [MyHiveLocalizationKey.BioacousticsListenToRecentDetections]: 'Écouter les détections récentes',
    [MyHiveLocalizationKey.BioacousticsNoBuzzDetections]: "Aucune détection de bourdonnement pour l'instant",
    [MyHiveLocalizationKey.BioacousticsDawnChorus]: "Le chœur de l'aube",
    [MyHiveLocalizationKey.BioacousticsWhenBirdsSingAllTime]: 'quand les oiseaux chantent · depuis toujours',
    [MyHiveLocalizationKey.BioacousticsByTheNumbers]: 'En chiffres',
    [MyHiveLocalizationKey.BioacousticsBirdDiversityScore]: 'Score de diversité des oiseaux',
    [MyHiveLocalizationKey.BioacousticsBirdDiversityScoreDescription]:
      "Le nombre effectif d'espèces d'oiseaux sur ce site, calculé à partir de la part de chaque espèce dans le total des détections. Un site dominé par une seule espèce obtient un score faible ; une répartition équilibrée entre plusieurs espèces obtient un score élevé.",
    [MyHiveLocalizationKey.BioacousticsEffectiveSpeciesFromAllDetections]:
      'espèces effectives parmi toutes les détections',
    [MyHiveLocalizationKey.BioacousticsPeakWindowBetween]: 'Fenêtre de pic entre',
    [MyHiveLocalizationKey.BioacousticsSongPeaksBetween]: 'Chant vocal entre',
    [MyHiveLocalizationKey.BioacousticsAnd]: 'et',
    [MyHiveLocalizationKey.BioacousticsVariety]: 'Variété',
    [MyHiveLocalizationKey.BioacousticsUniqueFrequencies]: 'Fréquences uniques',
    [MyHiveLocalizationKey.BioacousticsWeather]: 'Météo',

    // BioacousticsPage public page keys
    [MyHiveLocalizationKey.BioacousticsPageHeroTitleSamplePre]:
      'Données de biodiversité en direct depuis un immeuble de bureaux à ',
    [MyHiveLocalizationKey.BioacousticsPageHeroTitleSampleCity]: 'New York City',
    [MyHiveLocalizationKey.BioacousticsPageHeroTitleLivePre]: 'Données de biodiversité en direct depuis ',
    [MyHiveLocalizationKey.BioacousticsPageHeroDescription]:
      "Les oiseaux, les pollinisateurs et d'autres espèces bénéfiques vivent dans et autour de chaque immeuble. Explorez les données de biodiversité à l'échelle de l'actif que cet immeuble partage avec les locataires et les investisseurs sensibles à la nature.",
    [MyHiveLocalizationKey.BioacousticsPageAlignedWith]: 'Aligné avec',
    [MyHiveLocalizationKey.BioacousticsPageWhereTitle]: 'Où cela se passe.',
    [MyHiveLocalizationKey.BioacousticsPageWhereDescription]:
      "Chaque donnée ici provient d'un seul site, et le territoire environnant influence ce que les capteurs détectent.",
    [MyHiveLocalizationKey.BioacousticsPageLandCoverLabel]: 'couverture du sol',
    [MyHiveLocalizationKey.BioacousticsPageLandCoverNatural]: 'Naturel',
    [MyHiveLocalizationKey.BioacousticsPageLandCoverAgricultural]: 'Agricole',
    [MyHiveLocalizationKey.BioacousticsPageLandCoverArtificial]: 'Artificiel',
    [MyHiveLocalizationKey.BioacousticsPageLandCoverWater]: 'Eau',
    [MyHiveLocalizationKey.BioacousticsPagePollinatorsDescription]:
      "Chaque battement d'aile porte une signature fréquentielle. Nous regroupons ces signatures pour estimer combien de groupes distincts sont présents et à quel point le site est actif.",
    [MyHiveLocalizationKey.BioacousticsPageBirdsDescription]:
      "Les oiseaux racontent une histoire plus lente et plus large, leur chant atteignant son apogée au printemps avec le territoire et la parade nuptiale. Le chœur de l'aube au premier jour est l'un des enregistrements les plus écoutés en écologie.",
    [MyHiveLocalizationKey.BioacousticsPageDawnChorusDescPre]: 'Le ',
    [MyHiveLocalizationKey.BioacousticsPageDawnChorusDescEmphasis]: "chœur de l'aube",
    [MyHiveLocalizationKey.BioacousticsPageDawnChorusDescPost]:
      " est la vague de chants qui s'élève aux premières lueurs du jour. Son timing et sa richesse en disent long sur la communauté d'oiseaux d'un site.",
    [MyHiveLocalizationKey.BioacousticsPageUniqueSpecies]: 'Espèces uniques',
    [MyHiveLocalizationKey.BioacousticsPageBirdSensorNotActive]: "Capteur d'oiseaux inactif",
    [MyHiveLocalizationKey.BioacousticsPageBirdSensorDescription]:
      "Ajoutez un capteur d'oiseaux à votre site pour débloquer le suivi des espèces, les scores de diversité et les données du chœur de l'aube.",
    [MyHiveLocalizationKey.BioacousticsPageUpsellTitlePre]: 'Imaginez ces données de biodiversité',
    [MyHiveLocalizationKey.BioacousticsPageUpsellTitleMid]: 'pour ',
    [MyHiveLocalizationKey.BioacousticsPageUpsellTitleYour]: 'votre',
    [MyHiveLocalizationKey.BioacousticsPageUpsellTitlePost]: ' actif.',
    [MyHiveLocalizationKey.BioacousticsPageUpsellDescription]:
      "Un capteur nature capte des données de biodiversité sur site, les analyse avec l'IA, et génère des rapports prêts pour les investisseurs et les locataires.",
    [MyHiveLocalizationKey.BioacousticsPageSensorName]: 'Le capteur nature',
    [MyHiveLocalizationKey.BioacousticsPageSensorDescription]:
      "Une unité bioacoustique passive qui mesure l'activité des pollinisateurs et les espèces d'oiseaux, 24h/24.",
    [MyHiveLocalizationKey.BioacousticsPageTheProblem]: 'Le problème',
    [MyHiveLocalizationKey.BioacousticsPageProblemDescPre]: 'Le GRESB RM7, le TNFD et la diligence raisonnable des LP',
    [MyHiveLocalizationKey.BioacousticsPageProblemDescPost]:
      " exigent désormais des données de biodiversité au niveau de l'actif pour les divulgations. La plupart des gestionnaires se présentent avec des photos plutôt que des données.",
    [MyHiveLocalizationKey.BioacousticsPageTheSolution]: 'La solution',
    [MyHiveLocalizationKey.BioacousticsPageSolutionDescription]:
      "Le capteur nature fonctionne 24h/24, diffusant des données de biodiversité en temps réel analysées par nos modèles d'IA et automatiquement intégrées dans des rapports préformatés pour GRESB, TNFD, CSRD ou BREEAM.",
    [MyHiveLocalizationKey.BioacousticsPageThreeWaysTitle]: 'Trois façons dont cela paie',
    [MyHiveLocalizationKey.BioacousticsPageThreeWaysOnePlatformTitle]:
      'Une plateforme pour piloter votre stratégie de biodiversité',
    [MyHiveLocalizationKey.BioacousticsPageThreeWaysOnePlatformBody]:
      'Les données de cet immeuble alimentent notre plateforme Aura Nature Risk, vous guidant des données brutes vers une stratégie actionnable.',
    [MyHiveLocalizationKey.BioacousticsPageThreeWaysOnlyDataTitle]: 'Seulement les données qui comptent',
    [MyHiveLocalizationKey.BioacousticsPageThreeWaysOnlyDataBody]:
      "Vous obtenez exactement les indicateurs que l'industrie valorise pour l'immobilier, présentés en langage clair, sans le bruit.",
    [MyHiveLocalizationKey.BioacousticsPageThreeWaysDDQsTitle]: 'Conçu avec les DDQ en tête',
    [MyHiveLocalizationKey.BioacousticsPageThreeWaysDDQsBody]:
      'Vos données arrivent déjà alignées sur GRESB, TNFD et CSRD, ce qui rend les divulgations et les questionnaires de diligence raisonnable faciles à remplir.',
    [MyHiveLocalizationKey.BioacousticsPageAsFeaturedIn]: 'Comme présenté dans',
    [MyHiveLocalizationKey.BioacousticsPageDeployedAtPre]: 'Déjà déployé chez ',
    [MyHiveLocalizationKey.BioacousticsPageDeployedAtBrand]: 'des marques immobilières mondiales de premier plan',
    [MyHiveLocalizationKey.BioacousticsPagePerYearPerProperty]: '/ an par propriété',
    [MyHiveLocalizationKey.BioacousticsPagePricingNote]:
      "Aucun frais d'installation. Aucun minimum de sites. Opérationnel en deux semaines.",
    [MyHiveLocalizationKey.BioacousticsPageWhatsIncluded]: 'Ce qui est inclus',
    [MyHiveLocalizationKey.BioacousticsPageIncluded1]: '2 capteurs nature + installation',
    [MyHiveLocalizationKey.BioacousticsPageIncluded2]: 'Flux de données en temps réel dans votre tableau de bord',
    [MyHiveLocalizationKey.BioacousticsPageIncluded3]: 'Données en direct accessibles aux locataires',
    [MyHiveLocalizationKey.BioacousticsPageIncluded4]: 'Rapport annuel de biodiversité (GRESB RM7 + TNFD)',
    [MyHiveLocalizationKey.BioacousticsPageFreeScreeningTitle]:
      'Voyez comment votre actif se positionne avec un bilan nature gratuit.',
    [MyHiveLocalizationKey.BioacousticsPageTryItFree]: 'Essayez gratuitement',
    [MyHiveLocalizationKey.BioacousticsChartToday]: "Aujourd'hui",
    [MyHiveLocalizationKey.BioacousticsChartYesterday]: 'Hier',
    [MyHiveLocalizationKey.BioacousticsChart1WkAgo]: 'il y a 1 sem.',
    [MyHiveLocalizationKey.BioacousticsChart2WksAgo]: 'il y a 2 sem.',
    [MyHiveLocalizationKey.BioacousticsChartMidnight]: 'MINUIT',
    [MyHiveLocalizationKey.BioacousticsChartNoon]: 'MIDI',
    [MyHiveLocalizationKey.BioacousticsChart6AM]: '6 H',
    [MyHiveLocalizationKey.BioacousticsChart6PM]: '18 H',
    [MyHiveLocalizationKey.AuraNatureAroundBuilding]: 'La nature autour de votre immeuble',
    [MyHiveLocalizationKey.AuraPoweredBy]: 'Propulsé par Aura',
    [MyHiveLocalizationKey.AuraLandCover]: 'Couverture du sol',
    [MyHiveLocalizationKey.AuraWithin500m]: 'Dans un rayon de 500 m',
    [MyHiveLocalizationKey.AuraSeeFullPicture]: 'Voir le portrait complet dans Aura',
    [MyHiveLocalizationKey.AuraLandCoverAgricultural]: 'Agricole',
    [MyHiveLocalizationKey.AuraLandCoverArtificial]: 'Artificiel',
    [MyHiveLocalizationKey.AuraLandCoverNatural]: 'Naturel',
    [MyHiveLocalizationKey.AuraLandCoverWater]: 'Eau',
    [MyHiveLocalizationKey.AuraDescription]:
      "Aura est la plateforme nature d'Alvéole. Elle mesure la biodiversité de l'ensemble de votre site, bien au-delà des abeilles.",
    [MyHiveLocalizationKey.AuraExploreSpecies]:
      "Explorez les espèces, l'habitat et le risque naturel pour cette adresse. Gratuit, s'ouvre dans un nouvel onglet.",

    [MyHiveLocalizationKey.EdnaCardTitle]: 'ADN environnemental du miel',
    [MyHiveLocalizationKey.EdnaCardUniquePlants]: 'espèces de plantes uniques détectées',
    [MyHiveLocalizationKey.EdnaCardDescription]:
      "Le miel de la ruche de votre immeuble a été analysé pour son ADN végétal, révélant un registre des types de plantes que vos abeilles ont butinées au cours de l'année.",
    [MyHiveLocalizationKey.EdnaCardEveryPlantDetected]: 'Toutes les plantes détectées',
    [MyHiveLocalizationKey.EdnaCardTenantHeading]: "Qu'est-ce qui pousse près de vous ?",
    [MyHiveLocalizationKey.EdnaCardTenantBody]:
      "Le miel de votre immeuble contient un registre de chaque plante que les abeilles ont visitée — extrait directement de l'ADN.",
    [MyHiveLocalizationKey.EdnaCardManagerHeading]: 'Découvrez ce qui pousse autour de votre immeuble',
    [MyHiveLocalizationKey.EdnaCardManagerBody]:
      "Le miel de votre ruche contient l'ADN de chaque plante visitée par vos abeilles. Ajoutez une analyse eDNA pour révéler le paysage vivant autour de votre site et obtenir des données sur la biodiversité pour TNFD, GRESB et CSRD.",
    [MyHiveLocalizationKey.EdnaCardSeeSampleData]: 'Voir un exemple de données',

    [MyHiveLocalizationKey.EdnaGrowthTreesShrubs]: 'Arbres et arbustes',
    [MyHiveLocalizationKey.EdnaGrowthWildflowers]: 'Fleurs sauvages',
    [MyHiveLocalizationKey.EdnaGrowthVinesGrasses]: 'Vignes et graminées',
    [MyHiveLocalizationKey.EdnaGrowthMixed]: 'Mixte et non précisé',
    [MyHiveLocalizationKey.EdnaGrowthPctOfGroups]: '% des groupes de plantes',
    [MyHiveLocalizationKey.EdnaGrowthKindsByForm]: 'espèces, par\nforme de croissance',

    [MyHiveLocalizationKey.ShareWithTenantsTitle]: 'Partager avec les locataires',
    [MyHiveLocalizationKey.ShareWithTenantsSubheader]:
      'Stimulez l’engagement — partagez votre page Alvéole avec votre réseau de locataires pour que tout le monde puisse voir la ruche, participer aux événements et réclamer du miel.',
    [MyHiveLocalizationKey.InviteByEmailTab]: 'Inviter par courriel',
    [MyHiveLocalizationKey.ShareALinkTab]: 'Partager un lien',
    [MyHiveLocalizationKey.QRCodeTab]: 'Code QR',
    [MyHiveLocalizationKey.ShareableLink]: 'Lien partageable',
    [MyHiveLocalizationKey.ShareableLinkHint]:
      'Partagez-le n’importe où — infolettre, courriel, application de l’immeuble. Toute personne ayant le lien peut suivre la page.',
    [MyHiveLocalizationKey.MakeItYours]: 'Personnalisez-le',
    [MyHiveLocalizationKey.MakeItYoursHint]:
      'Donnez à la page un nom et un lien que votre communauté reconnaîtra et retiendra.',
    [MyHiveLocalizationKey.PageNameLabel]: 'Nom de la page',
    [MyHiveLocalizationKey.PageNameExampleHint]: 'p. ex. The Bees at Smith Tower, Maple Court Hive.',
    [MyHiveLocalizationKey.PageLinkLabel]: 'Lien de la page',
    [MyHiveLocalizationKey.PageLinkExampleHint]: 'p. ex. maple-court, 412-king-st.',
    [MyHiveLocalizationKey.QRScanHeading]: 'Un scan ouvre votre page',
    [MyHiveLocalizationKey.QRScanHint]: 'Aucune saisie, aucune connexion requise pour suivre.',
    [MyHiveLocalizationKey.DownloadQRCode]: 'Télécharger le code QR',
    [MyHiveLocalizationKey.SavedConfirmation]: 'Enregistré',

    [MyHiveLocalizationKey.ErrorPageGenericTitle]: "Une erreur s'est produite",
    [MyHiveLocalizationKey.ErrorPageGenericBody]:
      'Veuillez réessayer. Si le problème persiste, communiquez avec notre équipe de soutien.',
    [MyHiveLocalizationKey.ErrorPageLoadUserTitle]: 'Un problème est survenu avec votre compte',
    [MyHiveLocalizationKey.ErrorPageLoadUserBody]:
      "Nous n'avons pas pu charger votre compte. Veuillez réessayer ou contactez le soutien si le problème persiste.",
    [MyHiveLocalizationKey.ErrorPageHoneyLabelTitle]: 'Votre étiquette de miel arrive bientôt',
    [MyHiveLocalizationKey.ErrorPageHoneyLabelBody]:
      "L'accès à votre étiquette de miel sera bientôt disponible. Une question d'ici là ? Écrivez-nous.",
    [MyHiveLocalizationKey.ErrorPageNotFoundTitle]: 'Page introuvable',
    [MyHiveLocalizationKey.ErrorPageNotFoundBody]:
      "Nous n'avons pas trouvé la page que vous cherchez. Vérifiez le lien ou contactez le soutien.",
    [MyHiveLocalizationKey.ErrorPageNoAccessTitle]: "Vous n'avez pas accès à cette page",
    [MyHiveLocalizationKey.ErrorPageNoAccessAuthed]:
      "Votre compte n'a pas accès à cette page. Demandez à un collègue qui gère cette ruche de vous accorder l'accès, ou contactez le soutien pour en faire la demande.",
    [MyHiveLocalizationKey.ErrorPageNoAccessGuest]: 'Redirection vers la page de connexion…',
    [MyHiveLocalizationKey.ErrorPageContactSupport]: 'Contacter le soutien',
    [MyHiveLocalizationKey.ErrorPageSupportUrl]: 'https://support.alveole.buzz/hc/fr',
  },
};
